<template>
  <div>
    <div class="model" v-if="upload_loader">
      <span class="loader"></span>
      <span>Loading...........</span>
    </div>
    <toast-message
      :message="errmsg"
      type="error"
      :isToastEnable="toast"
      @close="(val) => (toast = val)"
    />
    <div class="main-container" v-if="ifEmployee ||  ifClientAdmin">
      <div style="display: flex; flex-direction:column">
        <tl-header type="h1">Income Tax Proof Submission</tl-header>
        <div v-show="enableRegimeChange && incomeTaxProofSubmittedFlag">
             <div >
              <span class="label">Select Regime</span>
            </div>
            <div style="display:flex; align-items: center; gap: 20px;">
              <tl-radio
                label="Old Regime"
                name="uploadType"
                id="oldregime"
                value="oldregime"
                v-model="uploadMethod"
              />
              <tl-radio
                label="New Regime"
                name="uploadType"
                id="newregime"
                value="newregime"
                v-model="uploadMethod"
              />
              <div style="background: linear-gradient(135deg, #e3f2fd, #f3e5f5); border: 1px solid #2196f3; border-radius: 8px; padding: 8px 12px; margin-left: 20px; font-size: 16px; color: #1565c0; box-shadow: 0 2px 4px rgba(33, 150, 243, 0.1); display: flex; align-items: center; gap: 6px; min-width: 900px; max-width: 1000px;">
                <span style="font-weight: 600; color: #1976d2;">💡 Note:</span>
                <span>Payroll deductions are automatically exempted — employees need not declare them.</span>
              </div>
            </div>
        </div>
      </div>
      <pop-up-window-lg
        v-if="form12BB_pop_up"
        @back="form12BB_pop_up = !form12BB_pop_up;toast=false"
        header="Upload Form 12BB"
      >
        <template v-slot:content>
          <pop-up-message
      v-if="showDeleteConfirmation"
      message="Please review the entire document carefully before submission. This will be final and cannot be altered after submission."
      :popupType="'Warning'"
      :popupHeaderMessage="'Confirm Submit'"
      @back="backFromPopup"
    >
      <template v-slot:bottomContent>
        <div class="popup-btn-group">
          <button class="btn-popup-secondary" type="button" @click="showDeleteConfirmation = !showDeleteConfirmation">cancel</button>
          <button class="btn-popup" type="button" @click="it_proof_submission('final_submit')">Final Submit</button>
        </div>
      </template>
    </pop-up-message>
          <div class="BBmain">
            <div class="BBtop">
              <div style="padding-top:5px">
                  <div style="font-size:small;font-weight:400;padding:0px">
                    <p>I hereby declare that the information provided is true in all respects and
                       to the best of my knowledge and belief.  I am aware that the company is 
                       considering the above self attested copies of proofs/documents provided by 
                       me in utmost good faith and trust for the purpose of calculating my TDS.</p>
                       <p>Therefore, it would be binding on me to keep the said documents under 
                        my safe custody and produce a part or all the original documents to the Company 
                        or Income tax Authorities whenever the same is requisitioned for.  
                        I am also aware that I alone would be liable for any consequences/action as 
                        per the rules of the company if the above mentioned is found to be devoid of
                       the truth and/or in case of my failure 
                        to produce the requisitioned documents within the time/ period given to me. 
                    </p>
                  </div>
                
                   <div style="display: flex; gap: 30px; margin: 40px">
                  <input style="transform: scale(2.5)" type="checkbox" @click="(val)=>{
                  checkBoxFlag = !checkBoxFlag
                  }" />
                  <p style="font-size: medium">
                    I agree and confirm the above declaration
                  </p>
                   </div>
                </div>
              <div style="display:flex; gap:64rem">
                <p style="font-weight: 600; padding-top: 10px">
                  Digitally sign your form 12BB below
                </p>
                <btn :disabled="checkBoxFlag" style="font-size:medium" text="Download 12BB" type="secondary" @click="download12BBUrl(BB_12_url)" />
              </div>
              <div style="display: flex; flex-direction: column">
                <div
                  style="
                    display: flex;
                    justify-content: space-between;
                    margin: 40px;
                  "
                >
                  <div>
                    <p style="font-weight: 600; font-size: large">{{ promiseIP?promiseIP:"103.139.159.242"}}</p>
                    <p style="font-weight: 500; font-size: large">Ip Address</p>
                  </div>
                  <div>
                    <p style="font-weight: 600; font-size: large">
                      {{ form12BBDate }}
                    </p>
                    <p style="font-weight: 500; font-size: large">
                      Date & Time
                    </p>
                  </div>
                  <div>
                    <p style="font-weight: 600; font-size: large">{{ employeeName }}</p>
                    <p style="font-weight: 500; font-size: large">Name</p>
                  </div>
                  <div>
                    <btn
                      :disabled="checkBoxFlag"
                      style="font-size:medium"
                      text="Sign Digitally"
                      type="primary"
                      @click="()=>digitalySign()"
                    />
                  </div>
                </div>
              </div>
              <div></div>
            </div>
            <div v-if="!['dfba4011-0c5e-46cc-b4f4-99f5962f9ebe', 'ac40f8c0-8ccb-46c3-aa7c-7958dc8014f0'].includes(le_id)"  class="BBbottom">
              <p style="font-weight: 600; padding-top: 10px">
                Download your form 12BB sign it and upload the scanned copy
                below
              </p>
              <div class="upload">
                <p>Upload files here</p>
                <div class="upload-button">
                  <!-- <img src="@/assets/logout-copy-2_2@2x.png" alt /> -->
                  <label :disabled="checkBoxFlag" for="upload-photo">Browse</label>
                  <input type="file" name="photo" id="upload-photo" @change="upload12BBmanual(
                    $event.target.files,
                  )" />
                </div>
              </div>
            </div>
          </div>
        </template>
        <template v-slot:bottom>
          <footer>
            <popup-bottom-container>
              <template slot="end">
                <btn-grp class="form-button">
                  <btn
                  v-show="incomeTaxProofSubmittedFlag && !checkBoxFlag"
                  :disabled="finalSubmitButton"
                  text="Submit"
                    type="primary"
                    @click="showConfirmMessageFunction()"
                  />
                </btn-grp>
              </template>
            </popup-bottom-container>
          </footer>
        </template>
      </pop-up-window-lg>
      <div  class="section-container">
        <div
          class="pl-0 cursor-point"
          @click="showPopupFamilyDetaila = !showPopupFamilyDetaila;toast=false"
        >
          <div class="row col-bg-gray">
            <div class="col-3 img-block">
              <img src="@/assets/home_rent_declartion.svg" />
            </div>
            <div class="col-7 img-block">
              <div class="heading-text">
                <Section>Family Details</Section>
              </div>
              <div class="sub-heading-details-sm">
                Please enter your family details
              </div>
            </div>
            <div class="col-2 arrow-left-align">
              <img class="arrow-icon-it" src="@/assets/arrow_purple_new.svg" />
            </div>
          </div>
        </div>
        <pop-up-window-lg
          v-if="showPopupFamilyDetaila"
          @back="showPopupFamilyDetaila = !showPopupFamilyDetaila;toast=false;getItSubmissionData();"
          header="Family Details"
        >
          <template v-slot:content>
            <toast-message
              :message="errmsg"
              type="error"
              :isToastEnable="toast"
              @close="(val) => (toast = val)"
            />
            <div style="display: flex; flex-direction: column">
              <p style="font-size: large; font-weight: 600">
                Number of children, Self and Family Details.
              </p>

              <div :disabled="finalizedSubmitFlag" style="display: flex; gap: 10rem; padding: 30px">
                <div style="width: 50rem">
                  <label style="font-weight: 500" for="no_of_school_Childrens"
                    >No of Children*</label
                  >
                  <txt
                    type="number"
                    name="No_Children"
                    placeholder="enter no of children"
                    v-validate="'required'"
                    :classname="errors.has('No_Children')"
                    :errormsg="errors.first('No_Children')"
                    @change="
                      (val) => {
                        
                            employeeFamilyDetails[0].no_of_children = val;
                        childValidation()
                        
                        
                      }
                    "
                    v-model="employeeFamilyDetails[0].no_of_children"
                  />
                </div>
                <div style="width: 50rem">
                  <label style="font-weight: 500" for="no_of_school_Childrens"
                    >No of School Going Children*</label
                  >
                  <txt
                    type="number"
                    :disable="employeeFamilyDetails[0].no_of_children<=0"
                    placeholder="enter no of school childrens"
                    @change="
                      (val) => {
                        
                           employeeFamilyDetails[0].no_of_school_children =
                          val ||0
                          childValidation()
                        
                       
                      }
                    "
                    v-model="employeeFamilyDetails[0].no_of_school_children "
                  />
                </div>
                <div style="width: 50rem">
                  <label style="font-weight: 500" for="no_of_hostel_Childrens"
                    >No of Hostel Staying Children*</label
                  >
                  <txt
                    type="number"
                   :disable="employeeFamilyDetails[0].no_of_children<=0"
                    placeholder="enter no of hostel childrens"
                    @change="
                      (val) => {
                        
                          employeeFamilyDetails[0].no_of_hostel_children =
                          val ||0;
                          childValidation()
                        
                        
                      }
                    "
                    v-model="employeeFamilyDetails[0].no_of_hostel_children"
                  />
                </div>
              </div>
            </div>
            <itProof-submit-dataTable
               :disabled="!incomeTaxProofSubmittedFlag ||(releaseForEmployees||dateCheck==false)"
              :tableColumsHeader="family_details_table_colums_header"
              :tableColumnsData="employeeFamilyDetails[0].details"
            >
              <template v-slot="slotprops">
                <div v-if="!slotprops.value.record.isDelete">
                  <txt
                    v-if="slotprops.value.column.key == 'particulars'"
                    :disabled = "slotprops.value.index == 0"
                    style="width: 12rem"
                    type="alphabet"
                    @Change="
                      (value) => {
                        slotprops.value.record.name = value;
                      }
                    "
                    v-model="slotprops.value.record.name"
                  >
                  </txt>
                  <tl-select
                    v-if="slotprops.value.column.key == 'relationship'"
                    :disabled = "slotprops.value.index == 0"
                    name="relationship"
                    :options="options_for_relationship"
                    placeholder="Select"
                    v-model="slotprops.value.record.relationship"
                    @change="
                      (val) => {
                        slotprops.value.record.relationship = val;
                        checkRelationship(val);
                      }
                    "
                  />

                  <date-picker
                    v-if="slotprops.value.column.key == 'dob'"
                    :disabled = "slotprops.value.index == 0"
                    :name="`${slotprops.value.index}dob`"
                    data-vv-as="from date"
                    @datevalue="
                      (val) => {
                        slotprops.value.record.dob = val;
                        calculateAge(val, slotprops.value.index);
                      }
                    "
                     :dates-disabled="{
                        
                        from: new Date(),
                      }"
                    v-validate="{ required: true }"
                    :classname="errors.has(`${slotprops.value.index}dob`)"
                    errormsg="DOB is Mandatory"
                    v-model="slotprops.value.record.dob"
                  />

                  <txt
                    v-if="slotprops.value.column.key == 'age'"
                    style="width: 14rem"
                    type="text"
                    @Change="
                      (value) => {
                        slotprops.value.record.dob = value;
                      }
                    "
                    :disabled="true"
                    v-model="slotprops.value.record.age"
                  >
                  </txt>
                  <button
                    class="delete-btn"
                    v-if="
                      slotprops.value.column.key == 'delete' &&
                      slotprops.value.index > 0
                    "
                    @click="
                      () => {
                        deleteRow(
                          'family_details',
                          slotprops.value.index,
                          slotprops.value.record.relationship
                        );
                      }
                    "
                  >
                    Delete
                  </button>
                </div>
              </template>
            </itProof-submit-dataTable>
            <div class="row margin-t-m margin-b-l">
              <div class="col-12">
                <div
                  class="row-container"
                  :disabled = "finalizedSubmitFlag"
                  style="display: flex; justify-content: right"
                >
                  <img src="@/assets/group-5.svg" class="Group-5" />
                  <button
                    class="text-green"
                    @click="addMoreRow('family_details')"
                  >
                    Add More Family Details
                  </button>
                </div>
              </div>
            </div>
          </template>
          <template v-slot:bottom>
            <footer>
              <popup-bottom-container>
                <template>
                  <div style="display: flex; flex-direction: column">
                    <p style="font-size: large; font-weight: 700">
                      General Remarks
                    </p>
                    <p>
                      IncomeTax proof Submission window will be closing soon
                    </p>
                  </div>
                </template>
                <template slot="end">
                  <btn-grp class="form-button">
                    <btn
                      text="Cancel"
                      type="secondary"
                      @click="showPopupFamilyDetaila = !showPopupFamilyDetaila;toast=false;getItSubmissionData()"
                    />
                    <btn
                    
                    v-show="incomeTaxProofSubmittedFlag"
                    :disabled="!incomeTaxProofSubmittedFlag ||(releaseForEmployees||dateCheck==false)"
                      text="Save as Draft"
                      type="primary"
                      @click="saveDataForFinalArray('employee_family_details')"
                    />
                  </btn-grp>
                </template>
              </popup-bottom-container>
            </footer>
          </template>
        </pop-up-window-lg>
        <div
          v-show="regime_type || (!regime_type && enableSection10ForNewRegime)"
          :disabled="!clientCodeBoolen"
          class="pr-0 cursor-point"
          @click="
            showPopupExemptionUnderSectionDeduction =
              !showPopupExemptionUnderSectionDeduction;toast=false
          "
        >
          <div class="row col-bg-gray">
            <div class="col-3 img-block">
              <img src="@/assets/home_rent_declartion.svg" />
            </div>
            <div class="col-7 img-block">
              <div class="heading-text">
                <Section>Sec 10 Exemption</Section>
              </div>
              <div class="sub-heading-details-sm">
                provides exemption only in respect of tax on non- monetary
                perquisites
              </div>
            </div>
            <div class="col-2 arrow-left-align">
              <img class="arrow-icon-it" src="@/assets/arrow_purple_new.svg" />
            </div>
          </div>
        </div>
        <pop-up-window-lg
          v-if="showPopupExemptionUnderSectionDeduction"
          @back="
            showPopupExemptionUnderSectionDeduction =
              !showPopupExemptionUnderSectionDeduction;toast=false;getItSubmissionData();
          "
          header="Sec 10 Exemption"
        >
        <template v-slot:header>
        <div style="display: inline-block; position: relative; margin-left: 5px;height: 19px; width: 19px; ">
          <img
            style="cursor: pointer; margin-left: 5px; vertical-align: middle;height: 19px; width: 19px;"
            src="@/assets/info-black.svg"
            @click = "showSec10TooltipPopup = true"    
          />
        </div>
        </template>
          <template v-slot:content>
            <toast-message
      :message="errmsg"
      type="error"
      :isToastEnable="toast"
      @close="(val) => (toast = val)"
    />
    <pop-up-message popupHeaderMessage="Section 10" v-if="showSec10TooltipPopup" :message="'Qualified Amount: No Limit'" :popupType="'Success'">
      <template v-slot:bottomContent>
        <div
          style="display: flex;margin-bottom: 20px; flex-direction: column; align-items: flex-start;">
          <div style="display: flex; gap: 20px;">
          <ul>
            <p style="font-size: 16px">Exemption depends on the actual Bill/Expense Proof submitted</p>
          </ul>
          </div>
          
        </div>
        <div class="popup-btn-group" style="display: flex; justify-content: flex-end; margin-top: 20px;" >
          <button class="btn-popup-cancel" type="button" @click="showSec10TooltipPopup = !showSec10TooltipPopup">
            <b>OK</b>
          </button>
          <!-- <button class="btn-popup" type="button" @click="showPopupHouseRentDeclaration = !showPopupHouseRentDeclaration,showHraTooltipPopup = !showHraTooltipPopup">
            <b>Agree</b>
          </button> -->
        </div>
      </template>
      </pop-up-message>
            <itProof-submit-dataTable
              :disabled="!incomeTaxProofSubmittedFlag ||(releaseForEmployees||dateCheck==false)"
              :tableColumsHeader="sec_ten_exemption_table_colums_header"
              :tableColumnsData="sec_ten_exemption_table_columns_data"
            >
              <template v-slot="slotprops">
                <div :disabled="slotprops.value.record.status == 'Approved'">
                <span :disabled="slotprops.value.record.status=='Approved' || finalizedSubmitFlag"
                  style="display: flex; gap: 20px"
                  v-if="slotprops.value.column.key == 'particulars'"
                >
                  <span style="width: 12rem">{{
                    slotprops.value.record.name||slotprops.value.record["InvestmentComponentType.name"]
                  }}</span>
                  <!-- <img
                    style="cursor: pointer"
                   :title="getTitleSec10(slotprops.value.record)"
                    src="@/assets/info-black.svg"
                  /> -->
                </span>
                <span
                  style="width: 10rem"
                  v-if="slotprops.value.column.key == 'declaredAmount'"
                  :disabled = "finalizedSubmitFlag"
                >
                  {{ slotprops.value.record.planned }}
                </span>
                <txt
                  v-if="slotprops.value.column.key == 'submittedAmount'"
                  @blur="uploadValidation('section_ten_exemption')"
                  :disabled = "finalizedSubmitFlag"
                  style="width: 14rem;"
                 
                  type="number"
                  @Change="
                    (value) => {
                      slotprops.value.record.actual = value;
                    }
                  "
                  v-model="slotprops.value.record.actual"
                >
                </txt>
                <p v-if="slotprops.value.column.key == 'submittedAmount' && slotprops.value.record.file_location && !slotprops.value.record.actual" style="font-size:x-small;color:red;">Field is mandatory</p>
                <span
                 :disabled = "finalizedSubmitFlag"
                  style="width: 7rem"
                  v-if="slotprops.value.column.key == 'verifiedAmount'"
                >
                  {{ slotprops.value.record.approved }}
                </span>
                <button
                  style="width: 12rem; background-color: #e3c449"
                  @click="
                    show_pop_up(
                      slotprops.value.record,
                      'section_ten_exemption',
                      slotprops.value.index
                    )
                  "
                  v-if="
                    slotprops.value.column.key == 'proof' &&
                    slotprops.value.record.file_location
                  "
                  class="export-button"
                >
                  <img src="@/assets/clip.svg" />
                  <label style="cursor: pointer">View Attachment</label>
                </button>
                
                <button
                  style="width: 12rem; cursor: default"
                  v-if="
                    slotprops.value.column.key == 'proof' &&
                    !slotprops.value.record.file_location
                  "
                  :disabled="!slotprops.value.record.actual || finalizedSubmitFlag"
                  class="export-button"
                >
                  <label
                    class="input-label"
                    :for="`file-input${slotprops.value.index}`"
                  >
                    <img src="@/assets/clip.svg" />
                    <p>Attachment</p>
                  </label>
                  <!-- <img src="@/assets/clip.svg" />
                  <p>Attachment</p> -->
                  <input
                    style="opacity: 0"
                    type="file"
                    :id="`file-input${slotprops.value.index}`"
                    name="attachment"
                    @change="
                      uploadAttachments(
                        $event.target.files,
                        slotprops,
                        slotprops.value.index,
                        'section_ten_exemption'
                      )
                    "
                  />
                </button>
                <p v-if="slotprops.value.column.key == 'proof' && !slotprops.value.record.file_location && slotprops.value.record.actual" style="font-size:small;color:red;">Proof is Mandatory</p>
                <span
                  style="display: flex; gap: 5px; width: 9rem"
                  v-if="slotprops.value.column.key == 'status'"
                >
                  <img
                    style="width: 1rem; height: 1rem"
                    v-if="slotprops.value.record.status == 'Approved'"
                    src="@/assets/approved.png"
                  />
                  <img
                    style="width: 1rem; height: 1rem"
                    v-if="slotprops.value.record.status == 'Pending'"
                    src="@/assets/pending.svg"
                  />
                  <img
                    style="width: 1rem; height: 1rem"
                    v-if="slotprops.value.record.status == 'rejected'"
                    src="@/assets/rejected.png"
                  />
                  <img
                    style="width: 1rem; height: 1rem"
                    v-if="slotprops.value.record.status == 'partially_approved'"
                    src="@/assets/approved.png"
                  />
                  <span v-if="(slotprops.value.record.status == 'rejected') && (slotprops.value.record.remarks)">{{ slotprops.value.record.status}}</span>
                  <span v-if="(slotprops.value.record.status == 'rejected') && (!slotprops.value.record.remarks)">Not Submitted</span>
                  <span v-if="(slotprops.value.record.status !== 'rejected')">{{ slotprops.value.record.status }}</span>
                </span>
                <span :title="slotprops.value.record.remarks" v-if="slotprops.value.column.key == 'remarks'">
                  {{ slotprops.value.record.remarks }}
                </span>
                </div>
              </template>
            </itProof-submit-dataTable>
          </template>
          <template v-slot:bottom>
            <footer>
              <popup-bottom-container>
                <template>
                  <div style="display: flex; flex-direction: column">
                    <p style="font-size: large; font-weight: 700">
                      General Remarks
                    </p>
                    <p>
                      IncomeTax proof Submission window will be closing soon
                    </p>
                  </div>
                </template>
                <template slot="end">
                  <btn-grp class="form-button">
                    <btn
                      text="Cancel"
                      type="secondary"
                      @click="
                        showPopupExemptionUnderSectionDeduction =
                          !showPopupExemptionUnderSectionDeduction;toast=false;getItSubmissionData()
                      "
                    />
                    <btn
                      v-show="incomeTaxProofSubmittedFlag"
                      :disabled="!incomeTaxProofSubmittedFlag ||(releaseForEmployees||dateCheck==false)"
                      text="Save as Draft"
                      type="primary"
                      @click="saveDataForFinalArray('section_ten_exemption')"
                    />
                  </btn-grp>
                </template>
              </popup-bottom-container>
            </footer>
          </template>
        </pop-up-window-lg>
        <pop-up-window-lg
          v-if="
            section_ten_attachments_pop_up ||
            house_rent_attachments_pop_up ||
            deduction_under_6A_attachments_pop_up ||
            income_from_previous_employee_pop_up ||
            income_loss_from_house_attachments_pop_up ||
            other_income_attachments_pop_up || 
            other_tcs_attachment_pop_up
          "
          @back="goBackFunction(attachments_pop_up_header)"
          :header="attachments_pop_up_header"
        >
          <template v-slot:content>
            
            <itProof-submit-dataTable
              :tableColumsHeader="attachment_pop_up_column_header"
              :tableColumnsData="attachment_pop_up_table_columns_data"
            >
              <template v-slot="slotprops">
                <span
                :disabled="!incomeTaxProofSubmittedFlag"
                  style="display: flex; gap: 20px"
                  v-if="slotprops.value.column.key == 'attachment'"
                >
                  <span style="width: 12rem">{{
                    slotprops.value.record.attachment
                  }}</span>
                </span>
                <span
                :disabled="!incomeTaxProofSubmittedFlag"
                  style="width: 10rem"
                  v-if="slotprops.value.column.key == 'fileName'"
                >
                  {{ slotprops.value.record.fileName }}
                </span>
               

               
                <span
                  style="width: 15rem"
                  v-if="slotprops.value.column.key == 'viewFile'"
                >
               
                  <button @click="downloadUrl()" class="export-button">
                    View Attachment
                  </button>
                 
                </span>
                
                <span
                :disabled="!incomeTaxProofSubmittedFlag"
                  style="width: 15rem"
                  v-if="slotprops.value.column.key == 'removeFile'"
                >
                  <button @click="deleteUrl(slotprops.value.record,slotprops.value.index,attachments_pop_up_header)" class="export-button">
                    Delete Attachment
                  </button>
                </span>
              </template>
            </itProof-submit-dataTable>
          </template>
          <template v-slot:bottom>
            <footer>
              <popup-bottom-container>
                <template slot="end">
                  <btn-grp class="form-button">
                    <btn
                      text="Cancel"
                      type="secondary"
                      @click="goBackFunction(attachments_pop_up_header);"
                    />
                  </btn-grp>
                </template>
              </popup-bottom-container>
            </footer>
          </template>
        </pop-up-window-lg>
        <div
          v-show="regime_type"
          class="pl-0 cursor-point"
          @click="
            showPopupHouseRentDeclaration = !showPopupHouseRentDeclaration;toast=false
          "
        >
          <div class="row col-bg-gray">
            <div class="col-3 img-block">
              <img src="@/assets/home_rent_declartion.svg" />
            </div>
            <div class="col-7 img-block">
              <div class="heading-text">House Rent Declaration</div>
              <div class="sub-heading-details-sm">
                To claim House rent allowance(HRA), it is necessary to provide
                evidence of the payment of the rent to the employee.
              </div>
            </div>
            <div class="col-2 arrow-left-align">
              <img class="arrow-icon-it" src="@/assets/arrow_purple_new.svg" />
            </div>
          </div>
        </div>
        <pop-up-window-lg
          v-if="showPopupHouseRentDeclaration"
          @back="showPopupHouseRentDeclaration = !showPopupHouseRentDeclaration;toast=false;getItSubmissionData();"
          header="House Rent Allowance"
        >
        <template v-slot:header>
        <div style="display: inline-block; position: relative; margin-left: 5px;height: 19px; width: 19px; ">
          <img
            style="cursor: pointer; margin-left: 5px; vertical-align: middle;height: 19px; width: 19px;"
            src="@/assets/info-black.svg"
            @click = "showHraTooltipPopup = true"    
          />
        </div>
        </template>
        <template v-if="showPopupHouseRentDeclaration" v-slot:content>
             <toast-message
      :message="errmsg"
      type="error"
      :isToastEnable="toast"
      @close="(val) => (toast = val)"
    />
    <pop-up-message popupHeaderMessage="House rent allowance (Exempt U/S 10 (13A))" v-if="showHraTooltipPopup" :message="'The following rules are applicable for HRA claims:'" :popupType="'Success'">

<template v-slot:bottomContent>
  <div
    style="display: flex;margin-bottom: 20px; flex-direction: column; align-items: flex-start;">
    <div style="display: flex; gap: 20px;">
    <ul>
      <li> 1) The HRA cannot exceed more than 50% of your basic salary.</li>
      <li>
         2) You cannot claim for the full rental amount you are paying. The exemption is based on the least of the following options:
        <ol>
          <li> - The actual amount allotted by the employer as the HRA.</li>
          <li> - Actual rent paid less 10% of the basic salary.</li>
          <li> - 50% of the basic salary, if the employee is staying in a metro city (40% for a non-metro city).</li>
        </ol>
      </li>
      <li> 3) You can take advantage of tax benefits of HRA along with a home loan.</li>
      <li>
        4) If you are staying with your parents, you can pay rent to your parents and collect a receipt for HRA claim. However, the rules don't allow you to pay rent to your spouse.
      </li>
      <li>
        5) The landlord's PAN card is mandatory for rent exceeding Rs.1,00,000 per year. The landlord can provide a self-declaration if they do not have a PAN card.
      </li>
      <li> 6) If your landlord is an NRI, you must deduct 30% tax from the rent amount that needs to be declared.</li>
    </ul>
    </div>
    
  </div>
  <div class="popup-btn-group" style="display: flex; justify-content: flex-end; margin-top: 20px;" >
    <button class="btn-popup-cancel" type="button" @click="showHraTooltipPopup = !showHraTooltipPopup">
      <b>OK</b>
    </button>
    <!-- <button class="btn-popup" type="button" @click="showPopupHouseRentDeclaration = !showPopupHouseRentDeclaration,showHraTooltipPopup = !showHraTooltipPopup">
      <b>Agree</b>
    </button> -->
  </div>
</template>
</pop-up-message>
            <div>
              <div
                style="
                  display: flex;
                  justify-content: space-between;
                  width: 100%;
                "
              >
                <div class="heading-text">
                  Rent Paid Details for HRA Exemption
                </div>
                <div 
                :disabled="finalizedSubmitFlag"
                  class="align-center"
                  style="display: flex; align-items: center; gap: 5px"
                >
                  <img src="@/assets/group-5.svg" class="Group-5" />
                  <button
                    class="text-green"
                    @click="addMoreRow('house_rent_declaration')"
                  >
                    Add Row
                  </button>
                </div>
              </div>
              <div
                class="row form-group my-3 hraMain"
                v-for="(item, index) in house_rent_declaration_array.details"
                :key="index"
                style="width: 100% !important;"
              >
              <hr style="width:100%; border: 1px dashed #34c0be; margin: 2px 0px 14px 0px;"> 

                <div :disabled="item.status=='Approved' || finalizedSubmitFlag" v-if="!item.isDelete && index==0" class="col-4 pl-0">
                  <div class="label">
                    <span class="input-label1">From Date</span>
                    <date-picker
                      name="fromDate"
                      data-vv-as="from date"
                      @datevalue="
                        (val) => {
                          item.from=val
                          let date=new Date(val)
                          item.to=date.setDate(date.getDate()+1)
                        }
                      "

                      :dates-disabled="{
                        from:  new Date(
                          
                            fiscalYearEnd
                        ),
                        to: new Date(
                         
                            fiscalYearStart
                        ),
                      }"
                      v-validate="{ required: true }"
                      :classname="errors.has('fromDate')"
                      :errormsg="errors.first('fromDate')"
                      v-model="item.from"
                    />
                  </div>
                </div>
                <div :disabled="item.status=='Approved' || finalizedSubmitFlag" v-if="!item.isDelete && index>0 " class="col-4 pl-0">
                  <div class="label">
                    <span class="input-label1">From Date</span>
                    <date-picker
                      name="fromDate"
                      data-vv-as="from date"
                      @datevalue="
                        (val) => {  
                         
                           item.from=val
                          let date=new Date(val)
                          item.to=date.setDate(date.getDate()+1)
                          
                        }
                      "

                      :dates-disabled="{
                        from:  new Date(
                          
                         fiscalYearEnd
                        ),
                        to: new Date(
                          house_rent_declaration_array.details[index-1].to ||
                            fiscalYearStart
                        ),
                      }"
                      v-validate="{ required: true }"
                      :classname="errors.has('fromDate')"
                      :errormsg="errors.first('fromDate')"
                      v-model="item.from"
                    />
                  </div>
                </div>
                <div :disabled="item.status=='Approved' || finalizedSubmitFlag" v-if="!item.isDelete && index==0" class="col-4 pl-0">
                  <div class="label">
                    <span class="input-label1">To Date</span>
                    <date-picker
                      name="toDate"
                      data-vv-as="to date"
                      @datevalue="
                        (val) => {
                          item.to = val;
                        
                        }
                      "
                      :dates-disabled="{
                        from: new Date(
                         fiscalYearEndPlus
                        ),
                        to: new Date(
                         house_rent_declaration_array.details[index].from   
                        ),
                      }"
                      v-validate="{ required: true }"
                      :classname="errors.has('toDate')"
                      :errormsg="errors.first('toDate')"
                      v-model="item.to"
                    />
                  </div>
                </div>
                 <div :disabled="item.status=='Approved' || finalizedSubmitFlag" v-if="!item.isDelete && index>0" class="col-4 pl-0">
                  <div class="label">
                    <span class="input-label1">To Date</span>
                    <date-picker
                      name="toDate"
                      data-vv-as="to date"
                      @datevalue="
                        (val) => {
                          item.to = val;
                          }
                      "
                      :dates-disabled="{
                        from: new Date(
                            // fiscalYearEnd
                            fiscalYearEndPlus 
                        ),
                        to: new Date(
                         house_rent_declaration_array.details[index].from||fiscalYearStart
                        ),
                      }"
                      v-validate="{ required: true }"
                      :classname="errors.has('toDate')"
                      :errormsg="errors.first('toDate')"
                      v-model="item.to"
                    />
                  </div>
                </div>
                <div :disabled="item.status=='Approved' || finalizedSubmitFlag"  v-if="!item.isDelete" class="col-4 pl-0">
                  <txt
                    label="Rent per Month *"
                    type="number"
                    :name="`${index}Amount`"
                    v-validate="{ required: true }"
                    :classname="errors.has(`${index}Amount`)"
                    errormsg="Amount field is mandatory"
                    v-model="item.value"
                    @change="
                      (val) => {
                       
                         
                          hraOnchange(val,index)
                        }
                      
                    "
                  />
                </div>
                <div :disabled="item.status=='Approved' || finalizedSubmitFlag"  v-show="!item.isDelete && item.ownerDetails.metro!='non_metro' && item.value>0" class="col-4 pl-0 metroBtn">
                  <tl-select
                    label="City *"
                    :options="metro_city_options"
                    @change="
                      (val) => {
                        sendMetroValue(val, index);
                      }
                    "
                    v-model="item.ownerDetails.state"
                  ></tl-select>
                </div>
                <div :disabled="item.status=='Approved' || finalizedSubmitFlag"  v-if="!item.isDelete && item.ownerDetails.metro=='non_metro'&&item.value>0" class="col-4 pl-0 metroBtn">
                  <tl-select
                    label="City"
                    :options="metro_city_options"
                    @change="
                      (val) => {
                        sendMetroValue(val, index);
                      }
                    "
                    value="Other"
                  ></tl-select>
                </div>
                <div 
                :disabled="item.status=='Approved' || finalizedSubmitFlag"
                  class="col-4 pl-0 metroBtn"
                  v-if="
                    (item.ownerDetails.metro == 'Other' ||
                      item.ownerDetails.metro == 'non_metro') &&
                    !item.isDelete && item.value>0
                  "
                >
                  <txt
                    label="City Name *"
                    type="text"
                    :name="`${index}City name`"
                    v-validate="{ required: true }"
                    :classname="errors.has(`${index}City name`)"
                    errormsg="City name is mandatory for non-metro"
                    v-model="item.ownerDetails.state"
                    @change="
                      (val) => {
                        item.ownerDetails.state = val;
                      }
                    "
                  />
                </div>
                <div
                :disabled="item.status=='Approved' || finalizedSubmitFlag"
                  v-if="!item.isDelete"
                  class="col-4 pl-0"
                >
                  <txt
                    label="Owner PAN Number *"
                    type="text"
                    :name="`${index}owner PAN Number`"
                     v-validate="totalRentExceedsOneLakh ? { required: true, regex: pancardRegex } : { required: false, regex: pancardRegex }"
                    :classname="errors.has(`${index}owner PAN Number`)"
                    errormsg="Owner PAN number is required & should be in valid format"
                    v-model="item.ownerDetails.panNumber"
                    @change="
                      (val) => {
                        
                        item.ownerDetails.panNumber = val.toUpperCase();
                        checkOwnerPan(val.toUpperCase(),index)
                      }
                    "
                  />
                </div>
                <div
                  :disabled="item.status=='Approved' || finalizedSubmitFlag"
                  v-if="!item.isDelete"
                  class="col-4 pl-0"
                >
                  <txt
                    label="Owner Name *"
                    type="text"
                    :name="`${index}Owner name`"
                    v-validate="item.value>8333?{ required: true }:{ required: false }"
                    :classname="errors.has(`${index}Owner name`)"
                    errormsg="Owner name is mandatory for non-metro"
                    v-model="item.ownerDetails.name"
                    @change="
                      (val) => {
                        item.ownerDetails.name = val.toUpperCase();
                      }
                    "
                  />
                </div>
                <div
                  :disabled="item.status=='Approved' || finalizedSubmitFlag"
                  v-if="!item.isDelete"
                  class="col-4 pl-0"
                >
                  <txt
                    label="Owner Address *"
                    type="text"
                    :name="`${index}owner address`"
                    v-validate="item.value>8333?{ required: true }:{ required: false }"
                    :classname="errors.has(`${index}owner address`)"
                    errormsg="Owner address is required "
                    v-model="item.ownerDetails.address"
                    @change="
                      (val) => {
                        item.ownerDetails.address = val;
                      }
                    "
                  />
                </div>
                 <div
                 
                  v-if="!item.isDelete && item.remarks"
                  class="col-4 pl-0 metroBtn"
                 
                >
                <label :for="`remarks`" class="">
                 
                  <p>Remarks</p>
                </label>
                <input 
                
                type="text"
                id="remarks"
                v-model="item.remarks"
                style="height:2rem; border:1px solid red; text-align: center;font-weight:bold;font-size: medium;"
                />
                  <!-- <txt
                    label="Remarks"
                    type="text"
                    name="remarks"
                    :stylee="`border:1px solid red`"
                    v-model="item.remarks"
                    @change="
                      (val) => {
                        item.remarks = val;
                      }
                    "
                  /> -->
                </div>
                <!-- <div style="display:flex; flex-direction: column; margin-left: auto"> 
                  
                </div> -->
                <div :disabled = 'finalizedSubmitFlag' class="col-4 pl-0 uploadMethoRadio" v-if="!item.isDelete && item.status">
                   <span>
                  <img
                    style="width: 1rem; height: 1rem"
                    v-if="item.status == 'Approved'"
                    src="@/assets/approved.png"
                  />
                  <img
                    style="width: 1rem; height: 1rem"
                    v-if="item.status == 'Pending'"
                    src="@/assets/pending.svg"
                  />
                  <img
                    style="width: 1rem; height: 1rem"
                    v-if="item.status == 'rejected'"
                    src="@/assets/rejected.png"
                  />
                  <img
                    style="width: 1rem; height: 1rem"
                    v-if="item.status == 'partially_approved'"
                    src="@/assets/approved.png"
                  />
                  <span>{{ item.status.toUpperCase() }}</span>
                </span>
               
                    
                  <!-- <span >({{ item.remarks }})</span> -->
                
                
                </div>
                <div  :disabled = 'finalizedSubmitFlag'  class="metroBtn" style="cursor: pointer" v-if="!item.isDelete&&index>0">
                  <p
                    class="delete-btn"
                    @click="deleteRow('house_rent_declaration', index, 0)"
                  >
                    <span>Delete</span>
                  </p>
                </div>
              </div>
            </div>
            <div  class="hraButton">
              <button
              :disabled="(releaseForEmployees||dateCheck==false)"
                style="width: 12rem; background-color: #e3c449"
                class="export-button"
                v-if="file_location_hra || house_rent_declaration_array.file_location"
                
                @click="
                  show_pop_up(
                    house_rent_declaration_array,
                    'house_rent_declaration',
                  )
                "
              >
                <img src="@/assets/clip.svg" />
                <label style="cursor: pointer">View Attachment</label>
              </button>

              <button
              :disabled="!incomeTaxProofSubmittedFlag ||(releaseForEmployees||dateCheck==false)"
                style="width: 12rem; cursor: default"
                class="export-button"
                v-if="!file_location_hra && !house_rent_declaration_array.file_location"
              >
                <label :for="`file-inputHRA`" class="input-label">
                  <img src="@/assets/clip.svg" />
                  <p>Attachment</p>
                </label>
                <!-- <img src="@/assets/clip.svg" />
                  <p>Attachment</p> -->
                <input
                  style="opacity: 0"
                  type="file"
                  :id="`file-inputHRA`"
                  name="attachment"
                  @change="
                    uploadAttachments(
                      $event.target.files,
                      0,
                      0,
                      'house_rent_declaration'
                    )
                  "
                />
              </button>
            </div>
          </template>

          <template v-if="showPopupHouseRentDeclaration" v-slot:bottom>
            <footer>
              <popup-bottom-container>
                <template>
                  <div style="display: flex; flex-direction: column">
                    <p style="font-size: large; font-weight: 700">
                      General Remarks
                    </p>
                    <p>
                      IncomeTax proof Submission window will be closing soon
                    </p>
                  </div>
                </template>
                <template slot="end">
                  <btn-grp class="form-button">
                    <btn
                      text="Cancel"
                      type="secondary"
                      @click="
                        showPopupHouseRentDeclaration =
                          !showPopupHouseRentDeclaration;toast=false;getItSubmissionData()
                      "
                    />
                    <btn
                    
                    v-show="incomeTaxProofSubmittedFlag"
                     :disabled="!incomeTaxProofSubmittedFlag ||(releaseForEmployees||dateCheck==false)"
                      text="Save as Draft"
                      type="primary"
                      @click="hraPanValidation()"
                    />
                  </btn-grp>
                </template>
              </popup-bottom-container>
            </footer>
          </template>
        </pop-up-window-lg>
        <div  
           v-show="!regime_type"
          class="pr-0 cursor-point"
          @click="showPopupDeductionUnderNPS = !showPopupDeductionUnderNPS;toast=false"
        >
          <div class="row col-bg-gray">
            <div class="col-3 img-block">
              <img src="@/assets/deduction_under_80CD.svg" />
            </div>
            <div class="col-7 img-block">
              <div class="heading-text">Deduction under VI A</div>
              <div class="sub-heading-details-sm">
                Section 80C offers tax deductions on different types of
                tax-saving investments, such as ULIP,PPF, premium, etc.
              </div>
            </div>
            <div class="col-2 arrow-left-align">
              <img class="arrow-icon-it" src="@/assets/arrow_purple_new.svg" />
            </div>
          </div>
        </div>
        <pop-up-window-lg  v-if="showPopupDeductionUnderNPS"
          @back="showPopupDeductionUnderNPS = !showPopupDeductionUnderNPS;toast=false;getItSubmissionData();"
          header="Deduction Under Chapter VI A"
        >
          <template v-slot:content>
             <toast-message
      :message="errmsg"
      type="error"
      :isToastEnable="toast"
      @close="(val) => (toast = val)"
         /> 
         <itProof-submit-dataTable
              :disabled="!incomeTaxProofSubmittedFlag ||(releaseForEmployees||dateCheck==false) || true"
              :tableColumsHeader="deduction_under_80C_table_colums_fornewRegime_header"
              :tableColumnsData="deduction_under_NPS_table_columns_data"
            >
              <template v-slot="slotprops">
                <span
                  :disabled="slotprops.value.record.status == 'Approved'"
                  v-if="slotprops.value.column.key == '80Cparticulars'"
                >
                  <span style="width: 12rem">80CCD2 - National Pension Scheme ('The NPS Employer contribution will be processed through Payroll')</span>
                  <!-- <img
                    style="cursor: pointer"
                    :title="getTitleName(slotprops.value.record)"
                    src="@/assets/info-black.svg"
                  /> -->
                </span>
                
                <!-- <span
                  style="width: 10rem"
                  v-if="slotprops.value.column.key == 'declaredAmount'"
                >The NPS Employer contribution will be processed through Payroll
                </span> -->
                <!-- <txt
                  :disabled="slotprops.value.record.status == 'Approved'"
                  v-if="slotprops.value.column.key == 'submittedAmount'"
                  @blur="uploadValidation('deduction_under_chapter_VI_A_80C')"
                  style="width: 14rem"
                  type="number"
                  @Change="
                    (value) => {
                      slotprops.value.record.actual = value;
                    }
                  "
                  v-model="slotprops.value.record.actual"
                >
                </txt> -->
                <!-- <p v-if="slotprops.value.column.key == 'submittedAmount' && slotprops.value.record.file_location && !slotprops.value.record.actual" style="font-size:x-small;color:red;">Field is mandatory</p> -->

                <!-- <span 
                :disabled="slotprops.value.record.status == 'Approved'"
                  style="width: 7rem"
                  v-if="slotprops.value.column.key == 'verifiedAmount'"
                >
                  {{ slotprops.value.record.approved }}
                </span>
                <button
                :disabled="slotprops.value.record.status == 'Approved'"
                  style="width: 12rem; background-color: #e3c449"
                  @click="
                    show_pop_up(
                      slotprops.value.record,
                      'deduction_under_80C',
                      slotprops.value.index
                    )
                  "
                  v-if="
                    slotprops.value.column.key == 'proof' &&
                    slotprops.value.record.file_location
                  "
                  class="export-button"
                >
                  <img src="@/assets/clip.svg" />
                  <label style="cursor: pointer">View Attachment</label>
                </button>
                <button
                
                  style="width: 12rem; cursor: default"
                  v-if="
                    slotprops.value.column.key == 'proof' &&
                    !slotprops.value.record.file_location
                  "
                  class="export-button"
                  :disabled="!slotprops.value.record.actual || slotprops.value.record.status == 'Approved'"
                >
                  <label
                    class="input-label"
                    :for="`file-input${slotprops.value.index}`"
                  >
                    <img src="@/assets/clip.svg" />
                    <p>Attachment</p>
                  </label>
                  
                <p v-if="slotprops.value.column.key == 'proof' && !slotprops.value.record.file_location && slotprops.value.record.actual" style="font-size:small;color:red;">Document is Mandatory</p>

                <span
                :disabled="slotprops.value.record.status == 'Approved'"
                  style="display: flex; gap: 5px; width: 9rem"
                  v-if="slotprops.value.column.key == 'status'"
                >
                  <img
                    style="width: 1rem; height: 1rem"
                    v-if="slotprops.value.record.status == 'Approved'"
                    src="@/assets/approved.png"
                  />
                  <img
                    style="width: 1rem; height: 1rem"
                    v-if="slotprops.value.record.status == 'Pending'"
                    src="@/assets/pending.svg"
                  />
                  <img
                    style="width: 1rem; height: 1rem"
                    v-if="slotprops.value.record.status == 'rejected'"
                    src="@/assets/rejected.png"
                  />
                  <img
                    style="width: 1rem; height: 1rem"
                    v-if="slotprops.value.record.status == 'partially_approved'"
                    src="@/assets/approved.png"
                  />
                  <span v-if="(slotprops.value.record.status == 'rejected') && (slotprops.value.record.remarks)">{{ slotprops.value.record.status}}</span>
                  <span v-if="(slotprops.value.record.status == 'rejected') && (!slotprops.value.record.remarks)">Not Submitted</span>
                  <span v-if="(slotprops.value.record.status !== 'rejected')">{{ slotprops.value.record.status }}</span>
                </span>
                <span :disabled="slotprops.value.record.status == 'Approved'" :title="slotprops.value.record.remarks" v-if="slotprops.value.column.key == 'remarks'">
                  {{ slotprops.value.record.remarks }}
                </span> -->
              </template>
            </itProof-submit-dataTable>
          </template>
          <template v-slot:bottom>
            <footer>
              <popup-bottom-container>
                <template>
                  <div style="display: flex; flex-direction: column">
                    <p style="font-size: large; font-weight: 700">
                      General Remarks
                    </p>
                    <p>
                      IncomeTax proof Submission window will be closing soon
                    </p>
                  </div>
                </template>
                <template slot="end">
                  <btn-grp class="form-button">
                    <btn
                      text="Cancel"
                      type="secondary"
                      @click="
                        showPopupDeductionUnderNPS =
                          !showPopupDeductionUnderNPS;toast=false;getItSubmissionData()
                      "
                    />
                    <btn
                      v-show="incomeTaxProofSubmittedFlag"
                      :disabled="!incomeTaxProofSubmittedFlag ||(releaseForEmployees||dateCheck==false)"
                      text="Save as Draft"
                      type="primary"
                      @click="saveDataForFinalArray('deduction_under_6A')"
                    />
                  </btn-grp>
                </template>
              </popup-bottom-container>
            </footer>
          </template>
        </pop-up-window-lg>
        <div  
           v-show="regime_type"
          class="pr-0 cursor-point"
          @click="showPopupDeductionUnderCdeu = !showPopupDeductionUnderCdeu;toast=false"
        >
          <div class="row col-bg-gray">
            <div class="col-3 img-block">
              <img src="@/assets/deduction_under_80CD.svg" />
            </div>
            <div class="col-7 img-block">
              <div class="heading-text">Deduction under VI A</div>
              <div class="sub-heading-details-sm">
                Section 80C offers tax deductions on different types of
                tax-saving investments, such as ULIP,PPF, premium, etc.
              </div>
            </div>
            <div class="col-2 arrow-left-align">
              <img class="arrow-icon-it" src="@/assets/arrow_purple_new.svg" />
            </div>
          </div>
        </div>
        <pop-up-window-lg
          v-if="showPopupDeductionUnderCdeu"
          @back="showPopupDeductionUnderCdeu = !showPopupDeductionUnderCdeu;toast=false;getItSubmissionData();"
          header="Deduction Under Chapter VI A"
        >
          <template v-slot:content>
             <toast-message
      :message="errmsg"
      type="error"
      :isToastEnable="toast"
      @close="(val) => (toast = val)"
    />
    <pop-up-message popupHeaderMessage="Section 80D - Medical Insurance for Self, Spouse and Dependent Children"
      v-if="show80DFamilyPopup" :message="'Qualified Amount : 25000 INR'" :popupType="'Success'">
      <template v-slot:bottomContent>
        <div style="display: flex; margin-bottom: 10px; flex-direction: column; align-items: flex-start;">
          <div style="display: flex; gap: 10px;">
            <div style="max-height: 400px; overflow-y: auto; border: 1px solid #ddd; padding: 10px;">
              <h3>HEALTH INSURANCE PREMIUM - 80D</h3>

              <h4>Eligibility</h4>
              <p>You can claim a tax deduction under this section for the payment of medical insurance premiums for self, your spouse, or any child. In addition, any amount paid for health check-ups can also be claimed for a tax deduction which shall not exceed Rs. 5,000. 
              </p>
            </div>
          </div>
        </div>
        <div class="popup-btn-group" style="display: flex; justify-content: flex-end; margin-top: 20px;">
          <button class="btn-popup-cancel" type="button" @click="show80DFamilyPopup = false">
            <b>OK</b>
          </button>
          <!-- <button class="btn-popup" type="button"">
        <b>Agree</b>
      </button> -->
        </div>
      </template>
    </pop-up-message>    
    <pop-up-message popupHeaderMessage="Section 80D - Medical Insurance for Parents"
      v-if="show80DParentsPopup" :message="'Qualified Amount : 25000 INR'" :popupType="'Success'">
      <template v-slot:bottomContent>
        <div style="display: flex; margin-bottom: 10px; flex-direction: column; align-items: flex-start;">
          <div style="display: flex; gap: 10px;">
            <div style="max-height: 400px; overflow-y: auto; border: 1px solid #ddd; padding: 10px;">
              <h3>HEALTH INSURANCE PREMIUM - 80D</h3>
              <p>You can claim a tax deduction under this section for the payment of medical insurance premiums for your parents. Additionally, any amount spent on health check-ups can also be claimed as a tax deduction, subject to a maximum limit of Rs. 5,000.</p>
            </div>
          </div>
        </div>
        <div class="popup-btn-group" style="display: flex; justify-content: flex-end; margin-top: 20px;">
          <button class="btn-popup-cancel" type="button" @click="show80DParentsPopup = false">
            <b>OK</b>
          </button>
          <!-- <button class="btn-popup" type="button"">
        <b>Agree</b>
      </button> -->
        </div>
      </template>
    </pop-up-message>   
    <pop-up-message popupHeaderMessage="Section 80D - Medical Insurance/ Medical Expenditure for Parent(s) if Senior Citizen(s)"
      v-if="show80DSeniorParentsPopup" :message="'Qualified Amount : 50000 INR'" :popupType="'Success'">
      <template v-slot:bottomContent>
        <div style="display: flex; margin-bottom: 10px; flex-direction: column; align-items: flex-start;">
          <div style="display: flex; gap: 10px;">
            <div style="max-height: 400px; overflow-y: auto; border: 1px solid #ddd; padding: 10px;">
              <h3>HEALTH INSURANCE PREMIUM - 80D</h3>
              <p>You can claim a tax deduction under this section for the payment of medical insurance premiums for your parents if they are senior citizens. Additionally, any amount spent on health check-ups can also be claimed as a tax deduction, with a maximum limit of Rs. 5,000.</p>
              <h3>MEDICAL EXPENDITURE</h3>
              <p>If there is no health insurance in effect, medical expenses for senior citizen parents can be claimed up to a maximum of Rs. 50,000.</p>
            </div>
          </div>
        </div>
        <div class="popup-btn-group" style="display: flex; justify-content: flex-end; margin-top: 20px;">
          <button class="btn-popup-cancel" type="button" @click="show80DSeniorParentsPopup = false">
            <b>OK</b>
          </button>
          <!-- <button class="btn-popup" type="button"">
        <b>Agree</b>
      </button> -->
        </div>
      </template>
    </pop-up-message> 
    <pop-up-message popupHeaderMessage="Section 80D - Health Insurance for Self, Spouse and Children if Senior Citizen"
      v-if="show80DFamilySeniorParentsPopup" :message="'Qualified Amount : 50000 INR'" :popupType="'Success'">
      <template v-slot:bottomContent>
        <div style="display: flex; margin-bottom: 10px; flex-direction: column; align-items: flex-start;">
          <div style="display: flex; gap: 10px;">
            <div style="max-height: 400px; overflow-y: auto; border: 1px solid #ddd; padding: 10px;">
              <h3>HEALTH INSURANCE PREMIUM - 80D</h3>
              <p>You can claim a tax deduction under this section for the payment of medical insurance premium for self, spouse or any child. In addition, any amount paid for health check-up can also be claimed for tax deduction which shall not exceed to Rs. 5,000.</p>
            </div>
          </div>
        </div>
        <div class="popup-btn-group" style="display: flex; justify-content: flex-end; margin-top: 20px;">
          <button class="btn-popup-cancel" type="button" @click="show80DFamilySeniorParentsPopup = false">
            <b>OK</b>
          </button>
          <!-- <button class="btn-popup" type="button"">
        <b>Agree</b>
      </button> -->
        </div>
      </template>
    </pop-up-message> 
    <pop-up-message popupHeaderMessage="80 E- Interest paid on loan for Higher Education"
      v-if="showInterestonEducationPopup" :message="'Qualified Amount : No Limit'" :popupType="'Success'">
      <template v-slot:bottomContent>
        <div style="display: flex; margin-bottom: 10px; flex-direction: column; align-items: flex-start;">
          <div style="display: flex; gap: 10px;">
            <div style="max-height: 400px; overflow-y: auto; border: 1px solid #ddd; padding: 10px;">
              <h3>Section 80E: Income tax deduction for interest on Education Loan</h3>
              <p>You can claim a tax deduction under section 80E for interest paid on repayment of an Education loan. The deduction can only be claimed on the interest paid on the repayment of the loan and not on the principal amount. </p>
            </div>
          </div>
        </div>
        <div class="popup-btn-group" style="display: flex; justify-content: flex-end; margin-top: 20px;">
          <button class="btn-popup-cancel" type="button" @click="showInterestonEducationPopup = false">
            <b>OK</b>
          </button>
          <!-- <button class="btn-popup" type="button"">
        <b>Agree</b>
      </button> -->
        </div>
      </template>
    </pop-up-message> 
    <pop-up-message popupHeaderMessage="80 EE - Additional Home Loan Interest Deduction"
      v-if="showInterestonHomeonePopup" :message="'Qualified Amount : 50000 INR'" :popupType="'Success'">
      <template v-slot:bottomContent>
        <div style="display: flex; margin-bottom: 10px; flex-direction: column; align-items: flex-start;">
          <div style="display: flex; gap: 10px;">
            <div style="max-height: 400px; overflow-y: auto; border: 1px solid #ddd; padding: 10px;">
              <h3 style="margin-bottom: 10px; color: #333;">Condition for Claiming this Section</h3>
                <ul style="margin: 0; padding: 0 0 0 20px; color: #555;">
                  <li style="margin-bottom: 8px;">The value of the house should be <strong>Rs 50 lakh or less</strong>.</li>
                  <li style="margin-bottom: 8px;">The loan taken for the house must be <strong>Rs 35 lakh or less</strong>.</li>
                  <li style="margin-bottom: 8px;">The loan must be sanctioned by a <strong>financial institution or a housing finance company</strong>.</li>
                  <li style="margin-bottom: 8px;">The loan must be sanctioned between <strong>01.04.2016 to 31.03.2017</strong>.</li>
                  <li style="margin-bottom: 8px;">As of the date of the sanction of the loan, <strong>no other house property must be owned by you</strong>.</li>
                </ul>
                <p style="margin-top: 15px; color: #444;">
                  <strong>Eligibility Amount:</strong> Rs 50,000 per year until the loan is repaid.
                </p>
            </div>
          </div>
        </div>
        <div class="popup-btn-group" style="display: flex; justify-content: flex-end; margin-top: 20px;">
          <button class="btn-popup-cancel" type="button" @click="showInterestonHomeonePopup = false">
            <b>OK</b>
          </button>
          <!-- <button class="btn-popup" type="button"">
        <b>Agree</b>
      </button> -->
        </div>
      </template>
    </pop-up-message> 
    <pop-up-message popupHeaderMessage="80 EEA - Additional Home Loan Interest Deduction"
      v-if="showInterestonHometwoPopup" :message="'Qualified Amount : 150000 INR'" :popupType="'Success'">
      <template v-slot:bottomContent>
        <div style="display: flex; margin-bottom: 10px; flex-direction: column; align-items: flex-start;">
          <div style="display: flex; gap: 10px;">
            <div style="max-height: 400px; overflow-y: auto; border: 1px solid #ddd; padding: 10px;">
              <h3 style="margin-bottom: 10px; color: #333;">Condition for Claiming this Section</h3>
                  <ul style="margin: 0; padding: 0 0 0 20px; color: #555;">
                    <li style="margin-bottom: 8px;">
                      A housing loan must be taken from a <strong>financial institution or a housing finance company</strong> for buying a residential house property.
                    </li>
                    <li style="margin-bottom: 8px;">
                      The loan should be sanctioned during the period <strong>1st April 2019 and 31st March 2022</strong>.
                    </li>
                    <li style="margin-bottom: 8px;">
                      The stamp duty value of the house property should be <strong>Rs 45 lakhs or less</strong>.
                    </li>
                    <li style="margin-bottom: 8px;">
                      The individual taxpayer should not be eligible to claim a deduction under the existing <strong>Section 80EE</strong>.
                    </li>
                    <li style="margin-bottom: 8px;">
                      The taxpayer should be a first-time home buyer. The taxpayer should not own any residential house property as of the date of sanction of the loan.
                    </li>
                  </ul>
                  <p style="margin-top: 15px; color: #444;">
                    <strong>Eligibility Amount:</strong> Rs 1,50,000 per year until the loan is repaid.
                  </p>
            </div>
          </div>
        </div>
        <div class="popup-btn-group" style="display: flex; justify-content: flex-end; margin-top: 20px;">
          <button class="btn-popup-cancel" type="button" @click="showInterestonHometwoPopup = false">
            <b>OK</b>
          </button>
          <!-- <button class="btn-popup" type="button"">
        <b>Agree</b>
      </button> -->
        </div>
      </template>
    </pop-up-message> 
    <pop-up-message popupHeaderMessage="80 EEB - Deduction in Respect of Purchase of Electric Vehicle"
      v-if="showInterestonEVPopup" :message="'Qualified Amount : 150000 INR'" :popupType="'Success'">
      <template v-slot:bottomContent>
        <div style="display: flex; margin-bottom: 10px; flex-direction: column; align-items: flex-start;">
          <div style="display: flex; gap: 10px;">
            <div style="max-height: 400px; overflow-y: auto; border: 1px solid #ddd; padding: 10px;">
              <h3 style="margin-bottom: 10px; color: #333;">Condition for Claiming this Section</h3>
                  <ul style="margin: 0; padding: 0 0 0 20px; color: #555;">
                    <li style="margin-bottom: 8px;">
                      The loan must be sanctioned anytime during the period starting from 1 April 2019 till 31 March 2023
                    </li>
                  </ul>
                  
            </div>
          </div>
        </div>
        <div class="popup-btn-group" style="display: flex; justify-content: flex-end; margin-top: 20px;">
          <button class="btn-popup-cancel" type="button" @click="showInterestonEVPopup = false">
            <b>OK</b>
          </button>
          <!-- <button class="btn-popup" type="button"">
        <b>Agree</b>
      </button> -->
        </div>
      </template>
    </pop-up-message> 
    <pop-up-message :dynamicWidth="'50%'" popupHeaderMessage="INTEREST ON DEPOSIT IN SAVING ACCOUNT - 80TTA"
      v-if="showInterestFromSavingAccount" :message="'Qualified Amount : 10000 INR'" :popupType="'Success'">
      <template v-slot:bottomContent>
        <div style="display: flex; margin-bottom: 10px; flex-direction: column; align-items: flex-start;">
          <div style="display: flex; gap: 10px;">
            <div style="max-height: 400px; overflow-y: auto; border: 1px solid #ddd; padding: 10px;">
               <p>As per the existing provisions of Section 80TTA of the Income Tax Act, an assessee is allowed a deduction of up to Rs. 10,000 on interest income from a savings account. It's important to note that this deduction applies only to interest earned from savings accounts and not from Fixed Deposits or Recurring Deposits.</p>
               <p>Under Section 80TTA, there is no distinction for senior citizens; the deduction of Rs. 10,000 applies to all eligible taxpayers, regardless of age</p>
            </div>
          </div>
        </div>
        <div class="popup-btn-group" style="display: flex; justify-content: flex-end; margin-top: 20px;">
          <button class="btn-popup-cancel" type="button" @click="showInterestFromSavingAccount = false">
            <b>OK</b>
          </button>
          <!-- <button class="btn-popup" type="button"">
        <b>Agree</b>
      </button> -->
        </div>
      </template>
    </pop-up-message> 
    <pop-up-message :dynamicWidth="'50%'" popupHeaderMessage="INTEREST ON DEPOSIT IN SAVING ACCOUNT FOR SENIOR CITIZEN - 80TTB"
      v-if="showInterestFromSavingAccountforseniorcitizen" :message="'Qualified Amount : 50000 INR'" :popupType="'Success'">
      <template v-slot:bottomContent>
        <div style="display: flex; margin-bottom: 10px; flex-direction: column; align-items: flex-start;">
          <div style="display: flex; gap: 10px;">
            <div style="max-height: 400px; overflow-y: auto; border: 1px solid #ddd; padding: 10px;">
              <p>As per the Budget 2018, a new section 80TTB was introduced in the Income Tax Act to provide a deduction of Rs. 50,000 for senior citizens on interest income from deposits, including savings accounts, fixed deposits, and recurring deposits. This provision is effective from 1st April 2018 (i.e., for Assessment Year 2019-20 and Financial Year 2018-19).</p>
              <p>It is important to note that if a senior citizen claims a deduction under Section 80TTB, they cannot claim a deduction under Section 80TTA for interest income. Both deductions are mutually exclusive, meaning the taxpayer can choose only one of them.</p>
              <p>This provision benefits senior citizens by allowing a higher deduction of Rs. 50,000 compared to the Rs. 10,000 available under Section 80TTA for other taxpayers.</p>
            </div>
          </div>
        </div>
        <div class="popup-btn-group" style="display: flex; justify-content: flex-end; margin-top: 20px;">
          <button class="btn-popup-cancel" type="button" @click="showInterestFromSavingAccountforseniorcitizen = false">
            <b>OK</b>
          </button>
          <!-- <button class="btn-popup" type="button"">
        <b>Agree</b>
      </button> -->
        </div>
      </template>
    </pop-up-message> 
    <pop-up-message :dynamicWidth="'50%'" popupHeaderMessage="Additional Exemption Under National Pension Scheme (NPS) u/s 80CCD (1B)"
      v-if="showNPSEmployeeContributionPopup" :message="'Qualified Amount : 50000 INR'" :popupType="'Success'">
      <template v-slot:bottomContent>
        <div style="display: flex; margin-bottom: 10px; flex-direction: column; align-items: flex-start;">
          <div style="display: flex; gap: 10px;">
            <div style="max-height: 400px; overflow-y: auto; border: 1px solid #ddd; padding: 10px;">
              <h3 style="margin-bottom: 10px; color: #333;">Tax deductions under Section 80CCC and 80CCD for contributions to pension funds</h3>
              <p>You can claim a tax deduction under Section 80CCC and 80CCD for the contribution made to Pension Funds. If you have contributed any amount in any insurance scheme to receive a pension, then you can claim a tax deduction under 80CCC. However, if you have contributed to any pension scheme initiated by the central government, up to 10% of your salary such as the National Pension Scheme then you can claim a tax deduction under section 80CCD. </p>    
              <p><strong>Note:</strong> As per the Income Tax Act, the maximum limit of Rs. 1.5 lakh is an aggregate of deduction that may be claimed under sections 80C, 80CCC, and 80CCD. However, an exclusive tax benefit is available for NPS subscribers under section 80CCD. As per the Income Tax Act, Tier 1 account holder gets an additional deduction for investments up to Rs. 50, 000 in NPS. This deduction is over and above the deduction of Rs. 1.5 lakh available under section 80C of the IT Act, 1961. </p>    
            </div>
          </div>
        </div>
        <div class="popup-btn-group" style="display: flex; justify-content: flex-end; margin-top: 20px;">
          <button class="btn-popup-cancel" type="button" @click="showNPSEmployeeContributionPopup = false">
            <b>OK</b>
          </button>
          <!-- <button class="btn-popup" type="button"">
        <b>Agree</b>
      </button> -->
        </div>
      </template>
    </pop-up-message> 
    <pop-up-message popupHeaderMessage="Additional Exemption Under National Pension Scheme (NPS) u/s 80CCD (2)"
      v-if="showNPSEmployerContributionPopup" :message="'Qualified Amount : No Limit'" :popupType="'Success'">
      <template v-slot:bottomContent>
        <div style="display: flex; margin-bottom: 10px; flex-direction: column; align-items: flex-start;">
          <div style="display: flex; gap: 10px;">
            <div style="max-height: 400px; overflow-y: auto; border: 1px solid #ddd; padding: 10px;">
              <h3 style="margin-bottom: 10px; color: #333;">The exemption is based on the least of the following options:</h3>
              <ol>
                <li>1) Amount contributed by an employer,</li>
                <li>2) 10% of Basic+Dearness Allowance for the Old Tax regime, and 14% of Basic+Dearness Allowance for the New Tax Regime.</li>
                <li>3) Gross Total Income</li>
              </ol>
            </div>
          </div>
        </div>
        <div class="popup-btn-group" style="display: flex; justify-content: flex-end; margin-top: 20px;">
          <button class="btn-popup-cancel" type="button" @click="showNPSEmployerContributionPopup = false">
            <b>OK</b>
          </button>
          <!-- <button class="btn-popup" type="button"">
        <b>Agree</b>
      </button> -->
        </div>
      </template>
    </pop-up-message> 
            <span style="width: 12rem">   Note :  80CCD2 - National Pension Scheme ('The NPS Employer contribution will be processed through Payroll')</span>
            <itProof-submit-dataTable
              :disabled="(releaseForEmployees||dateCheck==false)"
              :tableColumsHeader="deduction_under_80C_table_colums_header"
              :tableColumnsData="deduction_under_80C_table_columns_data"
            >
              <template v-slot="slotprops">
                <div>
                <!-- <div v-if="slotprops.value.record.name !='LIC Deduction Through Salary' || slotprops.value.record.InvestmentComponentType.name!=='LIC Deduction Through Salary'"> -->
                  {{slotprops.value.record.name  }}
                <span
                  :disabled="slotprops.value.record.status == 'Approved' || finalizedSubmitFlag"
                  style="display: flex; gap: 20px"
                  v-if="slotprops.value.column.key == '80Cparticulars'"
                > 
                  <span v-if="slotprops.value.record.InvestmentComponentType.name == 'NPS Employee Contribution'" style="width: 12rem">
                    80CCD1(B)-Additional NPS Employee Contribution
                  </span>
                  <span v-else style="width: 12rem">{{
                   slotprops.value.record.name||slotprops.value.record["InvestmentComponentType"]["name"]
                  }}</span>
                  <img
                  v-if="slotprops.value.record.InvestmentComponentType.name=='NPS Employee Contribution'"
                    style="cursor: pointer"
                    src="@/assets/info-black.svg"
                    @click="show6APopup(slotprops.value.record.InvestmentComponentType.name)"
                  />
                  <img
                  v-if="slotprops.value.record.InvestmentComponentType.name=='NPS Employer Contribution'"
                    style="cursor: pointer"
                    src="@/assets/info-black.svg"
                    @click="show6APopup(slotprops.value.record.InvestmentComponentType.name)"
                  />
                </span>
                <span
                  style="width: 10rem"
                  v-if="slotprops.value.column.key == 'declaredAmount'"
                  :disabled="slotprops.value.record.status == 'Approved' || finalizedSubmitFlag"
                >
                  {{ slotprops.value.record.planned }}
                </span>
                <txt
                  :disabled="slotprops.value.record.status == 'Approved' || finalizedSubmitFlag"
                  v-if="slotprops.value.column.key == 'submittedAmount'"
                  @blur="uploadValidation('deduction_under_chapter_VI_A_80C')"
                  style="width: 14rem"
                  type="number"
                  @Change="
                    (value) => {
                      slotprops.value.record.actual = value;
                    }
                  "
                  v-model="slotprops.value.record.actual"
                >
                </txt>
                <p v-if="slotprops.value.column.key == 'submittedAmount' && slotprops.value.record.file_location && !slotprops.value.record.actual" style="font-size:x-small;color:red;">Field is mandatory</p>

                <span 
                :disabled="slotprops.value.record.status == 'Approved' || finalizedSubmitFlag"
                  style="width: 7rem"
                  v-if="slotprops.value.column.key == 'verifiedAmount'"
                >
                  {{ slotprops.value.record.approved }}
                </span>
                <button
                :disabled="slotprops.value.record.status == 'Approved'"
                  style="width: 12rem; background-color: #e3c449"
                  @click="
                    show_pop_up(
                      slotprops.value.record,
                      'deduction_under_80C',
                      slotprops.value.index
                    )
                  "
                  v-if="
                    slotprops.value.column.key == 'proof' &&
                    slotprops.value.record.file_location
                  "
                  class="export-button"
                >
                  <img src="@/assets/clip.svg" />
                  <label style="cursor: pointer">View Attachment</label>
                </button>
                <button
                  :disabled="!slotprops.value.record.actual || slotprops.value.record.status == 'Approved' || finalizedSubmitFlag"
                  style="width: 12rem; cursor: default"
                  v-if="
                    slotprops.value.column.key == 'proof' &&
                    !slotprops.value.record.file_location
                  "
                  class="export-button"
                >
                  <label
                    class="input-label"
                    :for="`file-input${slotprops.value.index}`"
                  >
                    <img src="@/assets/clip.svg" />
                    <p>Attachment</p>
                  </label>
                  <!-- <img src="@/assets/clip.svg" />
                  <p>Attachment</p> -->
                  <input
                    style="opacity: 0"
                    type="file"
                    :id="`file-input${slotprops.value.index}`"
                    name="attachment"
                    @change="
                      uploadAttachments(
                        $event.target.files,
                        slotprops.value.record,
                        slotprops.value.index,
                        'deduction_under_chapter_VI_A_80C'
                      )
                    "
                  />
                </button>
                <p v-if="slotprops.value.column.key == 'proof' && !slotprops.value.record.file_location && slotprops.value.record.actual" style="font-size:small;color:red;">Document is Mandatory</p>

                <span
                :disabled="slotprops.value.record.status == 'Approved'"
                  style="display: flex; gap: 5px; width: 9rem"
                  v-if="slotprops.value.column.key == 'status'"
                >
                  <img
                    style="width: 1rem; height: 1rem"
                    v-if="slotprops.value.record.status == 'Approved'"
                    src="@/assets/approved.png"
                  />
                  <img
                    style="width: 1rem; height: 1rem"
                    v-if="slotprops.value.record.status == 'Pending'"
                    src="@/assets/pending.svg"
                  />
                  <img
                    style="width: 1rem; height: 1rem"
                    v-if="slotprops.value.record.status == 'rejected'"
                    src="@/assets/rejected.png"
                  />
                  <img
                    style="width: 1rem; height: 1rem"
                    v-if="slotprops.value.record.status == 'partially_approved'"
                    src="@/assets/approved.png"
                  />
                  <span v-if="(slotprops.value.record.status == 'rejected') && (slotprops.value.record.remarks)">{{ slotprops.value.record.status}}</span>
                  <span v-if="(slotprops.value.record.status == 'rejected') && (!slotprops.value.record.remarks)">Not Submitted</span>
                  <span v-if="(slotprops.value.record.status !== 'rejected')">{{ slotprops.value.record.status }}</span>
                </span>
                <span :disabled="slotprops.value.record.status == 'Approved'" :title="slotprops.value.record.remarks" v-if="slotprops.value.column.key == 'remarks'">
                  {{ slotprops.value.record.remarks }}
                </span>
              </div>
              </template>
            </itProof-submit-dataTable>
            <itProof-submit-dataTable
              :disabled="(releaseForEmployees||dateCheck==false)"
              :tableColumsHeader="deduction_under_80D_table_colums_header"
              :tableColumnsData="deduction_under_80D_table_columns_data"
            >
              <template v-slot="slotprops">
                <span
                  style="display: flex; gap: 20px"
                  v-if="slotprops.value.column.key == '80Dparticulars'"
                  :disabled="slotprops.value.record.status == 'Approved' || finalizedSubmitFlag"
                >
                <span v-if="slotprops.value.record.InvestmentComponentType.name == 'Medical Insurance Premium Parents Sr. Citizen'"
                    class="hover-on-text"
                    @click="function_for_chapter6A(
                        slotprops.value.record,
                        'deduction_under_80D',
                        slotprops.value.index
                      )"
                    style="width: 12rem"
                  >
                  Medical Insurance Premium/ Medical Expenditure for Parents Sr.Citizen
                  </span>
                  <span v-else
                    class="hover-on-text"
                    @click="function_for_chapter6A(
                        slotprops.value.record,
                        'deduction_under_80D',
                        slotprops.value.index
                      )"
                    style="width: 12rem"
                  >
                  {{
                      slotprops.value.record.name||slotprops.value.record["InvestmentComponentType"]["name"]
                    }}
                  </span>
                  <img v-if ="slotprops.value.record.InvestmentComponentType.name!='Preventive Health Check Up Upto 5000 Part of Above'"
                    style="cursor: pointer"
                    src="@/assets/info-black.svg"
                    @click="show6APopup(slotprops.value.record.InvestmentComponentType.name)"
                  />
                </span>
                <span
                  style="width: 10rem"
                  v-if="slotprops.value.column.key == 'declaredAmount'"
                  :disabled="slotprops.value.record.status == 'Approved' || finalizedSubmitFlag"
                >
                  {{ slotprops.value.record.planned }}
                </span>
                <txt
                  :disabled="true"
                  v-if="slotprops.value.column.key == 'submittedAmount'"
                  
                  @blur="uploadValidation('deduction_under_chapter_VI_A_80D')"
                  style="width: 14rem"
                  type="number"
                  @Change="
                    (value) => {
                      slotprops.value.record.actual = value;
                    }
                  "
                  v-model="slotprops.value.record.actual"
                >
                </txt>
                <span
                  style="width: 7rem"
                  v-if="slotprops.value.column.key == 'verifiedAmount'"
                  :disabled="slotprops.value.record.status == 'Approved' || finalizedSubmitFlag"
                >
                  {{ slotprops.value.record.approved }}
                </span>
                <button
                  style="width: 12rem; background-color: #e3c449"
                  @click="
                    show_pop_up(
                      slotprops.value.record,
                      'deduction_under_80D',
                      slotprops.value.index
                    )
                  "
                  v-if="
                    slotprops.value.column.key == 'proof' &&
                    slotprops.value.record.file_location
                  "
                  :disabled="slotprops.value.record.status == 'Approved'"
                  class="export-button"
                >
                  <img src="@/assets/clip.svg" />
                  <label style="cursor: pointer">View Attachment</label>
                </button>
                <button
                  style="width: 12rem; cursor: default"
                  v-if="
                    slotprops.value.column.key == 'proof' &&
                    !slotprops.value.record.file_location
                  "
                  class="export-button"
                  :disabled="!slotprops.value.record.actual || slotprops.value.record.status == 'Approved' || finalizedSubmitFlag"
                >
                  <label
                    class="input-label"
                    :for="`file-input80D${slotprops.value.index}`"
                  >
                    <img src="@/assets/clip.svg" />
                    <p>Attachment</p>
                  </label>
                  <input
                    style="opacity: 0"
                    type="file"
                    :id="`file-input80D${slotprops.value.index}`"
                    name="attachment"
                    @change="
                      uploadAttachments(
                        $event.target.files,
                        slotprops.value.record,
                        slotprops.value.index,
                        'deduction_under_chapter_VI_A_80D'
                      )
                    "
                  />
                </button>
                <p v-if="slotprops.value.column.key == 'proof' && !slotprops.value.record.file_location && slotprops.value.record.actual" style="font-size:small;color:red;">Document is Mandatory</p>

                <span
                  style="display: flex; gap: 5px; width: 9rem"
                  v-if="slotprops.value.column.key == 'status'"
                  :disabled="slotprops.value.record.status == 'Approved'"
                >
                <img
                    style="width: 1rem; height: 1rem"
                    v-if="slotprops.value.record.status == 'Approved'"
                    src="@/assets/approved.png"
                  />
                  <img
                    style="width: 1rem; height: 1rem"
                    v-if="slotprops.value.record.status == 'Pending'"
                    src="@/assets/pending.svg"
                  />
                  <img
                    style="width: 1rem; height: 1rem"
                    v-if="slotprops.value.record.status == 'rejected'"
                     src="@/assets/rejected.png"
                  />
                  <img
                    style="width: 1rem; height: 1rem"
                    v-if="slotprops.value.record.status == 'partially_approved'"
                    src="@/assets/approved.png"
                  />
                  <span>{{ slotprops.value.record.status }}</span>
                </span>
                <span :disabled="slotprops.value.record.status == 'Approved'" :title="slotprops.value.record.remarks" v-if="slotprops.value.column.key == 'remarks'">
                  {{ slotprops.value.record.remarks }}
                </span>
              </template>
            </itProof-submit-dataTable>
            <itProof-submit-dataTable
              :disabled="(releaseForEmployees||dateCheck==false)"
              :tableColumsHeader="deduction_under_80DD_table_colums_header"
              :tableColumnsData="deduction_under_80DD_table_columns_data"
            >
            <template v-slot="slotprops">
                <span
                  style="display: flex; gap: 20px"
                  v-if="slotprops.value.column.key == '80DDparticulars'"
                  :disabled="slotprops.value.record.status == 'Approved' || finalizedSubmitFlag"
                >
                  <span
                    class="hover-on-text"
                    @click="function_for_chapter6A(
                        slotprops.value.record,
                        'deduction_under_80DD',
                        slotprops.value.index
                      )"
                    style="width: 12rem"
                  >
                  {{
                      slotprops.value.record.name||slotprops.value.record["InvestmentComponentType"]["name"]
                    }}
                  </span>
                  <!-- <img
                    style="cursor: pointer"
                    :title="getTitleName(slotprops.value.record)"
                    src="@/assets/info-black.svg"
                  /> -->
                </span>
                <span
                  style="width: 10rem"
                  v-if="slotprops.value.column.key == 'declaredAmount'"
                  :disabled="slotprops.value.record.status == 'Approved' || finalizedSubmitFlag"
                >
                  {{ slotprops.value.record.planned }}
                </span>
                <txt
                  :disabled="true"
                  v-if="slotprops.value.column.key == 'submittedAmount'"
                  
                  @blur="uploadValidation('deduction_under_chapter_VI_A_80DD')"
                  style="width: 14rem"
                  type="number"
                  @Change="
                    (value) => {
                      slotprops.value.record.actual = value;
                    }
                  "
                  v-model="slotprops.value.record.actual"
                >
                </txt>
                <span
                  style="width: 7rem"
                  v-if="slotprops.value.column.key == 'verifiedAmount'"
                  :disabled="slotprops.value.record.status == 'Approved' || finalizedSubmitFlag"
                >
                  {{ slotprops.value.record.approved }}
                </span>
                <button
                  style="width: 12rem; background-color: #e3c449"
                  @click="
                    show_pop_up(
                      slotprops.value.record,
                      'deduction_under_80DD',
                      slotprops.value.index
                    )
                  "
                  v-if="
                    slotprops.value.column.key == 'proof' &&
                    slotprops.value.record.file_location
                  "
                  :disabled="slotprops.value.record.status == 'Approved'"
                  class="export-button"
                >
                  <img src="@/assets/clip.svg" />
                  <label style="cursor: pointer">View Attachment</label>
                </button>
                <button
                  style="width: 12rem; cursor: default"
                  v-if="
                    slotprops.value.column.key == 'proof' &&
                    !slotprops.value.record.file_location
                  "
                  class="export-button"
                  :disabled="!slotprops.value.record.actual ||slotprops.value.record.status == 'Approved' || finalizedSubmitFlag"
                >
                  <label
                    class="input-label"
                    :for="`file-input80DD${slotprops.value.index}`"
                  >
                    <img src="@/assets/clip.svg" />
                    <p>Attachment</p>
                  </label>
                  <input
                    style="opacity: 0"
                    type="file"
                    :id="`file-input80DD${slotprops.value.index}`"
                    name="attachment"
                    @change="
                      uploadAttachments(
                        $event.target.files,
                        slotprops.value.record,
                        slotprops.value.index,
                        'deduction_under_chapter_VI_A_80DD'
                      )
                    "
                  />
                </button>
                <p v-if="slotprops.value.column.key == 'proof' && !slotprops.value.record.file_location && slotprops.value.record.actual" style="font-size:small;color:red;">Document is Mandatory</p>

                <span
                  style="display: flex; gap: 5px; width: 9rem"
                  v-if="slotprops.value.column.key == 'status'"
                  :disabled="slotprops.value.record.status == 'Approved'"
                >
                <img
                    style="width: 1rem; height: 1rem"
                    v-if="slotprops.value.record.status == 'Approved'"
                    src="@/assets/approved.png"
                  />
                  <img
                    style="width: 1rem; height: 1rem"
                    v-if="slotprops.value.record.status == 'Pending'"
                    src="@/assets/pending.svg"
                  />
                  <img
                    style="width: 1rem; height: 1rem"
                    v-if="slotprops.value.record.status == 'rejected'"
                     src="@/assets/rejected.png"
                  />
                  <img
                    style="width: 1rem; height: 1rem"
                    v-if="slotprops.value.record.status == 'partially_approved'"
                    src="@/assets/approved.png"
                  />
                  <span v-if="(slotprops.value.record.status == 'rejected') && (slotprops.value.record.remarks)">{{ slotprops.value.record.status}}</span>
                  <span v-if="(slotprops.value.record.status == 'rejected') && (!slotprops.value.record.remarks)">Not Submitted</span>
                  <span v-if="(slotprops.value.record.status !== 'rejected')">{{ slotprops.value.record.status }}</span>
                </span>
                <span :disabled="slotprops.value.record.status == 'Approved'" :title="slotprops.value.record.remarks" v-if="slotprops.value.column.key == 'remarks'">
                  {{ slotprops.value.record.remarks }}
                </span>
              </template>
            </itProof-submit-dataTable>
            <itProof-submit-dataTable
              :disabled="(releaseForEmployees||dateCheck==false)"
              :tableColumsHeader="deduction_under_80DDB_table_colums_header"
              :tableColumnsData="deduction_under_80DDB_table_columns_data"
            >
            <template v-slot="slotprops">
                <span
                  style="display: flex; gap: 20px"
                  v-if="slotprops.value.column.key == '80DDBparticulars'"
                  :disabled="slotprops.value.record.status == 'Approved' || finalizedSubmitFlag"
                >
                  <span
                    class="hover-on-text"
                    @click="function_for_chapter6A(
                        slotprops.value.record,
                        'deduction_under_80DDB',
                        slotprops.value.index
                      )"
                    style="width: 12rem"
                  >
                  {{
                      slotprops.value.record.name||slotprops.value.record["InvestmentComponentType"]["name"]
                    }}
                  </span>
                  <!-- <img
                    style="cursor: pointer"
                    :title="getTitleName(slotprops.value.record)"
                    src="@/assets/info-black.svg"
                  /> -->
                </span>
                <span
                  style="width: 10rem"
                  v-if="slotprops.value.column.key == 'declaredAmount'"
                  :disabled="slotprops.value.record.status == 'Approved' || finalizedSubmitFlag"
                >
                  {{ slotprops.value.record.planned }}
                </span>
                <txt
                  :disabled="true"
                  v-if="slotprops.value.column.key == 'submittedAmount'"
                
                  @blur="uploadValidation('deduction_under_chapter_VI_A_80DDB')"
                  style="width: 14rem"
                  type="number"
                  @Change="
                    (value) => {
                      slotprops.value.record.actual = value;
                    }
                  "
                  v-model="slotprops.value.record.actual"
                >
                </txt>
                <span
                  style="width: 7rem"
                  v-if="slotprops.value.column.key == 'verifiedAmount'"
                  :disabled="slotprops.value.record.status == 'Approved' || finalizedSubmitFlag"
                >
                  {{ slotprops.value.record.approved }}
                </span>
                <button
                  style="width: 12rem; background-color: #e3c449"
                  @click="
                    show_pop_up(
                      slotprops.value.record,
                      'deduction_under_80DDB',
                      slotprops.value.index
                    )
                  "
                  v-if="
                    slotprops.value.column.key == 'proof' &&
                    slotprops.value.record.file_location
                  "
                  :disabled="slotprops.value.record.status == 'Approved'"
                  class="export-button"
                >
                  <img src="@/assets/clip.svg" />
                  <label style="cursor: pointer">View Attachment</label>
                </button>
                <button
                  style="width: 12rem; cursor: default"
                  v-if="
                    slotprops.value.column.key == 'proof' &&
                    !slotprops.value.record.file_location
                  "
                  class="export-button"
                  :disabled="!slotprops.value.record.actual ||slotprops.value.record.status == 'Approved' || finalizedSubmitFlag"
                >
                  <label
                    class="input-label"
                    :for="`file-input80DDB${slotprops.value.index}`"
                  >
                    <img src="@/assets/clip.svg" />
                    <p>Attachment</p>
                  </label>
                  <input
                    style="opacity: 0"
                    type="file"
                    :id="`file-input80DDB${slotprops.value.index}`"
                    name="attachment"
                    @change="
                      uploadAttachments(
                        $event.target.files,
                        slotprops.value.record,
                        slotprops.value.index,
                        'deduction_under_chapter_VI_A_80DDB'
                      )
                    "
                  />
                </button>
                <p v-if="slotprops.value.column.key == 'proof' && !slotprops.value.record.file_location && slotprops.value.record.actual" style="font-size:small;color:red;">Document is Mandatory</p>

                <span
                  style="display: flex; gap: 5px; width: 9rem"
                  v-if="slotprops.value.column.key == 'status'"
                  :disabled="slotprops.value.record.status == 'Approved'"
                >
                <img
                    style="width: 1rem; height: 1rem"
                    v-if="slotprops.value.record.status == 'Approved'"
                    src="@/assets/approved.png"
                  />
                  <img
                    style="width: 1rem; height: 1rem"
                    v-if="slotprops.value.record.status == 'Pending'"
                    src="@/assets/pending.svg"
                  />
                  <img
                    style="width: 1rem; height: 1rem"
                    v-if="slotprops.value.record.status == 'rejected'"
                     src="@/assets/rejected.png"
                  />
                  <img
                    style="width: 1rem; height: 1rem"
                    v-if="slotprops.value.record.status == 'partially_approved'"
                    src="@/assets/approved.png"
                  />
                  <span>{{ slotprops.value.record.status }}</span>
                </span>
                <span :disabled="slotprops.value.record.status == 'Approved'" :title="slotprops.value.record.remarks" v-if="slotprops.value.column.key == 'remarks'">
                  {{ slotprops.value.record.remarks }}
                </span>
              </template>
            </itProof-submit-dataTable>
             <itProof-submit-dataTable 
              v-if="deduction_under_80G_table_columns_data  && deduction_under_80G_table_columns_data.length > 0"
              :disabled="((releaseForEmployees||dateCheck==false))" 
              :tableColumsHeader="deduction_under_80G_table_colums_header"
              :tableColumnsData="deduction_under_80G_table_columns_data"
            >
              <template v-slot="slotprops">
                <span
                  style="display: flex; gap: 20px"
                  v-if="slotprops.value.column.key == '80Gparticulars'"
                >
                  <span style="width: 12rem">{{
                    slotprops.value.record.name||slotprops.value.record["InvestmentComponentType"]["name"]
                  }}</span>
                  
                </span>
                <span
                  style="width: 10rem"
                  v-if="slotprops.value.column.key == 'declaredAmount'"
                >
                  {{ slotprops.value.record.planned }}
                </span>
                <txt
                  @blur="uploadValidation('deduction_under_chapter_VI_A_80G')"
                  v-if="slotprops.value.column.key == 'submittedAmount'"
                  style="width: 14rem"
                  type="number"
                  @Change="
                    (value) => {
                      slotprops.value.record.actual = value;
                    }
                  "
                  v-model="slotprops.value.record.actual"
                >
                </txt>
                <p v-if="slotprops.value.column.key == 'submittedAmount' && slotprops.value.record.file_location && !slotprops.value.record.actual" style="font-size:small;color:red;">Field is mandatory for Document submitted</p>

                <span
                  style="width: 7rem"
                  v-if="slotprops.value.column.key == 'verifiedAmount'"
                >
                  {{ slotprops.value.record.approved }}
                </span>
                <button
                  style="width: 12rem; background-color: #e3c449"
                  @click="
                    show_pop_up(
                      slotprops.value.record,
                      'deduction_under_80G',
                      slotprops.value.index
                    )
                  "
                  v-if="
                    slotprops.value.column.key == 'proof' &&
                    slotprops.value.record.file_location
                  "
                  class="export-button"
                >
                  <img src="@/assets/clip.svg" />
                  <label style="cursor: pointer">View Attachment</label>
                </button>
                <button
                  style="width: 12rem; cursor: default"
                  v-if="
                    slotprops.value.column.key == 'proof' &&
                    !slotprops.value.record.file_location
                  "
                  class="export-button"
                  :disabled="!slotprops.value.record.actual"
                >
                  <label
                    class="input-label"
                    :for="`file-input80G${slotprops.value.index}`"
                  >
                    <img src="@/assets/clip.svg" />
                    <p>Attachment</p>
                  </label>
                  <input
                    style="opacity: 0"
                    type="file"
                    :id="`file-input80G${slotprops.value.index}`"
                    name="attachment"
                    @change="
                      uploadAttachments(
                        $event.target.files,
                        slotprops.value.record,
                        slotprops.value.index,
                        'deduction_under_chapter_VI_A_80G'
                      )
                    "
                  />
                </button>
                <p v-if="slotprops.value.column.key == 'proof' && !slotprops.value.record.file_location && slotprops.value.record.actual" style="font-size:small;color:red;">Document is Mandatory</p>

                <span
                  style="display: flex; gap: 5px; width: 9rem"
                  v-if="slotprops.value.column.key == 'status'"
                >
                <img
                    style="width: 1rem; height: 1rem"
                    v-if="slotprops.value.record.status == 'Approved'"
                    src="@/assets/approved.png"
                  />
                  <img
                    style="width: 1rem; height: 1rem"
                    v-if="slotprops.value.record.status == 'Pending'"
                    src="@/assets/pending.svg"
                  />
                  <img
                    style="width: 1rem; height: 1rem"
                    v-if="slotprops.value.record.status == 'rejected'"
                     src="@/assets/rejected.png"
                  />
                  <img
                    style="width: 1rem; height: 1rem"
                    v-if="slotprops.value.record.status == 'partially_approved'"
                    src="@/assets/approved.png"
                  />
                  <span v-if="(slotprops.value.record.status == 'rejected') && (slotprops.value.record.remarks)">{{ slotprops.value.record.status}}</span>
                  <span v-if="(slotprops.value.record.status == 'rejected') && (!slotprops.value.record.remarks)">Not Submitted</span>
                  <span v-if="(slotprops.value.record.status !== 'rejected')">{{ slotprops.value.record.status }}</span>
                </span>
                <span :title="slotprops.value.record.remarks" v-if="slotprops.value.column.key == 'remarks'">
                  {{ slotprops.value.record.remarks }}
                </span>
              </template>
            </itProof-submit-dataTable>

            <itProof-submit-dataTable
              :disabled="(releaseForEmployees||dateCheck==false)"
              :tableColumsHeader="deduction_under_80U_table_colums_header"
              :tableColumnsData="deduction_under_80U_table_columns_data"
            >
              <template v-slot="slotprops">
                <span
                  style="display: flex; gap: 20px"
                  v-if="slotprops.value.column.key == '80Uparticulars'"
                  :disabled="slotprops.value.record.status == 'Approved' || finalizedSubmitFlag"
                >
                  <span style="width: 12rem">{{
                    slotprops.value.record.name||slotprops.value.record["InvestmentComponentType"]["name"]
                  }}</span>
                  <!-- <img
                    style="cursor: pointer"
                   :title="getTitleName(slotprops.value.record)"
                    src="@/assets/info-black.svg"
                  /> -->
                </span>
                <span
                  style="width: 10rem"
                  v-if="slotprops.value.column.key == 'declaredAmount'"
                  :disabled="slotprops.value.record.status == 'Approved' || finalizedSubmitFlag"
                >
                  {{ slotprops.value.record.planned }}
                </span>
                <txt
                  @blur="uploadValidation('deduction_under_chapter_VI_A_80U')"
                  v-if="slotprops.value.column.key == 'submittedAmount'"
                  style="width: 14rem"
                  :disabled="finalizedSubmitFlag || isDisabilityFieldDisabled(slotprops.value.record)"
                  type="number"
                  @Change="
                    (value) => {
                      slotprops.value.record.actual = value;
                    }
                  "
                  v-model="slotprops.value.record.actual"
                >
                </txt>
                <p v-if="slotprops.value.column.key == 'submittedAmount' && slotprops.value.record.file_location && !slotprops.value.record.actual" style="font-size:small;color:red;">Field is mandatory for Document submitted</p>

                <span
                  style="width: 7rem"
                  v-if="slotprops.value.column.key == 'verifiedAmount'"
                  :disabled="slotprops.value.record.status == 'Approved' || finalizedSubmitFlag"
                >
                  {{ slotprops.value.record.approved }}
                </span>
                <button
                  style="width: 12rem; background-color: #e3c449"
                  @click="
                    show_pop_up(
                      slotprops.value.record,
                      'deduction_under_80U',
                      slotprops.value.index
                    )
                  "
                  v-if="
                    slotprops.value.column.key == 'proof' &&
                    slotprops.value.record.file_location
                  "
                  :disabled="slotprops.value.record.status == 'Approved'"
                  class="export-button"
                >
                  <img src="@/assets/clip.svg" />
                  <label style="cursor: pointer">View Attachment</label>
                </button>
                <button
                  style="width: 12rem; cursor: default"
                  v-if="
                    slotprops.value.column.key == 'proof' &&
                    !slotprops.value.record.file_location
                  "
                 
                  class="export-button"
                  :disabled="!slotprops.value.record.actual ||slotprops.value.record.status == 'Approved' || finalizedSubmitFlag"
                >
                  <label
                    class="input-label"
                    :for="`file-input80U${slotprops.value.index}`"
                  >
                    <img src="@/assets/clip.svg" />
                    <p>Attachment</p>
                  </label>
                  <!-- <img src="@/assets/clip.svg" />
                  <p>Attachment</p> -->
                  <input
                    style="opacity: 0"
                    type="file"
                    :id="`file-input80U${slotprops.value.index}`"
                    name="attachment"
                    @change="
                      uploadAttachments(
                        $event.target.files,
                        slotprops.value.record,
                        slotprops.value.index,
                        'deduction_under_chapter_VI_A_80U'
                      )
                    "
                  />
                </button>
                <p v-if="slotprops.value.column.key == 'proof' && !slotprops.value.record.file_location && slotprops.value.record.actual" style="font-size:small;color:red;">Document is Mandatory</p>

                <span
                  style="display: flex; gap: 5px; width: 9rem"
                  v-if="slotprops.value.column.key == 'status'"
                  :disabled="slotprops.value.record.status == 'Approved'"
                >
                <img
                    style="width: 1rem; height: 1rem"
                    v-if="slotprops.value.record.status == 'Approved'"
                    src="@/assets/approved.png"
                  />
                  <img
                    style="width: 1rem; height: 1rem"
                    v-if="slotprops.value.record.status == 'Pending'"
                    src="@/assets/pending.svg"
                  />
                  <img
                    style="width: 1rem; height: 1rem"
                    v-if="slotprops.value.record.status == 'rejected'"
                     src="@/assets/rejected.png"
                  />
                  <img
                    style="width: 1rem; height: 1rem"
                    v-if="slotprops.value.record.status == 'partially_approved'"
                    src="@/assets/approved.png"
                  />
                  <span v-if="(slotprops.value.record.status == 'rejected') && (slotprops.value.record.remarks)">{{ slotprops.value.record.status}}</span>
                  <span v-if="(slotprops.value.record.status == 'rejected') && (!slotprops.value.record.remarks)">Not Submitted</span>
                  <span v-if="(slotprops.value.record.status !== 'rejected')">{{ slotprops.value.record.status }}</span>
                </span>
                <span :disabled="slotprops.value.record.status == 'Approved'" :title="slotprops.value.record.remarks" v-if="slotprops.value.column.key == 'remarks'">
                  {{ slotprops.value.record.remarks }}
                </span>
              </template>
            </itProof-submit-dataTable>
            <itProof-submit-dataTable
              :disabled="(releaseForEmployees||dateCheck==false)"
              :tableColumsHeader="deduction_under_others_table_colums_header"
              :tableColumnsData="deduction_under_others_table_columns_data"
            >
              <template v-slot="slotprops">
                <span
                  style="display: flex; gap: 20px"
                  v-if="slotprops.value.column.key == 'particulars'"
                  :disabled="slotprops.value.record.status == 'Approved' || finalizedSubmitFlag"
                >
                <span v-if="slotprops.value.record.name == 'Interest from Savings Bank Account' || slotprops.value.record.InvestmentComponentType.name == 'Interest from Savings Bank Account' " style="width: 12rem">
                    80TTA - Interest from Savings Bank Account
                  </span>
                  <span v-else-if="slotprops.value.record.name == 'Interest from Savings Bank Account - Sr Citizens' || slotprops.value.record.InvestmentComponentType.name == 'Interest from Savings Bank Account - Sr Citizens' " style="width: 12rem">
                    80TTB - Interest from Savings Bank Account - Sr Citizens
                  </span>
                
                  <span v-else style="width: 12rem">{{
                    slotprops.value.record.name||slotprops.value.record["InvestmentComponentType"]["name"]
                  }}</span>
                  <img
                    style="cursor: pointer"
                    src="@/assets/info-black.svg"
                    @click="show6APopup(slotprops.value.record.InvestmentComponentType.name)"
                  />
                </span>
                <span
                  style="width: 10rem"
                  v-if="slotprops.value.column.key == 'declaredAmount'"
                  :disabled="slotprops.value.record.status == 'Approved' || finalizedSubmitFlag"
                >
                  {{ slotprops.value.record.planned }}
                </span>
                <txt
                  v-if="slotprops.value.column.key == 'submittedAmount'"
                  :disabled="slotprops.value.record.status == 'Approved' || finalizedSubmitFlag || isOtherFieldDisabled(slotprops.value.record)"
                  @blur="uploadValidation('deduction_under_chapter_VI_A_others')"
                  style="width: 14rem"
                  type="number"
                  @Change="
                    (value) => {
                      slotprops.value.record.actual = value;
                    }
                  "
                  v-model="slotprops.value.record.actual"
                >
                </txt>
                <p v-if="slotprops.value.column.key == 'submittedAmount' && slotprops.value.record.file_location && !slotprops.value.record.actual" style="font-size:small;color:red;">Field is mandatory for Document submitted</p>

                <span
                  style="width: 7rem"
                  v-if="slotprops.value.column.key == 'verifiedAmount'"
                  :disabled="slotprops.value.record.status == 'Approved' || finalizedSubmitFlag"
                >
                  {{ slotprops.value.record.approved }}
                </span>
                 <button
                  style="width: 12rem; background-color: #e3c449"
                  @click="
                    show_pop_up(
                      slotprops.value.record,
                      'deduction_under_others',
                      slotprops.value.index
                    )
                  "
                  v-if="
                    slotprops.value.column.key == 'proof' &&
                    slotprops.value.record.file_location
                  "
                  :disabled="slotprops.value.record.status == 'Approved'||slotprops.value.record.status == 'Approved'"
                  class="export-button"
                >
                  <img src="@/assets/clip.svg" />
                  <label style="cursor: pointer">View Attachment</label>
                </button>
                <button
                  style="width: 12rem; cursor: default"
                  v-if="
                    slotprops.value.column.key == 'proof' &&
                    !slotprops.value.record.file_location
                  "
                  
                  class="export-button"
                  :disabled="!slotprops.value.record.actual ||slotprops.value.record.status == 'Approved' || finalizedSubmitFlag"
                >
                  <label
                    class="input-label"
                    :for="`file-input80E${slotprops.value.index}`"
                  >
                    <img src="@/assets/clip.svg" />
                    <p>Attachment</p>
                  </label>
                  <input
                    style="opacity: 0"
                    type="file"
                    :id="`file-input80E${slotprops.value.index}`"
                    name="attachment"
                    @change="
                      uploadAttachments(
                        $event.target.files,
                        slotprops.value.record,
                        slotprops.value.index,
                        'deduction_under_chapter_VI_A_others'
                      )
                    "
                  />
                </button>
                <p v-if="slotprops.value.column.key == 'proof' && !slotprops.value.record.file_location && slotprops.value.record.actual" style="font-size:small;color:red;">Document is mandatory</p>

                <span
                  style="display: flex; gap: 5px; width: 9rem"
                  v-if="slotprops.value.column.key == 'status'"
                  :disabled="slotprops.value.record.status == 'Approved' "
                >
                <img
                    style="width: 1rem; height: 1rem"
                    v-if="slotprops.value.record.status == 'Approved'"
                    src="@/assets/approved.png"
                  />
                  <img
                    style="width: 1rem; height: 1rem"
                    v-if="slotprops.value.record.status == 'Pending'"
                    src="@/assets/pending.svg"
                  />
                  <img
                    style="width: 1rem; height: 1rem"
                    v-if="slotprops.value.record.status == 'rejected'"
                     src="@/assets/rejected.png"
                  />
                  <img
                    style="width: 1rem; height: 1rem"
                    v-if="slotprops.value.record.status == 'partially_approved'"
                    src="@/assets/approved.png"
                  />
                  <span v-if="(slotprops.value.record.status == 'rejected') && (slotprops.value.record.remarks)">{{ slotprops.value.record.status}}</span>
                  <span v-if="(slotprops.value.record.status == 'rejected') && (!slotprops.value.record.remarks)">Not Submitted</span>
                  <span v-if="(slotprops.value.record.status !== 'rejected')">{{ slotprops.value.record.status }}</span>
                </span>
                <span :disabled="slotprops.value.record.status == 'Approved'" :title="slotprops.value.record.remarks" v-if="slotprops.value.column.key == 'remarks'">
                  {{ slotprops.value.record.remarks }}
                </span>
              </template>
            </itProof-submit-dataTable>
          </template>
          <template v-slot:bottom>
            <footer>
              <popup-bottom-container>
                <template>
                  <div style="display: flex; flex-direction: column">
                    <p style="font-size: large; font-weight: 700">
                      General Remarks
                    </p>
                    <p>
                      IncomeTax proof Submission window will be closing soon
                    </p>
                  </div>
                </template>
                <template slot="end">
                  <btn-grp class="form-button">
                    <btn
                      text="Cancel"
                      type="secondary"
                      @click="
                        showPopupDeductionUnderCdeu =
                          !showPopupDeductionUnderCdeu;toast=false;getItSubmissionData()
                      "
                    />
                    <btn
                       v-show="incomeTaxProofSubmittedFlag"
                      :disabled="!incomeTaxProofSubmittedFlag ||(releaseForEmployees||dateCheck==false)"
                      text="Save as Draft"
                      type="primary"
                      @click="saveDataForFinalArray('deduction_under_6A')"
                    />
                  </btn-grp>
                </template>
              </popup-bottom-container>
            </footer>
          </template>
        </pop-up-window-lg>
        <pop-up-window-lg
          v-if="showPopupUnder80D"
          @back="showPopupUnder80D = !showPopupUnder80D;toast=false;options_for_6a_family_dependant =employeeFamilyDetails[0].details"
          :header="pop_up_header_80D"
        >
             
          <template v-slot:content>
             <toast-message
            :message="errmsg"
            type="error"
            :isToastEnable="toast"
            @close="(val) => (toast = val)"
          />
            <itProof-submit-dataTable
              :disabled="!incomeTaxProofSubmittedFlag"
              :tableColumsHeader="permanent_disability_under_80D_header"
              :tableColumnsData="deduction_under_80D_pop_up"
            >
              <template v-slot="slotprops">
                <tl-select
                   v-if="slotprops.value.column.key == 'name'"
                  labelText="name"
                  :options="options_for_6a_family_dependant"
                  placeholder="Select"
                  v-model="slotprops.value.record.name"
                  @change="
                    (val) => {
                      relationChange(val, slotprops.value.index,'80_d_popup')
                    }
                  "
                />
                <txt
                    v-if="slotprops.value.column.key == 'relationship'"
                  type="text"
                  v-model="slotprops.value.record.relationShip"
                >
                </txt>
                <txt
                    v-if="slotprops.value.column.key == 'amount'"
                  type="number"
                  @change="(value) => (slotprops.value.record.amount = value)"
                  v-model="slotprops.value.record.amount "
                >
                </txt>
                <button
                  class="delete-btn"
                  v-if="
                    slotprops.value.column.key == 'delete' &&
                    slotprops.value.index > 0
                  "
                  @click="
                    () => {
                      deleteRow(
                        'deduction_under_6a_80D',
                        slotprops.value.index
                      );
                    }
                  "
                >
                  Delete
                </button>
              </template>
            </itProof-submit-dataTable>
            <div class="row margin-t-m margin-b-l">
              <div class="col-12">
                <div
                  class="row-container"
                  style="display: flex; justify-content: right"
                >
                  <img src="@/assets/group-5.svg" class="Group-5" />
                  <button
                    class="text-green"
                    @click="
                      addMoreRow(
                        'deduction_under_6a_80D',
                        pop_up_header_80D
                      )
                    "
                  >
                    Add More Row
                  </button>
                </div>
              </div>
            </div>
          </template>
          <template v-slot:bottom>
            <footer>
              <popup-bottom-container>
                <template slot="end">
                  <btn-grp class="form-button">
                    <btn
                      text="Cancel"
                      type="secondary"
                      @click="showPopupUnder80D = !showPopupUnder80D;toast=false;options_for_6a_family_dependant =employeeFamilyDetails[0].details"
                    />
                    <btn
                      v-show="incomeTaxProofSubmittedFlag"
                      text="Save"
                      type="primary"
                      @click="
                        function_from_chapter6a_popup(
                          pop_up_header_80D,
                          'pop_up_80d'
                        )
                      "
                    />
                  </btn-grp>
                </template>
              </popup-bottom-container>
            </footer>
          </template>
        </pop-up-window-lg>
        <pop-up-window-lg
          v-if="showPopupUnder80DD"
          @back="showPopupUnder80DD = !showPopupUnder80DD;toast=false;options_for_6a_family_dependant =employeeFamilyDetails[0].details"
          :header=pop_up_80DD_header
        >
          <template v-slot:content>
            <toast-message
                    :message="errmsg"
                    type="error"
                    :isToastEnable="toast"
                    @close="(val) => (toast = val)"
                 />
            <itProof-submit-dataTable
              :disabled="!incomeTaxProofSubmittedFlag"
              :tableColumsHeader="permanent_disability_under_80D_header"
              :tableColumnsData="deduction_under_80DD_pop_up"
            >
            <template v-slot="slotprops">
                  
                <tl-select
                  v-if="slotprops.value.column.key == 'name'"
                  labelText="name"
                  :options="options_for_6a_family_dependant"
                  placeholder="Select"
                  v-model="slotprops.value.record.name"
                  @change="
                    (val) => {
                      relationChange(val, slotprops.value.index,'80_dd_popup')
                    }
                  "
                />
                <txt
                  v-if="slotprops.value.column.key == 'relationship'"
                  type="text"
                  v-model="slotprops.value.record.relationShip"
                >
                </txt>
                <txt
                  v-if="slotprops.value.column.key == 'amount'"
                  type="number"
                  @change="(value) => (slotprops.value.record.amount = value)"
                  v-model="slotprops.value.record.amount"
                >
                </txt>
                <button
                  class="delete-btn"
                  v-if="
                    slotprops.value.column.key == 'delete' &&
                    slotprops.value.index > 0
                  "
                  @click="
                    () => {
                      deleteRow(
                        'deduction_under_6a_80DD',
                        slotprops.value.index
                      );
                    }
                  "
                >
                  Delete
                </button>
              </template>
            </itProof-submit-dataTable>
            <div class="row margin-t-m margin-b-l">
              <div class="col-12">
                <div
                  class="row-container"
                  style="display: flex; justify-content: right"
                >
                  <img src="@/assets/group-5.svg" class="Group-5" />
                  <button
                    class="text-green"
                    @click="
                      addMoreRow(
                        'deduction_under_6a_80DD',
                        pop_up_80DD_header
                      )
                    "
                  >
                    Add More Row
                  </button>
                </div>
              </div>
            </div>
          </template>
          <template v-slot:bottom>
            <footer>
              <popup-bottom-container>
                <template slot="end">
                  <btn-grp class="form-button">
                    <btn
                      text="Cancel"
                      type="secondary"
                      @click="showPopupUnder80DD = !showPopupUnder80DD;toast=false;options_for_6a_family_dependant =employeeFamilyDetails[0].details"
                    />
                    <btn
                      v-show="incomeTaxProofSubmittedFlag"
                      text="Save"
                      type="primary"
                      @click="
                        function_from_chapter6a_popup(
                          pop_up_80DD_header,
                          'pop_up_80dd'
                        )
                      "
                    />
                  </btn-grp>
                </template>
              </popup-bottom-container>
            </footer>
          </template>
        </pop-up-window-lg>
        <pop-up-window-lg
          v-if="showPopupUnder80DDB"
          @back="showPopupUnder80DDB = !showPopupUnder80DDB;toast=false;options_for_6a_family_dependant =employeeFamilyDetails[0].details"
          :header=pop_up_80DDB_header
        >
          <template v-slot:content>
            <toast-message
                    :message="errmsg"
                    type="error"
                    :isToastEnable="toast"
                    @close="(val) => (toast = val)"
                 />
            <itProof-submit-dataTable
              :disabled="!incomeTaxProofSubmittedFlag"
              :tableColumsHeader="permanent_disability_under_80DDB_header"
              :tableColumnsData="deduction_under_80DDB_pop_up_data"
            >
            <template v-slot="slotprops">
                <tl-select
                  v-if="slotprops.value.column.key == 'name'"
                  labelText="name"
                   :options="options_for_6a_family_dependant"
                  placeholder="Select"
                  v-model="slotprops.value.record.name"
                  @change="
                    (val) => {
                      relationChange(val, slotprops.value.index,'80_ddb_popup')
                    }
                  "
                />
                <txt
                  v-if="slotprops.value.column.key == 'relationship'"
                  type="text"
                  v-model="slotprops.value.record.relationShip"
                >
                </txt>
                <txt
                  v-if="slotprops.value.column.key == 'amount'"
                  type="number"
                  @change="(value) => (slotprops.value.record.amount = value)"
                  v-model="slotprops.value.record.amount"
                >
                </txt>
                <button
                  class="delete-btn"
                  v-if="
                    slotprops.value.column.key == 'delete' &&
                    slotprops.value.index > 0
                  "
                  @click="
                    () => {
                      deleteRow(
                        'deduction_under_6a_80DDB',
                        slotprops.value.index
                      );
                    }
                  "
                >
                  Delete
                </button>
              </template>
            </itProof-submit-dataTable>
            <div class="row margin-t-m margin-b-l">
              <div class="col-12">
                <div
                  class="row-container"
                  style="display: flex; justify-content: right"
                >
                  <img src="@/assets/group-5.svg" class="Group-5" />
                  <button
                    class="text-green"
                    @click="
                      addMoreRow(
                        'deduction_under_6a_80DDB',
                        pop_up_80DDB_header
                      )
                    "
                  >
                    Add More Row
                  </button>
                </div>
              </div>
            </div>
          </template>
          <template v-slot:bottom>
            <footer>
              <popup-bottom-container>
                <template slot="end">
                  <btn-grp class="form-button">
                    <btn
                      text="Cancel"
                      type="secondary"
                      @click="showPopupUnder80DDB = !showPopupUnder80DDB;toast=false;options_for_6a_family_dependant =employeeFamilyDetails[0].details"
                    />
                    <btn
                     v-show="incomeTaxProofSubmittedFlag"
                       text="Save"
                      type="primary"
                      @click="
                        function_from_chapter6a_popup(
                          pop_up_80DDB_header,
                          'pop_up_80ddb'
                        )
                      "
                    />
                  </btn-grp>
                </template>
              </popup-bottom-container>
            </footer>
          </template>
        </pop-up-window-lg>
        <div
          v-show="!regime_type"
          class="pl-0 cursor-point"
          @click="
            showPopupIncomeLossFromHousingPropertyNewRegime =
              !showPopupIncomeLossFromHousingPropertyNewRegime;toast=false
          "
        >
          <div class="row col-bg-gray">
            <div class="col-3 img-block">
              <img src="@/assets/incomeLossFromHousingProperty.svg" />
            </div>
            <div class="col-7 img-block">
              <div class="heading-text">Income/Loss from Housing Property</div>
              <div class="sub-heading-details-sm">
                A taxpayer can claim deduction under Section 24 of interest paid
                on home loan for each of the houses separately.
              </div>
            </div>
            <div class="col-2 arrow-left-align">
              <img class="arrow-icon-it" src="@/assets/arrow_purple_new.svg" />
            </div>
          </div>
        </div>
        <pop-up-window-lg
          v-if="showPopupIncomeLossFromHousingPropertyNewRegime"
          @back="
            showPopupIncomeLossFromHousingPropertyNewRegime =
              !showPopupIncomeLossFromHousingPropertyNewRegime;toast=false;getItSubmissionData()
          "
          header="Income/Loss from Housing Property"
        >
          <template v-slot:content>
             <toast-message
      :message="errmsg"
      type="error"
      :isToastEnable="toast"
      @close="(val) => (toast = val)"
    />
            <itProof-submit-dataTable
              :disabled="(releaseForEmployees||dateCheck==false)"
              :tableColumsHeader="incomeLossTableColumsHeaderTwo"
              :tableColumnsData="income_loss_from_house_table_columns_data_two.letout"
            >
              <template v-slot="slotprops">
                <div :disabled="slotprops.value.record.status == 'Approved'">
                <span
                :disabled = "finalizedSubmitFlag"
                  style="display: flex; gap: 20px"
                  v-if="slotprops.value.column.key == 'income/lossOnHouse'"
                >
                  <!-- <span style="width: 12rem">{{
                    slotprops.value.record.name == 'Current Year Interest'? 'Current Financial Year Interest':slotprops.value.record.name 
                  }}</span> -->
                  <!-- <img
                    style="cursor: pointer"
                    :title="getTitleName(slotprops.value.record)"
                    src="@/assets/info-black.svg"
                  /> -->
                  <span v-if="slotprops.value.record.name == 'Current Year Interest'" style="width: 12rem">
                   Current Financial Year Interest
                  </span>
                  <span v-else-if="slotprops.value.record.name == 'A Total rent received by employee'" style="width: 12rem">
                  A Annual Rent Received By Employee
                  </span>
                  <span v-else style="width: 12rem">{{
                    slotprops.value.record.name 
                  }}</span>
                </span>
                <span
                  :disabled = "finalizedSubmitFlag"
                  style="width: 10rem"
                  v-if="slotprops.value.column.key == 'declaredAmount'"
                >
                  {{ slotprops.value.record.planned }}
                </span>
                <txt
                  v-if="slotprops.value.column.key == 'submittedAmount'"
                  style="width: 14rem"
                  type="number"
                  :disabled="slotprops.value.record.isDisabled || finalizedSubmitFlag"
                   @change="
                      (val) => {
                        
                            slotprops.value.record.actual = val;
                        calculate(slotprops.value.record.index)
                        
                        
                      }
                    "
                  
                  v-model="slotprops.value.record.actual"
                >
                <p v-if="slotprops.value.column.key == 'submittedAmount' && income_loss_from_house_table_columns_data_two.letout[0].file_location && income_loss_from_house_table_columns_data_two.letout[0].actual && slotprops.value.index==0" style="font-size:small;color:red;">Field is Mandatory for Submitted Document</p>
                </txt>
                <span
                  :disabled = "finalizedSubmitFlag"
                  style="width: 7rem"
                  v-if="slotprops.value.column.key == 'verifiedAmount'"
                >
                  {{ slotprops.value.record.approved }}
                </span>
                <button
                  style="width: 12rem; background-color: #e3c449"
                  @click="
                    show_pop_up(
                      slotprops.value.record,
                      'income_loss_letout',
                      slotprops.value.index
                    )
                  "
                  v-if="
                    slotprops.value.record.name == 'Current Year Interest' &&
                    slotprops.value.column.key == 'proof' &&
                    slotprops.value.record.file_location
                  "
                  class="export-button"
                >
                  <img src="@/assets/clip.svg" />
                  <label style="cursor: pointer">View Attachment</label>
                </button>
                <button
                  style="width: 12rem; cursor: default"
                  v-if="
                    slotprops.value.record.name == 'Current Year Interest' &&
                    slotprops.value.column.key == 'proof' &&
                    !slotprops.value.record.file_location
                  "
                  class="export-button"
                  :disabled="(!slotprops.value.record.actual > 0)?true:false || (slotprops.value.index > 0) ? true:false || finalizedSubmitFlag"
                >
                  <label
                    class="input-label"
                    :for="`file-inputSelf${slotprops.value.index}`"
                  >
                    <img src="@/assets/clip.svg" />
                    <p>Attachment</p>
                  </label>
                  <input
                    style="opacity: 0"
                    type="file"
                    :id="`file-inputSelf${slotprops.value.index}`"
                    name="attachment"
                    @change="
                      uploadAttachments(
                        $event.target.files,
                        slotprops.value.record,
                        slotprops.value.index,
                        'income_loss_letout_property'
                      )
                    "
                  />
                </button>
                <p v-if="slotprops.value.column.key == 'proof' && !slotprops.value.record.file_location && slotprops.value.record.actual && slotprops.value.index==0" style="font-size:small;color:red;">Document is Mandatory</p>

                <span
                  style="display: flex; gap: 5px; width: 9rem"
                  v-if="slotprops.value.column.key == 'status'"
                >
                <img
                    style="width: 1rem; height: 1rem"
                    v-if="slotprops.value.record.status == 'Approved'"
                    src="@/assets/approved.png"
                  />
                  <img
                    style="width: 1rem; height: 1rem"
                    v-if="slotprops.value.record.status == 'Pending'"
                    src="@/assets/pending.svg"
                  />
                  <img
                    style="width: 1rem; height: 1rem"
                    v-if="slotprops.value.record.status == 'rejected'"
                     src="@/assets/rejected.png"
                  />
                  <img
                    style="width: 1rem; height: 1rem"
                    v-if="slotprops.value.record.status == 'partially_approved'"
                    src="@/assets/approved.png"
                  />
                  <span>{{ slotprops.value.record.status }}</span>
                </span>
                <span :title="slotprops.value.record.remarks" v-if="slotprops.value.column.key == 'remarks'">
                  {{ slotprops.value.record.remarks }}
                </span>
                </div>
              </template>
            </itProof-submit-dataTable>
            <div
              style="
                display: flex;
                justify-content: space-between;
                padding: 15px 30px;
              "
            >
              <div>
                <div style="margin-bottom: 20px">
                <label>
                  <input 
                    type="checkbox" 
                    v-model="showDivforNewRegime" 
                  />
                  Joint Declaration Applicable
                </label>
              </div>
                <div
                  v-if="showDivforNewRegime"
                  v-for="(
                    value, index
                  ) in income_loss_from_house_table_columns_data_letout_joint_Property"
                  :key="index"
                  style="
                    display: flex;
                    justify-content: space-between;
                    gap: 20px;
                    padding: 15px 0;
                  "
                >
                  <div style="display: flex; align-items: center">
                    <span style="width: 12rem"
                      >Self-Declaration for joint property</span
                    >
                    <!-- <img
                      style="cursor: pointer; height: 1.5rem"
                      title="information about icon for the arrangements of somethig"
                      src="@/assets/info-black.svg"
                    /> -->
                  </div>
                  <!-- <div style="display: flex; flex-direction: column; gap: 10px">
                       <span>Name Of Joint Holder</span>
                    <txt
                      style="width: 20rem"
                      type="text"
                      v-model="
                        income_loss_from_house_table_columns_data_letout_joint_Property[index]
                          .joint_holder_name
                      "
                      @change="
                        (value) => {
                          income_loss_from_house_table_columns_data_letout_joint_Property[
                            index
                          ].name = value;
                        }
                      "
                    ></txt>
                  </div>
                  <div style="display: flex; flex-direction: column; gap: 10px">
                    <span>Relationship</span>
                    <txt
                      style="width: 20rem"
                      type="text"
                      v-model="
                        income_loss_from_house_table_columns_data_letout_joint_Property[index]
                          .relationship
                      "
                      @change="
                        (value) => {
                          income_loss_from_house_table_columns_data_letout_joint_Property[
                            index
                          ].relationship = value;
                        }
                      "
                    ></txt>
                  </div> -->
               <div style="display: flex; flex-direction: column; row-gap: 4px">
                       <span>Name Of Joint Holder</span>      
                      <tl-select
                        style="width: 20rem"
                        labelText="name"
                        :options="options_for_6a_family_dependant"
                        placeholder="Select"
                        v-model="income_loss_from_house_table_columns_data_letout_joint_Property[index]
                                .joint_holder_name"
                        @change="
                          (value) => {
                                income_loss_from_house_table_columns_data_letout_joint_Property[
                                  index
                                ].name = value.name;
                                income_loss_from_house_table_columns_data_letout_joint_Property[
                                  index
                                ].relationship = value.relationship;

                          }
                        "
                      />
                </div>  
                <div style="display: flex; flex-direction: column; gap: 10px">
                       <span>Relationship</span>      
                        <txt
                          type="text"
                          v-model="income_loss_from_house_table_columns_data_letout_joint_Property[index]
                                  .relationship"
                        >
                        </txt>
                </div>
                  <div style="display: flex; flex-direction: column; gap: 10px">
                    <span>% of tax benefit claimed by joint holder</span>
                    <txt
                      style="width: 20rem"
                      type="number"
                      :disabled="!isJointHolderAndRelationshipFilledforLetOutinNewRegime(index)"
                      v-model="
                        income_loss_from_house_table_columns_data_letout_joint_Property[index]
                          .tax_benefit
                      "
                      @change="
                        (value) => {
                          // income_loss_from_house_table_columns_data_letout_joint_Property[
                          //   index
                          // ].tax_benefit = value;
                        checkLetOutJointHolder(Number(value),index)

                        }
                      "
                    ></txt>
                  </div>
                  <button
                    class="delete-btn"
                    v-if="
                      income_loss_from_house_table_columns_data_letout_joint_Property.length > 1
                    "
                    @click="
                      () => {
                        deleteRow('income_loss_letout', index);
                      }
                    "
                  >
                    Delete
                  </button>
                </div>
              </div>
              <div class="row margin-t-m margin-b-l">
                <div class="col-12">
                  <div
                    v-if="showDivforNewRegime"
                    class="row-container"
                    style="display: flex; justify-content: right"
                  >
                    <img src="@/assets/group-5.svg" class="Group-5" />
                    <button
                      class="text-green"
                      @click="addMoreRow('income_loss_letout')"
                    >
                      Add More
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </template>
          <template v-slot:bottom>
            <footer>
              <popup-bottom-container>
                <template>
                  <div style="display: flex; flex-direction: column">
                    <p style="font-size: large; font-weight: 700">
                      General Remarks
                    </p>
                    <p>
                      IncomeTax proof Submission window will be closing soon
                    </p>
                  </div>
                </template>
                <template slot="end">
                  <btn-grp class="form-button">
                    <btn text="Cancel" type="secondary" @click="
                    showPopupIncomeLossFromHousingPropertyNewRegime =
                     !showPopupIncomeLossFromHousingPropertyNewRegime;toast=false;getItSubmissionData()
                   " />
                    <btn
                      v-show="incomeTaxProofSubmittedFlag"
                      :disabled="!incomeTaxProofSubmittedFlag ||(releaseForEmployees||dateCheck==false)"
                      text="Save as Draft"
                      type="primary"
                      @click="saveDataForFinalArray('income_loss_property')"
                    />
                  </btn-grp>
                </template>
              </popup-bottom-container>
            </footer>
          </template>
        </pop-up-window-lg>
        <div
          v-show="regime_type"
          class="pl-0 cursor-point"
          @click="
            showPopupIncomeLossFromHousingProperty =
              !showPopupIncomeLossFromHousingProperty;toast=false
          "
        >
          <div class="row col-bg-gray">
            <div class="col-3 img-block">
              <img src="@/assets/incomeLossFromHousingProperty.svg" />
            </div>
            <div class="col-7 img-block">
              <div class="heading-text">Income/Loss from Housing Property</div>
              <div class="sub-heading-details-sm">
                A taxpayer can claim deduction under Section 24 of interest paid
                on home loan for each of the houses separately.
              </div>
            </div>
            <div class="col-2 arrow-left-align">
              <img class="arrow-icon-it" src="@/assets/arrow_purple_new.svg" />
            </div>
          </div>
        </div>
        <pop-up-window-lg
          v-if="showPopupIncomeLossFromHousingProperty"
          @back="
            showPopupIncomeLossFromHousingProperty =
              !showPopupIncomeLossFromHousingProperty;toast=false;getItSubmissionData()
          "
          header="Income/Loss from Housing Property"
        >
          <template v-slot:content>
             <toast-message
      :message="errmsg"
      type="error"
      :isToastEnable="toast"
      @close="(val) => (toast = val)"
    />
            <itProof-submit-dataTable
              :disabled="(releaseForEmployees||dateCheck==false)"
              :tableColumsHeader="incomeLossTableColumsHeaderOne"
              :tableColumnsData="income_loss_from_house_table_columns_data_one"
              :key="componentKeyUpdate"
            >
              <template v-slot="slotprops">
                <div :disabled="slotprops.value.record.status == 'Approved'">
                <span
                :disabled = "finalizedSubmitFlag"
                  style="display: flex; gap: 20px"
                  v-if="slotprops.value.column.key == 'interestOnHousingLoan'"
                >
                  <span style="width: 10rem">
                    <!-- {{
                    slotprops.value.record.joint_holder_name
                  }} -->
                  Total Amount
                 </span>
                  <!-- <img
                    style="cursor: pointer"
                   
                    src="@/assets/info-black.svg"
                  /> -->
                </span>
                <span
                :disabled = "finalizedSubmitFlag"
                  style="width: 10rem"
                  v-if="slotprops.value.column.key == 'declaredAmount'"
                >
                  {{ slotprops.value.record.total_planned }}
                </span>
                <txt
                  v-if="slotprops.value.column.key == 'submittedAmount'"
                  :disabled = "finalizedSubmitFlag"
                  style="width: 10rem"
                  type="number"
                  v-model="slotprops.value.record.total_actual"
                  @Change="
                    (value) => {
                      slotprops.value.record.total_actual = value;
                    }
                  "
                >
                </txt>
                <p v-if="slotprops.value.column.key == 'submittedAmount' && slotprops.value.record.file_location && !slotprops.value.record.total_actual" style="font-size:small;color:red;">Field is Mandatory for Document Submitted</p>

                <span
                :disabled = "finalizedSubmitFlag"
                  style="width: 7rem"
                  v-if="slotprops.value.column.key == 'verifiedAmount'"
                >
                  {{ slotprops.value.record.total_approved }}
                </span>
                <button
                  style="width: 12rem; background-color: #e3c449"
                  @click="
                    show_pop_up(
                      slotprops.value.record,
                      'income_loss_self_occuiped',
                      slotprops.value.index
                    )
                  "
                  v-if="
                    slotprops.value.record.file_location && slotprops.value.column.key == 'proof'
                  "
                  class="export-button"
                >
                  <img src="@/assets/clip.svg" />
                  <label style="cursor: pointer">View Attachment</label>
                </button>

                <button
                  style="width: 12rem; cursor: default"
                  v-if="
                    slotprops.value.column.key == 'proof' &&
                    !slotprops.value.record.file_location
                  "
                  :disabled="!slotprops.value.record.total_actual || finalizedSubmitFlag"
                  class="export-button"
                >
                  <label
                    class="input-label"
                    :for="`file-inputLetout${slotprops.value.index}`"
                  >
                    <img src="@/assets/clip.svg" />
                    <p>Attachment</p>
                  </label>
                  <!-- <img src="@/assets/clip.svg" />
                  <p>Attachment</p> -->
                  <input
                    style="opacity: 0"
                    type="file"
                    :id="`file-inputLetout${slotprops.value.index}`"
                    name="attachment"
                    @change="
                      uploadAttachments(
                        $event.target.files,
                        slotprops,
                        slotprops.value.index,
                        'income_loss_self'
                      )
                    "
                  />
                </button>
                <p v-if="slotprops.value.column.key == 'proof' && !slotprops.value.record.file_location && slotprops.value.record.total_actual" style="font-size:small;color:red;">Document is Mandatory</p>

                <span
                :disabled = "finalizedSubmitFlag"
                  style="display: flex; gap: 5px; width: 9rem"
                  v-if="slotprops.value.column.key == 'status'"
                >
                <img
                    style="width: 1rem; height: 1rem"
                    v-if="slotprops.value.record.status == 'Approved'"
                    src="@/assets/approved.png"
                  />
                  <img
                    style="width: 1rem; height: 1rem"
                    v-if="slotprops.value.record.status == 'Pending'"
                    src="@/assets/pending.svg"
                  />
                  <img
                    style="width: 1rem; height: 1rem"
                    v-if="slotprops.value.record.status == 'rejected'"
                     src="@/assets/rejected.png"
                  />
                  <img
                    style="width: 1rem; height: 1rem"
                    v-if="slotprops.value.record.status == 'partially_approved'"
                    src="@/assets/approved.png"
                  />
                  <span v-if="(slotprops.value.record.status == 'rejected') && (slotprops.value.record.remarks)">{{ slotprops.value.record.status}}</span>
                  <span v-if="(slotprops.value.record.status == 'rejected') && (!slotprops.value.record.remarks)">Not Submitted</span>
                  <span v-if="(slotprops.value.record.status !== 'rejected')">{{ slotprops.value.record.status }}</span>
                </span>
                <span :disabled = "finalizedSubmitFlag"
                :title="slotprops.value.record.remarks" v-if="slotprops.value.column.key == 'remarks'">
                  {{ slotprops.value.record.remarks }}
                </span>
                </div>
              </template>
            </itProof-submit-dataTable>
            <div
            :disabled = "finalizedSubmitFlag"
              style="
                display: flex;
                flex-wrap: wrap;
                gap: 20px;
                padding: 15px 30px;
              "
            >
              <!-- <div class="data_three">
                <span>Bank Name</span>
                <txt
                  name="bank_name"
                  type="text"
                  data-vv-as="bank_name"
                  v-model="
                    income_loss_from_house_table_columns_data_one[0]
                      .bank_details.bank_name
                  "
                  @Change="
                    (value) => {

                      const regex = /^[A-Za-z\s]*$/;
                    const input = event.target.value;
                    if (!regex.test(input)) {
                      const sanitizedInput = input.replace(/[^A-Za-z\s]/g, '');
                      event.target.value = sanitizedInput;
                      income_loss_from_house_table_columns_data_one[0].bank_details.bank_name = sanitizedInput;
                    }
                       
                    }
                  "
                 @input="
                  (event) => {
                    const regex = /^[A-Za-z\s]*$/;
                    const input = event.target.value;
                    if (!regex.test(input)) {
                      const sanitizedInput = input.replace(/[^A-Za-z\s]/g, '');
                      event.target.value = sanitizedInput;
                      income_loss_from_house_table_columns_data_one[0].bank_details.bank_name = sanitizedInput;
                    }
                  }
                "
                ></txt>
                <p v-if="!income_loss_from_house_table_columns_data_one[0]
                      .bank_details.bank_name && income_loss_from_house_table_columns_data_one[0].total_actual>0" style="font-size:small;color:red;">Field is Mandatory if Amount Submitted </p>
                
              </div> -->
              <div class="data_three">
                <span>Bank Name</span>
                <txt
                  name="bank_name"
                  type="alphabet"
                  data-vv-as="bank_name"
                  v-model="
                    income_loss_from_house_table_columns_data_one[0]
                      .bank_details.bank_name
                  "
                  
                  @Change="
                    (value) => {
                      income_loss_from_house_table_columns_data_one[0]
                      .bank_details.bank_name = value;
                    }
                  "
                ></txt>
                <p v-if="!income_loss_from_house_table_columns_data_one[0]
                      .bank_details.bank_name && income_loss_from_house_table_columns_data_one[0].total_actual>0" style="font-size:small;color:red;">Field is Mandatory if Amount Submitted</p>
              </div>
              <div class="data_three">
                <span>Bank Address</span>
                <txt
                  name="bank_address"
                  type="text"
                  data-vv-as="bank_address"
                  v-model="
                    income_loss_from_house_table_columns_data_one[0]
                      .bank_details.bank_address
                  "
                ></txt>
                 <p v-if="!income_loss_from_house_table_columns_data_one[0]
                      .bank_details.bank_address && income_loss_from_house_table_columns_data_one[0].total_actual>0" style="font-size:small;color:red;">Field is Mandatory if Amount Submitted</p>
              </div>
              <div class="data_three">
                <span>Bank Pancard Number</span>
                <txt
                  name="bank_pancard_number"
                  type="text"
                  data-vv-as="bank_pancard_number"
                  v-model="
                    income_loss_from_house_table_columns_data_one[0]
                      .bank_details.bank_pancard_number
                  "
                  @change="
                      (val) => {
                       
                      checkBankPan(val.toUpperCase())
                      }
                    "
                   v-validate="{ required: true, regex: bankPanRegex }"
                    :classname="errors.has('bank_pancard_number')"
                    errormsg="PAN number is required & should be in valid format"
                ></txt>
              </div>
              <div class="data_three">
                <span>Loan Sanction Date</span>
                <date-picker
                  name="loan_sanction_date"
                  :value="
                    income_loss_from_house_table_columns_data_one[0]
                      .bank_details.loan_sanction_date
                  "
                  @datevalue="
                    (val) => {
                      income_loss_from_house_table_columns_data_one[0].bank_details.loan_sanction_date =
                        val;
                    //  let date=new Date(val)
                    //       income_loss_from_house_table_columns_data_one[0]
                    //   .bank_details.home_occupance_date=date.setDate(date.getDate()+1)
                    }
                  "
                   :dates-disabled="{
                        from:new Date(),
                        // to: new Date( fiscalYearStart),
                      }"
                  v-validate="{ required: true }"
                  data-vv-as="loan_sanction_date"
                  :classname="errors.has('loan_sanction_date')"
                  :errormsg="errors.first('loan_sanction_date')"
                ></date-picker>
                 <p v-if="!income_loss_from_house_table_columns_data_one[0]
                      .bank_details.loan_sanction_date  && income_loss_from_house_table_columns_data_one[0].total_actual>0" style="font-size:small;color:red;">Field is Mandatory if Amount Submitted</p>
              </div>
              <div class="data_three">
                <span>Home Occupancy Date </span>
                <date-picker
                  name="home_occupance_date"
                  :value="
                    income_loss_from_house_table_columns_data_one[0]
                      .bank_details.home_occupance_date
                  "
                  @datevalue="
                    (val) => {
                      income_loss_from_house_table_columns_data_one[0].bank_details.home_occupance_date =
                        val;
                        
                    }
                  "
                   :dates-disabled="{
                        from:new Date(fiscalYearEndPlus),
                        to: new Date( income_loss_from_house_table_columns_data_one[0].bank_details.loan_sanction_date),
                      }"
                  v-validate="{ required: true }"
                  data-vv-as="loan_sanction_date"
                  :classname="errors.has('home_occupance_date')"
                  :errormsg="errors.first('home_occupance_date')"
                ></date-picker>
                <p v-if="!income_loss_from_house_table_columns_data_one[0].bank_details.home_occupance_date  && income_loss_from_house_table_columns_data_one[0].total_actual>0" style="font-size:small;color:red;">Field is Mandatory if Amount Submitted</p>
              </div>
              <div class="data_three">
                <span>Home Address </span>
                <txt
                  name="home_address"
                  type="text"
                  data-vv-as="home_addres"
                  v-model="
                    income_loss_from_house_table_columns_data_one[0]
                      .bank_details.home_address
                  "
                ></txt>
                <p v-if="!income_loss_from_house_table_columns_data_one[0].bank_details.home_address  && income_loss_from_house_table_columns_data_one[0].total_actual>0" style="font-size:small;color:red;">Field is Mandatory if Amount Submitted</p>

              </div>
              <div class="data_three">
                <span>Pre-EMI intrest paid </span>
                <txt
                  name="pre_emi_interest_paid"
                  type="Number"
                  data-vv-as="pre_emi_interest_paid"
                  v-model="
                    income_loss_from_house_table_columns_data_one[0]
                      .bank_details.pre_emi_interest_paid
                  "
                ></txt>
                <p v-if="!income_loss_from_house_table_columns_data_one[0].bank_details.pre_emi_interest_paid  && income_loss_from_house_table_columns_data_one[0].total_actual>0" style="font-size:small;color:red;">Field is Mandatory if Amount Submitted</p>

              </div>
            </div>
            <!-- //Self-Declaration for joint property -->

            <div
            :disabled = "finalizedSubmitFlag"
              style="
                display: flex;
                justify-content: space-between;
                padding: 15px 30px;
              "
            >
              <div>

                <div style="margin-bottom: 20px">
                <label>
                  <input 
                    type="checkbox" 
                    v-model="showDiv" 
                  />
                  Joint Declaration Applicable
                </label>
              </div>
                <div
                  v-if="showDiv"
                  v-for="(
                    value, index
                  ) in income_loss_from_house_table_columns_data_three"
                  :key="index"
                  style="
                    display: flex;
                    justify-content: space-between;
                    gap: 20px;
                    padding: 15px 0;
                  "
                >
                  <div style="display: flex; align-items: center">
                    <span style="width: 12rem"
                      >Self-Declaration for joint property</span
                    >
                    <!-- <img
                      style="cursor: pointer; height: 1.5rem"
                      title="information about icon for the arrangements of somethig"
                      src="@/assets/info-black.svg"
                    /> -->
                  </div>
                  
                  <!-- <div style="display: flex; flex-direction: column; gap: 10px">
                    <span>Name Of Joint Holder</span>
                    <txt
                      style="width: 20rem"
                      type="alphabet"
                      v-model="
                        income_loss_from_house_table_columns_data_three[index]
                          .joint_holder_name
                      "
                      @change="
                        (value) => {
                          income_loss_from_house_table_columns_data_three[
                            index
                          ].joint_holder_name = value;
                         
                        }
                      "
                    ></txt>
                  </div>
                  <div style="display: flex; flex-direction: column; gap: 10px">
                    <span>Relationship</span>
                    <txt
                      style="width: 20rem"
                      type="text"
                      v-model="
                        income_loss_from_house_table_columns_data_three[index]
                          .relationship
                      "
                      @change="
                        (value) => {
                          income_loss_from_house_table_columns_data_three[
                            index
                          ].relationship = value;
                        }
                      "
                    ></txt>
                  </div> -->
                   <div style="display: flex; flex-direction: column; row-gap: 4px">
                      <span>Name Of Joint Holder</span>      
                      <tl-select
                        style="width: 20rem"
                        labelText="name"
                        :options="options_for_6a_family_dependant"
                        placeholder="Select"
                        v-model="income_loss_from_house_table_columns_data_three[index].joint_holder_name"
                        @change="
                          (value) => {
                              income_loss_from_house_table_columns_data_three[index].joint_holder_name = value.name;
                              income_loss_from_house_table_columns_data_three[index].relationship = value.relationship;
                          }
                        "
                      />
                </div>  
                <div style="display: flex; flex-direction: column; gap: 10px">
                       <span>Relationship</span>      
                        <txt
                          type="text"
                          v-model="income_loss_from_house_table_columns_data_three[index].relationship"
                        >
                        </txt>
                </div>
                  <div style="display: flex; flex-direction: column; gap: 10px">
                    <span>% of tax benefit claimed by joint holder</span>
                    <txt
                      style="width: 20rem"
                      type="number"
                      :disabled="!isJointHolderAndRelationshipFilledforSelfOccupiedinOldRegime(index)"
                      v-model="income_loss_from_house_table_columns_data_three[index].tax_benefit"
                      @change="
                        (value) => {
                          // income_loss_from_house_table_columns_data_three[
                          //   index
                          // ].tax_benefit = value;
                           checkSelfJointHolder(Number(value),index)
                        }
                      "
                    ></txt>
                  </div>
                  <button
                    class="delete-btn"
                    v-if="
                      income_loss_from_house_table_columns_data_three.length > 1
                    "
                    @click="
                      () => {
                        deleteRow('income_loss', index);
                      }
                    "
                  >
                    Delete
                  </button>
                </div>
              </div>
              <!-- <div
                v-for="(value, index) in income_loss_from_house_table_columns_data_three"
                :key="index"
                style="
                  display: flex;
                  justify-content: space-between;
                  gap: 20px;
                  padding: 15px 0;
                "
              >
                <div style="display: flex; align-items: center">
                  <span style="width: 12rem">Self-Declaration for joint property</span>
                </div>
                <div style="display: flex; flex-direction: column; gap: 10px">
                  <span>Name Of Joint Holder</span>
                  <input
                    style="width: 20rem"
                    type="text"
                    v-model="income_loss_from_house_table_columns_data_three[index].joint_holder_name"
                    @input="validateName(index)"
                  />
                </div>
                <div style="display: flex; flex-direction: column; gap: 10px">
                  <span>Relationship</span>
                  <input
                    style="width: 20rem"
                    type="text"
                    v-model="income_loss_from_house_table_columns_data_three[index].relationship"
                  />
                </div>
                <div style="display: flex; flex-direction: column; gap: 10px">
                  <span>% of tax benefit claimed by joint holder</span>
                  <input
                    style="width: 20rem"
                    type="number"
                    v-model="income_loss_from_house_table_columns_data_three[index].tax_benefit"
                    @change="(value) => checkSelfJointHolder(Number(value), index)"
                  />
                </div>
                <button
                  class="delete-btn"
                  v-if="income_loss_from_house_table_columns_data_three.length > 1"
                  @click="() => deleteRow('income_loss', index)"
                >
                  Delete
                </button>
              </div> -->
              <div class="row margin-t-m margin-b-l">
                <div class="col-12">
                  <div
                    v-if="showDiv"
                    class="row-container"
                    style="display: flex; justify-content: right"
                  >
                    <img src="@/assets/group-5.svg" class="Group-5" />
                    <button
                      class="text-green"
                      @click="addOneMoreRow()"
                    >
                      Add More
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <itProof-submit-dataTable
              :disabled="(releaseForEmployees||dateCheck==false)"
              :tableColumsHeader="incomeLossTableColumsHeaderTwo"
              :tableColumnsData="income_loss_from_house_table_columns_data_two.letout"
            >
              <template v-slot="slotprops">
                <div :disabled="slotprops.value.record.status == 'Approved'">
                <span
                  :disabled = "finalizedSubmitFlag"
                  style="display: flex; gap: 20px"
                  v-if="slotprops.value.column.key == 'income/lossOnHouse'"
                >
                <span v-if="slotprops.value.record.name == 'Current Year Interest'" style="width: 12rem">
                   Current Financial Year Interest
                  </span>
                  <span v-else-if="slotprops.value.record.name == 'A Total rent received by employee'" style="width: 12rem">
                  A Annual Rent Received By Employee
                  </span>
                  <span v-else style="width: 12rem">{{
                    slotprops.value.record.name 
                  }}</span>
                  <!-- <img
                    style="cursor: pointer"
                    :title="getTitleName(slotprops.value.record)"
                    src="@/assets/info-black.svg"
                  /> -->
                </span>
                <span
                  :disabled = "finalizedSubmitFlag"
                  style="width: 10rem"
                  v-if="slotprops.value.column.key == 'declaredAmount'"
                >
                  {{ slotprops.value.record.planned }}
                </span>
                <txt
                  v-if="slotprops.value.column.key == 'submittedAmount'"
                  style="width: 14rem"
                  type="number"
                  :disabled="slotprops.value.record.isDisabled || finalizedSubmitFlag"
                   @change="
                      (val) => {
                        
                            slotprops.value.record.actual = val;
                        calculate(slotprops.value.record.index)
                        
                        
                      }
                    "
                  
                  v-model="slotprops.value.record.actual"
                >
                <p v-if="slotprops.value.column.key == 'submittedAmount' && income_loss_from_house_table_columns_data_two.letout[0].file_location && income_loss_from_house_table_columns_data_two.letout[0].actual && slotprops.value.index==0" style="font-size:small;color:red;">Field is Mandatory for Submitted Document</p>
                </txt>
                <span
                :disabled = "finalizedSubmitFlag"
                  style="width: 7rem"
                  v-if="slotprops.value.column.key == 'verifiedAmount'"
                >
                  {{ slotprops.value.record.approved }}
                </span>
                <button
                  style="width: 12rem; background-color: #e3c449"
                  @click="
                    show_pop_up(
                      slotprops.value.record,
                      'income_loss_letout',
                      slotprops.value.index
                    )
                  "
                  v-if="
                    slotprops.value.record.name == 'Current Year Interest' &&
                    slotprops.value.column.key == 'proof' &&
                    slotprops.value.record.file_location
                  "
                  class="export-button"
                >
                  <img src="@/assets/clip.svg" />
                  <label style="cursor: pointer">View Attachment</label>
                </button>
                <button
                  style="width: 12rem; cursor: default"
                  v-if="
                    slotprops.value.record.name == 'Current Year Interest' &&
                    slotprops.value.column.key == 'proof' &&
                    !slotprops.value.record.file_location
                  "
                  class="export-button"
                  :disabled="(!slotprops.value.record.actual > 0)?true:false || (slotprops.value.index > 0) ? true:false || finalizedSubmitFlag"
                >
                  <label
                    class="input-label"
                    :for="`file-inputSelf${slotprops.value.index}`"
                  >
                    <img src="@/assets/clip.svg" />
                    <p>Attachment</p>
                  </label>
                  <input
                    style="opacity: 0"
                    type="file"
                    :id="`file-inputSelf${slotprops.value.index}`"
                    name="attachment"
                    @change="
                      uploadAttachments(
                        $event.target.files,
                        slotprops.value.record,
                        slotprops.value.index,
                        'income_loss_letout_property'
                      )
                    "
                  />
                </button>
                <p v-if="slotprops.value.column.key == 'proof' && !slotprops.value.record.file_location && slotprops.value.record.actual && slotprops.value.index==0" style="font-size:small;color:red;">Document is Mandatory</p>

                <span
                  style="display: flex; gap: 5px; width: 9rem"
                  v-if="slotprops.value.column.key == 'status'"
                >
                <img
                    style="width: 1rem; height: 1rem"
                    v-if="slotprops.value.record.status == 'Approved'"
                    src="@/assets/approved.png"
                  />
                  <img
                    style="width: 1rem; height: 1rem"
                    v-if="slotprops.value.record.status == 'Pending'"
                    src="@/assets/pending.svg"
                  />
                  <img
                    style="width: 1rem; height: 1rem"
                    v-if="slotprops.value.record.status == 'rejected'"
                     src="@/assets/rejected.png"
                  />
                  <img
                    style="width: 1rem; height: 1rem"
                    v-if="slotprops.value.record.status == 'partially_approved'"
                    src="@/assets/approved.png"
                  />
                  <span>{{ slotprops.value.record.status }}</span>
                </span>
                <span :title="slotprops.value.record.remarks" v-if="slotprops.value.column.key == 'remarks'">
                  {{ slotprops.value.record.remarks }}
                </span>
                </div>
              </template>
            </itProof-submit-dataTable>
            <div
            :disabled="finalizedSubmitFlag"
              style="
                display: flex;
                justify-content: space-between;
                padding: 15px 30px;
              "
            >
              <div>
                <div style="margin-bottom: 20px">
                <label>
                  <input 
                    type="checkbox" 
                    v-model="showDivforletout" 
                  />
                  Joint Declaration Applicable
                </label>
              </div>
                <div
                  v-if="showDivforletout"
                  v-for="(
                    value, index
                  ) in income_loss_from_house_table_columns_data_letout_joint_Property"
                  :key="index"
                  style="
                    display: flex;
                    justify-content: space-between;
                    gap: 20px;
                    padding: 15px 0;
                  "
                >
                  <div style="display: flex; align-items: center">
                    <span style="width: 12rem"
                      >Self-Declaration for joint property</span
                    >
                    <!-- <img
                      style="cursor: pointer; height: 1.5rem"
                      title="information about icon for the arrangements of somethig"
                      src="@/assets/info-black.svg"
                    /> -->
                  </div>
                  <!-- <div style="display: flex; flex-direction: column; gap: 10px">
                    <span>Name Of Joint Holder</span>
                    <txt
                      style="width: 20rem"
                      type="alphabet"
                      v-model="
                        income_loss_from_house_table_columns_data_letout_joint_Property[index]
                          .joint_holder_name
                      "
                      @change="
                        (value) => {
                          income_loss_from_house_table_columns_data_letout_joint_Property[
                            index
                          ].name = value;
                        }
                      "
                    ></txt>
                  </div>
                  <div style="display: flex; flex-direction: column; gap: 10px">
                    <span>Relationship</span>
                    <txt
                      style="width: 20rem"
                      type="text"
                      v-model="
                        income_loss_from_house_table_columns_data_letout_joint_Property[index]
                          .relationship
                      "
                      @change="
                        (value) => {
                          income_loss_from_house_table_columns_data_letout_joint_Property[
                            index
                          ].relationship = value;
                        }
                      "
                    ></txt>
                  </div> -->
                    <div style="display: flex; flex-direction: column; row-gap: 4px">
                       <span>Name Of Joint Holder Testing</span>      
                      <tl-select
                        style="width: 20rem"
                        labelText="name"
                        :options="options_for_6a_family_dependant"
                        placeholder="Select"
                        v-model="income_loss_from_house_table_columns_data_letout_joint_Property[index]
                                .joint_holder_name"
                        @change="(value)=>{assignFamilyDetails(value,index)}"
                      />
                </div>  
                <div style="display: flex; flex-direction: column; gap: 10px">
                       <span>Relationship</span>      
                        <txt
                          type="text"
                          v-model="income_loss_from_house_table_columns_data_letout_joint_Property[index]
                                  .relationship"
                        >
                        </txt>
                </div>
                  <div style="display: flex; flex-direction: column; gap: 10px">
                    <span>% of tax benefit claimed by joint holder</span>
                    <txt
                      style="width: 20rem"
                      type="number"
                      :disabled="!isJointHolderAndRelationshipFilledforLetOutinOldRegime(index)"
                      v-model="
                        income_loss_from_house_table_columns_data_letout_joint_Property[index]
                          .tax_benefit
                      "
                      @change="
                        (value) => {
                          // income_loss_from_house_table_columns_data_letout_joint_Property[
                          //   index
                          // ].tax_benefit = value;
                        checkLetOutJointHolder(Number(value),index)

                        }
                      "
                    ></txt>
                  </div>
                  <button
                    class="delete-btn"
                    v-if="
                      income_loss_from_house_table_columns_data_letout_joint_Property.length > 1
                    "
                    @click="
                      () => {
                        deleteRow('income_loss_letout', index);
                      }
                    "
                  >
                    Delete
                  </button>
                </div>
              </div>
              <div class="row margin-t-m margin-b-l">
                <div class="col-12">
                  <div
                    v-if="showDivforletout"
                    class="row-container"
                    style="display: flex; justify-content: right"
                  >
                    <img src="@/assets/group-5.svg" class="Group-5" />
                    <button
                      class="text-green"
                      @click="addMoreRow('income_loss_letout')"
                    >
                      Add More
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </template>
          <template v-slot:bottom>
            <footer>
              <popup-bottom-container>
                <template>
                  <div style="display: flex; flex-direction: column">
                    <p style="font-size: large; font-weight: 700">
                      General Remarks
                    </p>
                    <p>
                      IncomeTax proof Submission window will be closing soon
                    </p>
                  </div>
                </template>
                <template slot="end">
                  <btn-grp class="form-button">
                    <btn text="Cancel" type="secondary" @click="
                    showPopupIncomeLossFromHousingProperty =
                     !showPopupIncomeLossFromHousingProperty;toast=false;getItSubmissionData()
                   " />
                    <btn
                      v-show="incomeTaxProofSubmittedFlag"
                      :disabled="!incomeTaxProofSubmittedFlag ||(releaseForEmployees||dateCheck==false)"
                      text="Save as Draft"
                      type="primary"
                      @click="saveDataForFinalArray('income_loss_property')"
                    />
                  </btn-grp>
                </template>
              </popup-bottom-container>
            </footer>
          </template>
        </pop-up-window-lg>
        <div
          v-if="isPrevEmployerEnabled && currentFinancialyear"
          class="pr-0 cursor-point"
          @click="
            showPopupIncomeFromPreviousEmployer =
              !showPopupIncomeFromPreviousEmployer;toast=false
          "
        >
          <div class="row col-bg-gray">
            <div class="col-3 img-block">
              <img src="@/assets/incomeFromPreviousEmployer.svg" />
            </div>
            <div class="col-7 img-block">
              <div class="heading-text">Income from Previous Employer</div>
              <div class="sub-heading-details-sm">
                It's not mandatory that you should report your previous employer
                salary income and TDS amount deducted.
              </div>
            </div>
            <div class="col-2 arrow-left-align">
              <img class="arrow-icon-it" src="@/assets/arrow_purple_new.svg" />
            </div>
          </div>
        </div>
        <pop-up-window-lg
          v-if="showPopupIncomeFromPreviousEmployer"
          @back="
            showPopupIncomeFromPreviousEmployer =
              !showPopupIncomeFromPreviousEmployer;toast=false;getItSubmissionData();
          "
          header="Income From Previous Employer"
        >
          <template v-slot:content>
             <toast-message
      :message="errmsg"
      type="error"
      :isToastEnable="toast"
      @close="(val) => (toast = val)"
    />
            <itProof-submit-dataTable
              :disabled="(releaseForEmployees||dateCheck==false)"
              :tableColumsHeader="income_from_previos_employee_colums_header"
              :tableColumnsData="
                income_from_previous_employee_table_columns_data[0]
              "
            >
              <template v-slot="slotprops">
                <div :disabled="slotprops.value.record.status == 'Approved'"> 
                <span
                  style="display: flex; gap: 20px"
                  v-if="slotprops.value.column.key == 'particulars'"
                  :disabled = "finalizedSubmitFlag"
                >
                  <span style="width: 12rem">{{
                    previousEmployerNames[slotprops.value.record.name] == 'Salary Income'? 'Salary Income After Section 10':previousEmployerNames[slotprops.value.record.name] == 'National Pension Scheme'? 'Contribution to NPS by Employer 80CCD2' :  previousEmployerNames[slotprops.value.record.name]
                  }}</span>
                  <!-- <img
                    style="cursor: pointer"
                  :title="getTitlePrevEmployee(previousEmployerNames[slotprops.value.record.name])"

                    src="@/assets/info-black.svg"
                  /> -->
                </span>
                <span
                :disabled = "finalizedSubmitFlag"
                  style="width: 10rem"
                  v-if="slotprops.value.column.key == 'declaredAmount'"
                >
                  {{ slotprops.value.record.planned }}
                </span>
                <txt
                  v-if="slotprops.value.column.key == 'submittedAmount'"
                  style="width: 14rem"
                  type="number"
                  :disabled = "finalizedSubmitFlag"
                  @blur="uploadValidation('previous_employee')"
                  @change="
                    (value) => {
                      prevEmployeeChange(value,slotprops.value.index )
                      // slotprops.value.record.actual = value;
                    }
                  "
                  v-model="slotprops.value.record.actual "
                >
                </txt>
                <p v-if="slotprops.value.column.key == 'submittedAmount' && income_from_previous_employee_table_columns_data[0][0].file_location && !slotprops.value.record.actual && slotprops.value.index==0" style="font-size:small;color:red;">Field is mandatory for Document submitted</p>

                <span
                :disabled = "finalizedSubmitFlag"
                  style="width: 7rem"
                  v-if="slotprops.value.column.key == 'verifiedAmount'"
                >
                  {{ slotprops.value.record.approved }}
                </span>
                <span
                  style="display: flex; gap: 5px; width: 9rem"
                  v-if="slotprops.value.column.key == 'status'"
                >
                <img
                    style="width: 1rem; height: 1rem"
                    v-if="slotprops.value.record.status == 'Approved'"
                    src="@/assets/approved.png"
                  />
                  <img
                    style="width: 1rem; height: 1rem"
                    v-if="slotprops.value.record.status == 'Pending'"
                    src="@/assets/pending.svg"
                  />
                  <img
                    style="width: 1rem; height: 1rem"
                    v-if="slotprops.value.record.status == 'rejected'"
                     src="@/assets/rejected.png"
                  />
                  <img
                    style="width: 1rem; height: 1rem"
                    v-if="slotprops.value.record.status == 'partially_approved'"
                    src="@/assets/approved.png"
                  />
                  <span v-if="(slotprops.value.record.status == 'rejected') && (slotprops.value.record.remarks)">{{ slotprops.value.record.status}}</span>
                  <span v-if="(slotprops.value.record.status == 'rejected') && (!slotprops.value.record.remarks)">Not Submitted</span>
                  <span v-if="(slotprops.value.record.status !== 'rejected')">{{ slotprops.value.record.status }}</span>
                </span>
                <span :title="slotprops.value.record.remarks" v-if="slotprops.value.column.key == 'remarks'">
                  {{ slotprops.value.record.remarks }}
                </span>
              </div>
              </template>
            </itProof-submit-dataTable>
            <div
              style="
                display: flex;
                justify-content: center;
                align-items: center;
                gap: 20px;
                
                margin: 20px 0px;
              "
            >
            <!-- <span style="margin-top:inherit; font-size:14px;">Comments:</span>
              <textarea
                class="form-control"
                name="remarks"
                v-model="
                  income_from_previous_employee_table_columns_data[0].remarks
                "
              /> -->
              <button
                style="width: 12rem; background-color: #e3c449; align-items:center; margin-top: inherit"
                @click="
                  show_pop_up(
                    income_from_previous_employee_table_columns_data,
                    'income_from_previous_employee'
                  )
                "
                v-if="
                income_from_previous_employee_table_columns_data[0][0].file_location
                "
                class="export-button"
              >
                <img src="@/assets/clip.svg" />
                <label style="cursor: pointer">View Attachment</label>
              </button>
              <button
                :disabled = "finalizedSubmitFlag"
                style="width: 12rem; cursor: default"
                v-if="
                  !income_from_previous_employee_table_columns_data[0][0].file_location
                "
                class="export-button"
              >
                <!-- <img src="@/assets/clip.svg" />
                  <p>Attachment</p>
                  <input
                    style="opacity: 0"
                    type="file"
                    name="attachment"
                    @change="
                      uploadAttachments(
                        $event.target.files,
                        slotprops.value.record,
                        slotprops.value.index,
                        'income_from_previous_employee'
                      )
                    "
                  /> -->
                <label class="input-label" :for="`file-inputprev`">
                  <img src="@/assets/clip.svg" />
                  <p>Attachment</p>
                </label>
                <!-- <img src="@/assets/clip.svg" />
                  <p>Attachment</p> -->
                <input
                  style="opacity: 0"
                  type="file"
                  :id="`file-inputprev`"
                  name="attachment"
                  @change="
                    uploadAttachments(
                      $event.target.files,
                      income_from_previous_employee_table_columns_data,
                      1,
                      'income_from_previous_employee'
                    )
                  "
                />
              </button>
                <p v-if="!income_from_previous_employee_table_columns_data[0][0].file_location && income_from_previous_employee_table_columns_data[0][0].actual" style="font-size:small;color:red;">Document is Mandatory </p>

            </div>
          </template>
          <template v-slot:bottom>
            <footer>
              <popup-bottom-container>
                <template>
                  <div style="display: flex; flex-direction: column">
                    <p style="font-size: large; font-weight: 700">
                      General Remarks
                    </p>
                    <p>
                      IncomeTax proof Submission window will be closing soon
                    </p>
                  </div>
                </template>
                <template slot="end">
                  <btn-grp class="form-button">
                    <btn
                      text="Cancel"
                      type="secondary"
                      @click="
                        showPopupIncomeFromPreviousEmployer =
                          !showPopupIncomeFromPreviousEmployer;toast=false;getItSubmissionData()
                      "
                    />
                    <btn
                      v-show="incomeTaxProofSubmittedFlag"
                      :disabled="!incomeTaxProofSubmittedFlag ||(releaseForEmployees||dateCheck==false)"
                      text="Save as Draft"
                      type="primary"
                      @click="
                        saveDataForFinalArray('income_from_previous_employee')
                      "
                    />
                  </btn-grp>
                </template>
              </popup-bottom-container>
            </footer>
          </template>
        </pop-up-window-lg>
        <div
          class="pl-0 cursor-point"
          @click="showPopupOtherIncome = !showPopupOtherIncome;toast=false"
        >
          <div class="row col-bg-gray">
            <div class="col-3 img-block">
              <img src="@/assets/other_income.svg" />
            </div>
            <div class="col-7 img-block">
              <div class="heading-text">Other Income</div>
              <div class="sub-heading-details-sm">
                Other income is income that does not come from a company's main
                business, such as interest.
              </div>
            </div>
            <div class="col-2 arrow-left-align">
              <img class="arrow-icon-it" src="@/assets/arrow_purple_new.svg" />
            </div>
          </div>
        </div>
        <pop-up-window-lg
          v-if="showPopupOtherIncome"
          @back="showPopupOtherIncome = !showPopupOtherIncome;toast=false;getItSubmissionData();"
          header="Other Income"
        >
          <template v-slot:content >
             <toast-message
      :message="errmsg"
      type="error"
      :isToastEnable="toast"
      @close="(val) => (toast = val)"
    />
            <itProof-submit-dataTable
            :disabled="(releaseForEmployees||dateCheck==false)"
            :tableColumsHeader="other_income_colums_header"
              :tableColumnsData="other_income_table_columns_data"
            >
              <template v-slot="slotprops" >
                <div :disabled="slotprops.value.record.status == 'Approved'">

                
                <span
                  :disabled = "finalizedSubmitFlag"
                  style="display: flex; gap: 20px"
                  v-if="slotprops.value.column.key == 'particulars'"
                >
                  <span style="width: 12rem">{{
                    slotprops.value.record.name == "Any other Income"? "Income from Other Sources": slotprops.value.record.name
                  }}</span>
                  <!-- <img
                    style="cursor: pointer"
                    :title="getTitleName(slotprops.value.record)"
                    src="@/assets/info-black.svg"
                  /> -->
                </span>
                <span
                :disabled = "finalizedSubmitFlag"
                  style="width: 10rem"
                  v-if="slotprops.value.column.key == 'declaredAmount'"
                >
                  {{ slotprops.value.record.planned }}
                </span>
                <txt
                :disabled = "finalizedSubmitFlag"
                  v-if="slotprops.value.column.key == 'submittedAmount'"
                  style="width: 14rem"
                  type="number"
                  @blur="uploadValidation('other_income')"
                  @Change="
                    (value) => {
                      slotprops.value.record.actual = value;
                    }
                  "
                  v-model="slotprops.value.record.actual "
                >
                </txt>
                <p v-if="slotprops.value.column.key == 'submittedAmount' && slotprops.value.record.file_location && !slotprops.value.record.actual" style="font-size:x-small;color:red;">Field is mandatory for Document submitted</p>

                <span
                :disabled = "finalizedSubmitFlag"
                  style="width: 7rem"
                  v-if="slotprops.value.column.key == 'verifiedAmount'"
                >
                  {{ slotprops.value.record.approved }}
                </span>
                <button
                  style="width: 12rem; background-color: #e3c449"
                  @click="
                    show_pop_up(
                      slotprops.value.record,
                      'other_income',
                      slotprops.value.index
                    )
                  "
                  v-if="
                    slotprops.value.column.key == 'proof' &&
                    slotprops.value.record.file_location
                  "
                  class="export-button"
                >
                  <img src="@/assets/clip.svg" />
                  <label style="cursor: pointer">View Attachment</label>
                </button>
                <button
                  style="width: 12rem; cursor: default"
                  v-if="
                    slotprops.value.column.key == 'proof' &&
                    !slotprops.value.record.file_location
                  "
                  class="export-button"
                  :disabled="!slotprops.value.record.actual || finalizedSubmitFlag"
                >
                  <!-- <img src="@/assets/clip.svg" />
                  <p>Attachment</p>
                  <input
                    style="opacity: 0"
                    type="file"
                    name="attachment"
                    @change="
                      uploadAttachments(
                        $event.target.files,
                        slotprops.value.record,
                        slotprops.value.index,
                        'other_income'
                      )
                    "
                  /> -->
                  <label
                    class="input-label"
                    :for="`file-input${slotprops.value.index}`"
                  >
                    <img src="@/assets/clip.svg" />
                    <p>Attachment</p>
                  </label>
                  <!-- <img src="@/assets/clip.svg" />
                  <p>Attachment</p> -->
                  <input
                    style="opacity: 0"
                    type="file"
                    :id="`file-input${slotprops.value.index}`"
                    name="attachment"
                    @change="
                      uploadAttachments(
                        $event.target.files,
                        slotprops.value.record,
                        slotprops.value.index,
                        'other_income'
                      )
                    "
                  />
                </button>
                <p v-if="slotprops.value.column.key == 'proof' && !slotprops.value.record.file_location && slotprops.value.record.actual" style="font-size:small;color:red;">Document is Mandatory</p>

                <span
                  style="display: flex; gap: 5px; width: 9rem"
                  v-if="slotprops.value.column.key == 'status'"
                >
                <img
                    style="width: 1rem; height: 1rem"
                    v-if="slotprops.value.record.status == 'Approved'"
                    src="@/assets/approved.png"
                  />
                  <img
                    style="width: 1rem; height: 1rem"
                    v-if="slotprops.value.record.status == 'Pending'"
                    src="@/assets/pending.svg"
                  />
                  <img
                    style="width: 1rem; height: 1rem"
                    v-if="slotprops.value.record.status == 'rejected'"
                    src="@/assets/rejected.png"
                  />
                  <img
                    style="width: 1rem; height: 1rem"
                    v-if="slotprops.value.record.status == 'partially_approved'"
                    src="@/assets/approved.png"
                  />
                  <span v-if="(slotprops.value.record.status == 'rejected') && (slotprops.value.record.remarks)">{{ slotprops.value.record.status}}</span>
                  <span v-if="(slotprops.value.record.status == 'rejected') && (!slotprops.value.record.remarks)">Not Submitted</span>
                  <span v-if="(slotprops.value.record.status !== 'rejected')">{{ slotprops.value.record.status }}</span>
                </span>
                <span :title="slotprops.value.record.remarks" v-if="slotprops.value.column.key == 'remarks'">
                  {{ slotprops.value.record.remarks }}
                </span>
                </div>
              </template>
            </itProof-submit-dataTable>
          </template>
          <template v-slot:bottom>
            <footer>
              <popup-bottom-container>
                <template>
                  <div style="display: flex; flex-direction: column">
                    <p style="font-size: large; font-weight: 700">
                      General Remarks
                    </p>
                    <p>
                      IncomeTax proof Submission window will be closing soon
                    </p>
                  </div>
                </template>
                <template slot="end">
                  <btn-grp class="form-button">
                    <btn
                      text="Cancel"
                      type="secondary"
                      @click="showPopupOtherIncome = !showPopupOtherIncome;toast=false;getItSubmissionData()"
                    />
                    <btn
                       v-show="incomeTaxProofSubmittedFlag"
                      :disabled="!incomeTaxProofSubmittedFlag ||(releaseForEmployees||dateCheck==false)"
                      text="Save as Draft"
                      type="primary"
                      @click="saveDataForFinalArray('other_income')"
                    />
                  </btn-grp>
                </template>
              </popup-bottom-container>
            </footer>
          </template>
        </pop-up-window-lg>
        <div
          v-show="enableTCS"
          class="pl-0 cursor-point"
          @click="showPopupOtherTaxTcs = !showPopupOtherTaxTcs;toast=false"
        > 
            <div class="row col-bg-gray">
              <div class="col-3 img-block">
                <img src="@/assets/other_income.svg" />
              </div>
              <div class="col-7 img-block">
                <div class="heading-text">Other Tax Collected at Source(TCS)</div>
                <div class="sub-heading-details-sm">
                  Enter details of any Tax Collected at Source (TCS) that you have paid during the financial year
                </div>      
              </div>
              <div class="col-2 arrow-left-align">  
                <img class="arrow-icon-it" src="@/assets/arrow_purple_new.svg" />
              </div>
            </div>
        </div>
        <pop-up-window-lg
          v-if="showPopupOtherTaxTcs"
          @back="showPopupOtherTaxTcs = !showPopupOtherTaxTcs;toast=false;getItSubmissionData();"
          header="Other Tax Collected at Source(TCS)"
        >
          <template v-slot:content>
            <toast-message
              :message="errmsg"
              type="error"
              :isToastEnable="toast"
              @close="(val) => (toast = val)"
            />
            <div>
              <div
                style="
                  display: flex;
                  width: 100%;
                  margin-bottom:12px;
                "
              >
                <div class="heading-text">
                  Tax Collected at Source (TCS) Details
                </div>
               
              </div>
            </div>
            <itProof-submit-dataTable
              :disabled="!incomeTaxProofSubmittedFlag ||(releaseForEmployees||dateCheck==false)"
              :tableColumsHeader="tcs_table_colums_header"
              :tableColumnsData="other_tcs_table_columns_data"
            >
              <template v-slot="slotprops">
                <tl-select
                  v-if="slotprops.value.column.key == 'section_display_name'"
                  :disabled="finalizedSubmitFlag"
                  name="tcs_section"
                  :options="tcs_section_options"
                  placeholder="Select Section"
                  v-model="slotprops.value.record.section_display_name"
                  @change="
                    (val) => {
                      slotprops.value.record.section_display_name = val;
                    }
                  "
                />
                <txt
                  v-if="slotprops.value.column.key == 'name_of_collector'"
                  :disabled="finalizedSubmitFlag"
                  style="width: 12rem"
                  type="text"
                  @Change="
                    (value) => {
                      slotprops.value.record.name_of_collector = value;
                    }
                  "
                  v-model="slotprops.value.record.name_of_collector"
                >
                </txt>
                <txt
                  v-if="slotprops.value.column.key == 'tan_of_collector'"
                  :disabled="finalizedSubmitFlag"
                  style="width: 12rem"
                  type="text"
                  @Change="
                    (value) => {
                      slotprops.value.record.tan_of_collector = value;
                    }
                  "
                  v-model="slotprops.value.record.tan_of_collector"
                >
                </txt>
                <span
                  :disabled="true"
                  style="width: 10rem"
                  v-if="slotprops.value.column.key == 'planned'"
                >
                  {{ slotprops.value.record.planned }}
                </span>
                <txt
                  v-if="slotprops.value.column.key == 'actual'"
                  :disabled="finalizedSubmitFlag"
                  style="width: 10rem"
                  type="number"
                  @Change="
                    (value) => {
                      slotprops.value.record.actual = value;
                    }
                  "
                  v-model="slotprops.value.record.actual"
                >
                </txt>
                <span
                  :disabled="true"
                  style="width: 10rem"
                  v-if="slotprops.value.column.key == 'approved'"
                >
                  {{ slotprops.value.record.approved }}
                </span>
                <button
                  style="width: 12rem; background-color: #e3c449"
                  @click="
                    show_pop_up(
                      slotprops.value.record,
                      'tcs_attachment',
                      slotprops.value.index
                    )
                  "
                  v-if="
                    slotprops.value.column.key == 'attachment' &&
                    slotprops.value.record.file_path
                  "
                  class="export-button"
                >
                  <img src="@/assets/clip.svg" />
                  <label style="cursor: pointer">View Attachment</label>
                </button>
                <button
                  style="width: 12rem; cursor: default"
                  v-if="
                    slotprops.value.column.key == 'attachment' &&
                    !slotprops.value.record.file_path
                  "
                  :disabled="finalizedSubmitFlag"
                  class="export-button"
                >
                  <label
                    class="input-label"
                    :for="`file-inputTCS${slotprops.value.index}`"
                  >
                    <img src="@/assets/clip.svg" />
                    <p>Attachment</p>
                  </label>
                  <input
                    style="opacity: 0"
                    type="file"
                    :id="`file-inputTCS${slotprops.value.index}`"
                    name="attachment"
                    @change="
                      uploadAttachments(
                        $event.target.files,
                        slotprops.value.record,
                        slotprops.value.index,
                        'tcs_attachment'
                      )
                    "
                  />
                </button>
                <span
                  style="display: flex; gap: 5px; width: 9rem"
                  v-if="slotprops.value.column.key == 'status'"
                >
                  <img
                    style="width: 1rem; height: 1rem"
                    v-if="slotprops.value.record.status == true"
                    src="@/assets/approved.png"
                  />
                  <img
                    style="width: 1rem; height: 1rem"
                    v-if="slotprops.value.record.status == false"
                    src="@/assets/pending.svg"
                  />
                  <span>{{ slotprops.value.record.status}}</span>
                </span>
                <span
                  :title="slotprops.value.record.remarks"
                  v-if="slotprops.value.column.key == 'remarks'"
                >
                  {{ slotprops.value.record.remarks }}
                </span>
                 <button
                  class="delete-btn"
                  v-if="
                    slotprops.value.column.key == 'delete' &&
                    slotprops.value.index > 0
                  "
                  :disabled="finalizedSubmitFlag"
                  @click="
                    () => {
                      deleteRow(
                        'tcs_data',
                        slotprops.value.index,
                        0
                      );
                    }
                  "
                >
                  Delete
                </button>
              </template>
            </itProof-submit-dataTable>
             <div 
                :disabled="finalizedSubmitFlag"
                  class="align-center"
                  style="display: flex; align-items: center; gap: 5px; margin:20px"
                >
                  <img src="@/assets/group-5.svg" class="Group-5" />
                  <button
                    class="text-green"
                    @click="addMoreRow('tcs_data')"
                  >
                    Add Row
                  </button>
                </div>
          </template>
          <template v-slot:bottom>
            <footer>
              <popup-bottom-container>
                <template>
                  <div style="display: flex; flex-direction: column">
                    <p style="font-size: large; font-weight: 700">
                      General Remarks
                    </p>
                    <p>
                      IncomeTax proof Submission window will be closing soon
                    </p>
                  </div>
                </template>
                <template slot="end">
                  <btn-grp class="form-button">
                    <btn
                      text="Cancel"
                      type="secondary"
                      @click="showPopupOtherTaxTcs = !showPopupOtherTaxTcs;toast=false;getItSubmissionData()"
                    />
                    <btn
                      v-show="incomeTaxProofSubmittedFlag"
                      :disabled="!incomeTaxProofSubmittedFlag ||(releaseForEmployees||dateCheck==false)"
                      text="Save as Draft"
                      type="primary"
                      @click="saveDataForFinalArray('tcs_data')"
                    />
                  </btn-grp>
                </template>
              </popup-bottom-container>
            </footer>
          </template>
        </pop-up-window-lg>
      </div>
      <bottom-action-container>
        <template>
        <div style="display: flex; flex-direction: column">
          <p style="font-size: large; font-weight: 700">
            Instruction
          </p>
          <p style="color:red">
            Uploading Attachments allow only PDF, PNG, ZIP, JPG upto 20MB
         </p>
          </div>
        </template>
        <template slot="end">
          <btn-grp>
            <btn v-show="incomeTaxProofSubmittedFlag" :disabled="allowOtherSections || !dateCheck || releaseForEmployees" text="Generate 12BB" type="primary" @click="openForm12BB()" />
            <btn v-show="!incomeTaxProofSubmittedFlag" style="font-size:medium" text="Download 12BB" type="secondary" @click="download12BBUrl(BB_12_url)" />
          </btn-grp>
        </template>
      </bottom-action-container>

      <pop-up-message
        v-if="showSuccessMsg"
        :message="pop_up_message"
        btnText="OK"
        @back="goBack"
      ></pop-up-message>
      <pop-up-message
        v-if="dateSuccess"
        message="IT proof Declaration time is expired"
        :popupType="'Warning'"
      :popupHeaderMessage="'Please Contact Admin'"
        btnText="OK"
        @back="goBack"
      ></pop-up-message>
      <pop-up-message
        v-if="releaseSuccess"
        message="IT proof Declaration is not enabled for you"
        :popupType="'Warning'"
      :popupHeaderMessage="'Please Contact Admin'"
        btnText="OK"
        @back="goBack"
      ></pop-up-message>
    </div>
  </div>
</template>
<script>
import * as globalConfig from "@/apis/config.js";
const crypto = require("crypto");
import { createDecipheriv } from 'crypto';
import {S3} from "aws-sdk";
import { mapGetters, mapActions, mapState } from "vuex";
import ItProofSubmitDataTable from "./incomeTax/houseRentdeclaration.vue";
import ExemptionUnderSectionDeduction from "../payroll/incometax/exemptionUnderSectionDeduction.vue";
import DeductionUnderCdeu from "../payroll/incometax/deductionsUnderCdeu.vue";
import DeductionUnderSectionSixteen from "../payroll/incometax/deductionUnderSectionSixteen.vue";
import ExemptionUnderSectionSeventeen from "../payroll/incometax/exemptionUnderSectionSeventeen.vue";
import IncomeFromPreviousEmployer from "../payroll/incometax/incomeFromPreviousEmployer";
import OtherIncome from "../payroll/incometax/otherIncome.vue";
import axios from "axios";
import IncomeLossFromHousingProperty from "../payroll/incometax/incomeLossFromHousingProperty.vue";
export default {
  components: {
    ExemptionUnderSectionDeduction,
    DeductionUnderCdeu,
    DeductionUnderSectionSixteen,
    ExemptionUnderSectionSeventeen,
    IncomeFromPreviousEmployer,
    OtherIncome,
    IncomeLossFromHousingProperty,
    ItProofSubmitDataTable,
  },

  data() {
    return {
      DateOfJoining:"",
      yearOfJoining:"",
      monthOfJoining:"",
      joiningDate:"",
      namesToAddIsDisabled: [
        "B Less: municipal Taxes Paid",
        "C (A-B) Net Annual Value",
        "D (C* 30%) Less: Standard Deduction @ 30%",
        "E Less: Interest on Housing Loan",
        "F (C-D-E) Income/Loss on House Property",
      ],
      componentKeyUpdate:0,
      previousEmployerNames: {
        salary_income: "Salary Income",
        pt: "Professional Tax",
        vpf: "Voluntary Provident Fund",
        pf: "Provident Fund",
        nps: "National Pension Scheme",
        tds: "Tax Deducted at Source",
      },
      BB_12_url: "",
      showDiv:false,
      showDivforNewRegime:false,
      showDivforletout:false,
      empProfileDob: "",
      regime_type :"",
      enableSection10ForNewRegime:true,
      subSectionInfo: [],
      backendArrayData:[], 
      uploadMethod:"newregime",
      enableRegimeChange:false,
      ltaValue: "",
      hraFound:undefined,
      clientCodeBoolen:true,
      showDeleteConfirmation:false,
      incomeTaxProofSubmittedFlag: true,
      releaseForEmployees:false,
      releaseSuccess:false,
      BBPayload:"",
      checkBoxFlag:true,
      finalSubmitFlag:true,
      finalizedSubmitFlag:false,
      employeeDetailsPayload:[],
      nameToRelationship: {},
      isPrevEmployerEnabled: false,
      e_code: "",
      form12BB_pop_up: false,
      allowOtherSections: false,
      errmsg: "",
      toast: false,
      pancardRegex: "",
      showPopupUnder80DDB: false,
      showPopupUnder80D: false,
      showPopupUnder80DD: false,
      pop_up_80DD_header:"",
      pop_up_80DDB_header:"",
      pop_up_header_80D:"",
      it_plan_id: "",
      dateCheck: false,
      dateSuccess: false,
      pop_up_message: "",
      it_financial_year: "",
      net_taxable_income: "",
      total_tax: "",
      tax_to_be_paid: "",
      fetchUrl: "",
      employeeObj: null,
      fiscalYearEnd: "",
      fiscalYearEndPlus:"",
      fiscalYearStart: "",
      checkRange: false,
      PlanName: null,
      file_location_hra: "",
      file_location_income: "",
      file_location_previous: "",
     file_name_previous:"", 
      section_ten_attachments_pop_up: false,
      house_rent_attachments_pop_up: false,
      deduction_under_6A_attachments_pop_up: false,
      income_loss_from_house_attachments_pop_up: false,
      income_from_previous_employee_pop_up: false,
      other_income_attachments_pop_up: false,
      other_tcs_attachment_pop_up: false,
      showPopupHouseRentDeclaration: false,
      showPopupSalaryPerks: false,
      showPopupTdsBreakupOldRegimePopup: false,
      showPopupItDeclarationStatmentOldRegimePopup: false,
      showPopupTdsBreakupNewRegimePopup: false,
      showPopupItDeclarationStatmentNewRegimePopup: false,
      showPopupExemptionUnderSectionDeduction: false,
      showPopupDeductionUnderCdeu: false,
      showPopupDeductionUnderNPS:false,
      showPopupDeductionUnderSectionSixteen: false,
      showPopupExemptionUnderSectionSeventeen: false,
      showPopupIncomeFromPreviousEmployer: false,
      showPopupOtherIncome: false,
      showPopupIncomeLossFromHousingProperty: false,
      showPopupIncomeLossFromHousingPropertyNewRegime: false,
      showConfirmationMsg: false,
      uploaded_attachment_name: "",
      exemptionSection: "Exemption Under Section 10",
      attachments_pop_up_header: "Attachments",
      upload_loader: false,
      house_rent_declaration_city: "",
      metro_city_options: ["Delhi", "Mumbai", "Kolkata", "Chennai", "Bengaluru", "Hyderabad", "Ahmedabad", "Pune", "Other"],
      employeeFamilyDetails: [],
      options_for_relationship: [
        "Self",
        "Spouse",
        "Son",
        "Daughter",
        "Mother",
        "Father",
      ],
      options_for_80u_percentage: [
        "Less than 40%",
        "More than 40% < 80%",
        "More than 80%",
      ],
      options_for_6a_family_dependant: [],
      attachment_pop_up_table_columns_data: [],
      attachment_pop_up_column_header: [
        {
          label: "Attachment",
          key: "attachment",
        },
        {
          label: "File Name",
          key: "fileName",
        },
        {
          label: "View File",
          key: "viewFile",
        },
        {
          label: "Remove File",
          key: "removeFile",
        },
      ],
      showPopupFamilyDetaila: false,
      deduction_under_80DD_table_columns_data: [],
      deduction_under_80DDB_table_columns_data:[],
      deduction_under_80C_table_columns_data: [],
      deduction_under_NPS_table_columns_data: [],
      deduction_under_80D_table_columns_data: [],
      arr:[],
      deduction_under_others_table_columns_data: [],
      deduction_under_80G_table_columns_data: [],
      deduction_under_80U_table_columns_data: [],
      income_from_previous_employee_table_columns_data: [],
      other_income_table_columns_data: [],
      deduction_under_80D_pop_up:[],
      deduction_under_80DD_pop_up:[],
      other_income_colums_header: [
        {
          label: "Particulars",
          key: "particulars",
          style: "width:15rem",
        },
        {
          label: "Declared Amount",
          key: "declaredAmount",
          style: "font-weight:bold;text-align:right;width:10rem",
        },
        {
          label: "Submitted Amount",
          key: "submittedAmount",
          style: "width:15rem;",
        },
        {
          label: "Verified Amount",
          key: "verifiedAmount",
          style: "font-weight:bold;text-align:right;width:10rem;",
        },
        {
          label: "Proof",
          key: "proof",
          style: "width:8rem;",
        },
        {
          label: "Status",
          key: "status",
        },
        {
          label: "Remarks",
          key: "remarks",
        },
      ],
      income_from_previos_employee_colums_header: [
        {
          label: "Particulars",
          key: "particulars",
          style: "width:15rem",
        },
        {
          label: "Declared Amount",
          key: "declaredAmount",
          style: "font-weight:bold;text-align:right;width:10rem",
        },
        {
          label: "Submitted Amount",
          key: "submittedAmount",
          style: "width:15rem;",
        },
        {
          label: "Verified Amount",
          key: "verifiedAmount",
          style: "font-weight:bold;text-align:right;width:10rem;",
        },
        // {
        //   label: "Proof",
        //   key: "proof",
        //   style: "width:8rem;",
        // },
        {
          label: "Status",
          key: "status",
        },
        {
          label: "Remarks",
          key: "remarks",
        },
      ],
      deduction_under_80C_table_colums_header: [
        {
          label: " 80C Particulars",
          key: "80Cparticulars",
          style: "width:15rem",
        },
        {
          label: "Declared Amount",
          key: "declaredAmount",
          style: "font-weight:bold;text-align:right;width:10rem",
        },
        {
          label: "Submitted Amount",
          key: "submittedAmount",
          style: "width:15rem;",
        },
        {
          label: "Verified Amount",
          key: "verifiedAmount",
          style: "font-weight:bold;text-align:right;width:10rem;",
        },
        {
          label: "Proof",
          key: "proof",
          style: "width:8rem;",
        },
        {
          label: "Status",
          key: "status",
        },
        {
          label: "Remarks",
          key: "remarks",
        },
      ],
      deduction_under_80C_table_colums_fornewRegime_header: [
        {
          label: " 80C Particulars",
          key: "80Cparticulars",
          style: "width:15rem",
        },
        {
          label: "",
          key: "declaredAmount",
          style: "font-weight:bold;text-align:right;width:10rem",
        },
      ],
      deduction_under_80DD_table_colums_header: [
        {
          label: "80DD Particulars",
          key: "80DDparticulars",
          style: "width:15rem",
        },
        {
          label: "Declared Amount",
          key: "declaredAmount",
          style: "font-weight:bold;text-align:right;width:10rem",
        },
        {
          label: "Submitted Amount",
          key: "submittedAmount",
          style: "width:15rem;",
        },
        {
          label: "Verified Amount",
          key: "verifiedAmount",
          style: "font-weight:bold;text-align:right;width:10rem;",
        },
        {
          label: "Proof",
          key: "proof",
          style: "width:8rem;",
        },
        {
          label: "Status",
          key: "status",
        },
        {
          label: "Remarks",
          key: "remarks",
        },
      ],
      deduction_under_80DDB_table_colums_header: [
        {
          label: "80DDB Particulars",
          key: "80DDBparticulars",
          style: "width:15rem",
        },
        {
          label: "Declared Amount",
          key: "declaredAmount",
          style: "font-weight:bold;text-align:right;width:10rem",
        },
        {
          label: "Submitted Amount",
          key: "submittedAmount",
          style: "width:15rem;",
        },
        {
          label: "Verified Amount",
          key: "verifiedAmount",
          style: "font-weight:bold;text-align:right;width:10rem;",
        },
        {
          label: "Proof",
          key: "proof",
          style: "width:8rem;",
        },
        {
          label: "Status",
          key: "status",
        },
        {
          label: "Remarks",
          key: "remarks",
        },
      ],
      deduction_under_80D_table_colums_header: [
        {
          label: "80D Particulars",
          key: "80Dparticulars",
          style: "width:15rem",
        },
        {
          label: "Declared Amount",
          key: "declaredAmount",
          style: "font-weight:bold;text-align:right;width:10rem",
        },
        {
          label: "Submitted Amount",
          key: "submittedAmount",
          style: "width:15rem;",
        },
        {
          label: "Verified Amount",
          key: "verifiedAmount",
          style: "font-weight:bold;text-align:right;width:10rem;",
        },
        {
          label: "Proof",
          key: "proof",
          style: "width:8rem;",
        },
        {
          label: "Status",
          key: "status",
        },
        {
          label: "Remarks",
          key: "remarks",
        },
      ],
      deduction_under_others_table_colums_header: [
        {
          label: "Particulars",
          key: "particulars",
          style: "width:15rem",
        },
        {
          label: "Declared Amount",
          key: "declaredAmount",
          style: "font-weight:bold;text-align:right;width:10rem",
        },
        {
          label: "Submitted Amount",
          key: "submittedAmount",
          style: "width:15rem;",
        },
        {
          label: "Verified Amount",
          key: "verifiedAmount",
          style: "font-weight:bold;text-align:right;width:10rem;",
        },
        {
          label: "Proof",
          key: "proof",
          style: "width:8rem;",
        },
        {
          label: "Status",
          key: "status",
        },
        {
          label: "Remarks",
          key: "remarks",
        },
      ],
      deduction_under_80G_table_colums_header: [
        {
          label: "80G Particulars",
          key: "80Gparticulars",
          style: "width:15rem",
        },
        {
          label: "Declared Amount",
          key: "declaredAmount",
          style: "font-weight:bold;text-align:right;width:10rem",
        },
        {
          label: "Submitted Amount",
          key: "submittedAmount",
          style: "width:15rem;",
        },
        {
          label: "Verified Amount",
          key: "verifiedAmount",
          style: "font-weight:bold;text-align:right;width:10rem;",
        },
        {
          label: "Proof",
          key: "proof",
          style: "width:8rem;",
        },
        {
          label: "Status",
          key: "status",
        },
        {
          label: "Remarks",
          key: "remarks",
        },
      ],
      deduction_under_80T_table_colums_header: [
        {
          label: "80T Particulars",
          key: "80Tparticulars",
          style: "width:15rem",
        },
        {
          label: "Declared Amount",
          key: "declaredAmount",
          style: "font-weight:bold;text-align:right;width:10rem",
        },
        {
          label: "Submitted Amount",
          key: "submittedAmount",
          style: "width:15rem;",
        },
        {
          label: "Verified Amount",
          key: "verifiedAmount",
          style: "font-weight:bold;text-align:right;width:10rem;",
        },
        {
          label: "Proof",
          key: "proof",
          style: "width:8rem;",
        },
        {
          label: "Status",
          key: "status",
        },
        {
          label: "Remarks",
          key: "remarks",
        },
      ],
      deduction_under_80U_table_colums_header: [
        {
          label: "80U Particulars",
          key: "80Uparticulars",
          style: "width:15rem",
        },
        {
          label: "Declared Amount",
          key: "declaredAmount",
          style: "font-weight:bold;text-align:right;width:10rem",
        },
        {
          label: "Submitted Amount",
          key: "submittedAmount",
          style: "width:15rem;",
        },
        {
          label: "Verified Amount",
          key: "verifiedAmount",
          style: "font-weight:bold;text-align:right;width:10rem;",
        },
        {
          label: "Proof",
          key: "proof",
          style: "width:8rem;",
        },
        {
          label: "Status",
          key: "status",
        },
        {
          label: "Remarks",
          key: "remarks",
        },
      ],
      house_rent_declaration_array: [],
      family_details_table_columns_data: [
        {
          name: "Akash",
          relationship: "",
          dependencies: "",
          age: "",
        },
      ],
      family_details_table_colums_header: [
        {
          label: "Name",
          key: "particulars",
        },
        {
          label: "Relationship",
          key: "relationship",
        },
        {
          label: "Date of Birth",
          key: "dob",
        },
        {
          label: "Age",
          key: "age",
        },
        {
          label: "",
          key: "delete",
        },
      ],
      sec_ten_exemption_table_colums_header: [
        {
          label: "Particulars",
          key: "particulars",
          style: "width:15rem",
        },
        {
          label: "Declared Amount",
          key: "declaredAmount",
          style: "font-weight:bold;text-align:right;width:10rem",
        },
        {
          label: "Submitted Amount",
          key: "submittedAmount",
          style: "width:15rem;",
        },
        {
          label: "Verified Amount",
          key: "verifiedAmount",
          style: "font-weight:bold;text-align:right;width:10rem;",
        },
        {
          label: "Proof",
          key: "proof",
          style: "width:8rem;",
        },
        {
          label: "Status",
          key: "status",
        },
        {
          label: "Remarks",
          key: "remarks",
        },
      ],
      house_rent_table_colums_header: [
        {
          label: "Particulars",
          key: "particulars",
          style: "width:14rem;",
        },
        {
          label: "Amount",
          key: "amount",
          style: "width:12rem;",
        },
        {
          label: "Owner Name",
          key: "ownerName",
          style: "width:12rem;",
        },
        {
          label: "Owner PAN Number",
          key: "ownerPanNumber",
          style: "width:14rem;",
        },
        {
          label: "Metro City",
          key: "metroCity",
          style: "width:14rem;",
        },
      ],
      incomeLossTableColumsHeaderOne: [
        {
          label: "(i)Interest on housing loan (Self occupied)",
          key: "interestOnHousingLoan",
          style: "width:15rem",
        },
        {
          label: "Declared Amount",
          key: "declaredAmount",
          style: "font-weight:bold;text-align:right;width:10rem",
        },
        {
          label: "Submitted Amount",
          key: "submittedAmount",
          style: "width:15rem;",
        },
        {
          label: "Verified Amount",
          key: "verifiedAmount",
          style: "font-weight:bold;text-align:right;width:10rem;",
        },
        {
          label: "Proof",
          key: "proof",
          style: "width:8rem;",
        },
        {
          label: "Status",
          key: "status",
        },
        {
          label: "Remarks",
          key: "remarks",
        },
      ],
      incomeLossTableColumsHeaderTwo: [
        {
          label: "(i)Income/Loss from house property(Letout)",
          key: "income/lossOnHouse",
          style: "width:12rem",
        },
        {
          label: "Declared Amount",
          key: "declaredAmount",
          style: "font-weight:bold;text-align:right;width:10rem",
        },
        {
          label: "Submitted Amount",
          key: "submittedAmount",
          style: "width:14rem",
        },
        {
          label: "Verified Amount",
          key: "verifiedAmount",
          style: "font-weight:bold;text-align:right;width:10rem;",
        },
        {
          label: "Proof",
          key: "proof",
          style: "width:8rem;",
        },
        {
          label: "Status",
          key: "status",
        },
        {
          label: "Remarks",
          key: "remarks",
        },
      ],
      income_loss_from_house_table_columns_data_one: [],
      income_loss_from_house_table_columns_data_three: [
        {
          joint_holder_name: "",
          relationship: "",
          tax_benefit: "",
        },
      ],
      income_loss_from_house_table_columns_data_letout_joint_Property: [
        {
          joint_holder_name: "",
          relationship: "",
          tax_benefit: "",
        },
      ],
      permanent_disability_under_80D_header: [
        {
          label: "Name",
          key: "name",
          style: "width:8rem;",
        },
        {
          label: "Relationship",
          key: "relationship",
        },
        {
          label: "Amount",
          key: "amount",
        },
        {
          label: "",
          key: "delete",
        },
      ],
      permanent_disability_under_80DDB_header: [
        {
          label: "Name",
          key: "name",
          style: "width:8rem;",
        },
        {
          label: "Relationship",
          key: "relationship",
        },
        {
          label: "Amount",
          key: "amount",
        },
        {
          label: "",
          key: "delete",
        },
      ],
      handicapped_disability_under_80DD_data: [
        {
          name: "",
        },
      ],
      income_loss_from_house_table_columns_data_two: {
        letout: [],
        joint_property_details:[]   
      },
      deduction_under_80DDB_pop_up_data:[],
      income_loss_from_house_table_columns_data_total: {},
      house_rent_table_columns_data: [
        {
          particulars: "01-Apr-2020 to 30-Apr-2023",
          amount: 40000,
          ownerName: "",
          ownerPanNumber: "",
          metroCity: "",
        },
        {
          particulars: "01-Apr-2020 to 30-Apr-2023",
          amount: 40000,
          ownerName: "",
          ownerPanNumber: "",
          metroCity: "",
        },
        {
          particulars: "01-Apr-2020 to 30-Apr-2023",
          amount: 40000,
          ownerName: "",
          ownerPanNumber: "",
          metroCity: "",
        },
        {
          particulars: "01-Apr-2020 to 30-Apr-2023",
          amount: 40000,
          ownerName: "",
          ownerPanNumber: "",
          metroCity: "",
        },
        {
          particulars: "01-Apr-2020 to 30-Apr-2023",
          amount: 40000,
          ownerName: "",
          ownerPanNumber: "",
          metroCity: "",
        },
      ],
      sec_ten_exemption_table_columns_data: [],
      promiseIP:[],
      form12BBDate:"",
      employeeName:'',
      bankPanRegex:"",
      personal: {
        first_name: null,
        last_name: null,
        code: null,
      },
      salary: {
        ctc: null,
        salary_structure_id: null,
        exempt_for_it_deduction_first_month: false,
        master_salary_structure: [],
      },
      it_plan_id: "",
      employeeId: "",
      instance: {
        le_id: "",
        employee_id: "",
        financial_year: "",
        it_plan_id: "",
      },
      data2: {
        exemption10: [],
        exemption17: [],
        deductionsUnderSection16: [],
        deductionsUnderChapterVIA: [],
        section24: [],
        previousEmploymentDetails: {},
        otherIncome: [],
        le_id: "",
        employee_id: "",
        financial_year: "",
        plan_id: "",
        regime_type: "",
      },
      finalSubmitButton: true,
      salaryPerk: [],
      tds_breakup_and_taxable_income: [],
      itSheet: [],
      first_name: "",
      last_name: "",
      ctc: "",
      code: "",
      totalIncomeTax: "",
      annualTax: "",
      showSuccessMsg: false,
      totalAmount_otherIncome: "",
      totalAmount_previousEmpDetails: "",
      show80DFamilyPopup: false,
      show80DParentsPopup: false,
      show80DSeniorParentsPopup: false,
      show80DFamilySeniorParentsPopup: false,
      showHraTooltipPopup: false,
      showSec10TooltipPopup: false,
      showInterestonEducationPopup: false,
      showInterestonHomeonePopup: false,
      showInterestonHometwoPopup: false,
      showInterestonEVPopup: false,
      showNPSEmployeeContributionPopup: false,
      showNPSEmployerContributionPopup: false,
      showInterestFromSavingAccount: false,
      subStartDate:"",
      now_date:"",
      showInterestFromSavingAccountforseniorcitizen: false,
      showPopupOtherTaxTcs: false,
      currentFinancialyear: false,
      enableTCS: false,
      other_tcs_table_columns_data : [],

      tcs_section_options: [
        "206CA - Collection at source from alcoholic liquor for human",
        "206CB - Collection at source from timber obtained under forest lease",
        "206CC - Collection at source from timber obtained by any mode other than a forest lease",
        "206CD - Collection at source from any other forest produce (not being tendu leaves)",
        "206CE - Collection at source from any scrap",
        "206CF - Collection at source from contractors or licensee or lease relating to parking lots",
        "206CG - Collection at source from contractors or licensee or lease relating to toll plaza",
        "206CH - Collection at source from contractors or licensee or lease relating to mine or quarry",
        "206CI - Collection at source from tendu Leaves",
        "206CJ - Collection at source from on sale of certain Minerals",
        "206CK - Collection at source on cash case of Bullion and Jewellery",
        "206CL - Collection at source on sale of Motor vehicle",
        "206CM - Collection at source on sale in cash of any goods(other than bullion/jewelry)",
        "206CN - Collection at source on providing of any services(other than Chapter-XVII-B)",
        "206CO - Collection at source on remittance under LRS for purchase of overseas tour program package",
        "206CP - Collection at source on remittance under LRS for educational loan taken from financial institution mentioned in section 80E",
        "206CQ - Collection at source on remittance under LRS for purpose other than for purchase of overseas tour package or for educational loan taken from financial institution",
        "206CR - Collection at source on sale of goods",
        "206CT - Collection at source on remittance under LRS is for the purposes of education or medical treatment and not covered under Code P"
      ],
      tcs_table_colums_header: [
        {
          key: "section_display_name",
          label: "Section under which Tax Collected at source",
        },
        {
          key: "name_of_collector",
          label: "Name of the Collector",
        },
        {
          key: "tan_of_collector",
          label: "TAN of the Collector",
        },
        {
          key: "planned",
          label: "Declared Amount",
        },
        {
          key: "actual",
          label: "Submitted Amount",
        },
        {
          key: "approved",
          label: "Verified Amount",
        },
        {
          key: "attachment",
          label: "Attachment",
        },
         {
           key: "status",
           label: "Status",
         },
        {
         key: "remarks",
        label: "Remarks",
       },
        {
          key: "delete",
          label: "Action",
        },
      ]
    };
  },
  computed: {
    ...mapState({
      payrollYear: (state) => state.payroll.runpayroll.payrollYear,
    }),
    ...mapGetters({
      getleid: "onboard/legal_entities/legal_entity_ID",
      getleData: "onboard/legal_entities/record",
      getITSettingsData: "onboard/statutoryinfo/incometax/getITData",
    }),
    ...mapState({
      globalData: (state) => state.globalapi.globalData.data,
    }),
    le_id() {
      return localStorage.getItem("le_id");
    },
    ifHr() {
      return localStorage.getItem("userRole") == "HR" ? true : false;
    },
    ifEmployee() {
      return localStorage.getItem("userRole") == "EMPLOYEE" ? true : false;
    },
    ifClientAdmin(){
      return localStorage.getItem("userRole") == "CLIENTADMIN" ? true : false;
    },
    empId() {
      return localStorage.getItem("empId");
    },
    emailId() {
      return localStorage.getItem("loginId");
    },
    totalRentExceedsOneLakh() {
      if (!this.house_rent_declaration_array || !this.house_rent_declaration_array.details) return false;
      const totalRent = this.house_rent_declaration_array.details.reduce((sum, item) => {
          const fromDate = new Date(item.from);
          const toDate = new Date(item.to);
          
          const fromYear = fromDate.getFullYear();
          const toYear = toDate.getFullYear();
          const fromMonth = fromDate.getMonth() + 1;
          const toMonth = toDate.getMonth() + 1;
          
          let monthsDiff;
          
          if (fromYear === toYear) {
            // Same year: simple month difference
            monthsDiff = toMonth - fromMonth + 1;
          } else {
            // Different years: months from first year + months from second year
            const monthsInFirstYear = 12 - fromMonth + 1; // Remaining months in first year
            const monthsInSecondYear = toMonth; // Months in second year
            monthsDiff = monthsInFirstYear + monthsInSecondYear;
          }
          
          const periodRent = monthsDiff * item.value;
          console.log(periodRent, "periodRent");
          return sum + periodRent;
      },  0)
      console.log(totalRent, "totalRent")

      return totalRent > 100000;
    },
  },
  watch:{
    uploadMethod(data){
      this.regime_type = (data == "newregime")?false:true
      this.regime_type = (data == "oldregime")?true:false
      this.saveDataForFinalArray("regimeChange")
    }
  },
  mounted() {
    this.salaryTableData = [];
    // this.isDateInRange()
    this.fetchRecord();
    this.pancardRegex = globalConfig.Regex.IT_EMPLOYEE_PAN;
    this.bankPanRegex = globalConfig.Regex.BANK_PAN
            this.getItSubmissionData();
    this.ipAddressFunction();
     setInterval(this.timeFunction,10000)
    (this.section_ten_attachments_pop_up = false),
      (this.house_rent_attachments_pop_up = false),
      (this.deduction_under_6A_attachments_pop_up = false),
      (this.income_loss_from_house_attachments_pop_up = false),
      (this.income_from_previous_employee_pop_up = false),
      (this.other_income_attachments_pop_up = false);
      (this.other_tcs_attachment_pop_up = false);
  },
  activated() {
    //this.fetchAllSalaryStructureData();
    this.salaryTableData = [];
    //this.setRecordData();
    this.fetchRecord();
    setInterval(this.timeFunction,60000)
    this.attachments_pop_up = false;
  },
  updated() {
    setInterval(this.timeFunction,60000)
    this.house_rent_declaration_array = this.house_rent_declaration_array;
    //console.log(this.house_rent_declaration_array, "updated");
  },
  methods: {
    ...mapActions({
      act_getProfileData:
        "dashboard/payroll/monthlypayroll/employeeProfile/fetchAll",
      getAllItProofSubmissionData: "dashboard/itProof/fetchAll",
      uploadFileToS3Bucket:"dashboard/itProof/uploadFileToS3Bucket",
      deleteFileInS3bucket:"dashboard/itProof/deleteFileInS3bucket",
      form12BBURL:"dashboard/itProof/form12BBURL",
      form12BBupdateURL:"dashboard/itProof/update12BBURL",
      postAllITProofData: "dashboard/itProof/postAllITProofData",
      act_get_plan: "dashboard/payroll/incometax/getPlan",
      act_fetchEmpById: "onboard/employees/fetchEmpDataById",
      fetchEmployeeCode: "onboard/employees/fetchEmployeeCode",
      act_fetchAll: "onboard/settings/salary_structure/fetchAll",
      act_fetchsalarycomponents:"onboard/settings/salary_component/fetchAllsalaryComponentsData",
      act_set_it_data: "dashboard/payroll/incometax/setItData",
      act_save_it_plan: "dashboard/payroll/incometax/createItData",
      act_fetch_plan_name: "dashboard/payroll/incometax/getPlanName",
      getOrgLeList: "onboard/organization/getOrgLeIdList",
      getPreSignedUrl: "payroll/lopsandrlops/createPreSigned",

    }),
    isOtherFieldDisabled(currentRecord) {
      if (!currentRecord || !currentRecord.InvestmentComponentType) {
        return false;
      }
      
      const currentName = currentRecord.InvestmentComponentType.name;
      const is80TTA = currentName === 'Interest from Savings Bank Account';
      const is80TTB = currentName === 'Interest from Savings Bank Account - Sr Citizens';
      
      if (!is80TTA && !is80TTB) {
        return false;
      }
      
      if (!this.deduction_under_others_table_columns_data) {
        return false;
      }
      
      if (is80TTA) {
        const tttbRecord = this.deduction_under_others_table_columns_data.find(record => 
          record.InvestmentComponentType && record.InvestmentComponentType.name === 'Interest from Savings Bank Account - Sr Citizens'
        );
        return (tttbRecord && tttbRecord.actual && Number(tttbRecord.actual) > 0)?true:false;
      }
      
      if (is80TTB) {
        const tttaRecord = this.deduction_under_others_table_columns_data.find(record => 
          record.InvestmentComponentType && record.InvestmentComponentType.name === 'Interest from Savings Bank Account'
        );
        return (tttaRecord && tttaRecord.actual && Number(tttaRecord.actual) > 0)? true:false;
      }
      
      return false;
    },
    isDisabilityFieldDisabled(currentRecord) {
      if (!currentRecord || !currentRecord.InvestmentComponentType) {
        return false;
      }
      
      const currentName = currentRecord.InvestmentComponentType.name;
      const isDisability40 = currentName === 'Person with Disability (40% - 80%)';
      const isDisability80 = currentName === 'Person with Sever Disability (>80%)';
      
      if (!isDisability40 && !isDisability80) {
        return false;
      }
      
      if (!this.deduction_under_80U_table_columns_data) {
        return false;
      }
      
      if (isDisability40) {
        const disability80Record = this.deduction_under_80U_table_columns_data.find(record => 
          record.InvestmentComponentType && record.InvestmentComponentType.name === 'Person with Sever Disability (>80%)'
        );
        return (disability80Record && disability80Record.actual && Number(disability80Record.actual) > 0)?true:false;
      }
      
      if (isDisability80) {
        const disability40Record = this.deduction_under_80U_table_columns_data.find(record => 
          record.InvestmentComponentType && record.InvestmentComponentType.name === 'Person with Disability (40% - 80%)'
        );
        return (disability40Record && disability40Record.actual && Number(disability40Record.actual) > 0)?true:false;
      }
      
      return false;
    },
    isJointHolderAndRelationshipFilledforSelfOccupiedinOldRegime(index) {
      const row = this.income_loss_from_house_table_columns_data_three[index];
      return row.joint_holder_name.trim() !== "" && row.relationship.trim() !== "";
    },
    isJointHolderAndRelationshipFilledforLetOutinOldRegime(index) {
      const row = this.income_loss_from_house_table_columns_data_letout_joint_Property[index];
      return row.joint_holder_name.trim() !== "" && row.relationship.trim() !== "";
    },
    isJointHolderAndRelationshipFilledforLetOutinNewRegime(index) {
      const row = this.income_loss_from_house_table_columns_data_letout_joint_Property[index];
      return row.joint_holder_name.trim() !== "" && row.relationship.trim() !== "";
    },
    show6APopup(keys){
      console.log("Keys:", keys);
      if(keys=="Medical Insurance Premium Self & Family"){        
        this.show80DFamilyPopup = true;
      }
      else if(keys=="Medical Insurance Premium Parents Sr. Citizen"){        
        this.show80DSeniorParentsPopup = true;
      }
      else if(keys=="Medical Insurance Premium Parents"){        
        this.show80DParentsPopup = true;
      }
      else if(keys=="Medical Insurance Premium Self & Family Sr. Citizen"){        
        this.show80DFamilySeniorParentsPopup = true;
      }
      else if(keys=="Interest on Education Loan"){        
        this.showInterestonEducationPopup = true;
      }
      else if(keys=="Interest on Home Loan (Availed during 2016-17)"){        
        this.showInterestonHomeonePopup = true;
      }
      else if(keys=="Interest on Home Loan (Availed during 2019-20 for the first house)"){        
        this.showInterestonHometwoPopup = true;
      }
      else if(keys=="Interest on Purchase of Electric vehicles (Availed after 1st April 2019)"){        
        this.showInterestonEVPopup = true;
      }
      else if(keys=="NPS Employee Contribution"){        
        this.showNPSEmployeeContributionPopup = true;
      }
      else if(keys=="NPS Employer Contribution"){        
        this.showNPSEmployerContributionPopup = true;
      }
      else if(keys=="Interest from Savings Bank Account"){        
        this.showInterestFromSavingAccount = true;
      }
      else if(keys=="Interest from Savings Bank Account - Sr Citizens"){        
        this.showInterestFromSavingAccountforseniorcitizen = true;
      }
      
      // else if(keys==)
      
    },
    validateInput(event, index) {      
      const regex = /^[A-Za-z\s]*$/;
      const input = event.target.value;

      if (!regex.test(input)) {
        const sanitizedInput = input.replace(/[^A-Za-z\s]/g, '');
        event.target.value = sanitizedInput;
        this.income_loss_from_house_table_columns_data_three[index].joint_holder_name = sanitizedInput;
      }
    },
 
    validateName(index) {      
      const regex = /^[A-Za-z\s]*$/;
      const inputValue = this.income_loss_from_house_table_columns_data_three[index].joint_holder_name;
      if (!regex.test(inputValue)) {
        this.income_loss_from_house_table_columns_data_three[index].joint_holder_name = inputValue.replace(/[^A-Za-z\s]/g, '');
      }
    },
    async ipAddressFunction(){
      this.promiseIP = await fetch("https://api.ipify.org?format=json")
          .then((response) => {
            return response.json();
          })
          .then((data) => {
            return data.ip;
          })
    },
     showConfirmMessageFunction(){
     this.showDeleteConfirmation=true;
     },
     timeFunction(){
      var formBBDate = new Date()
      var hours = formBBDate.getHours()
      var minutes = formBBDate.getMinutes()
      var ampm = hours >= 12 ? 'pm' : 'am';
      minutes = minutes < 10 ? '0'+minutes : minutes;
      var strTime = hours + ':' + minutes + ' ' + ampm;
      this.form12BBDate = formBBDate.getDate()+"/"+(formBBDate.getMonth()+1)+"/"+formBBDate.getFullYear()+" "+strTime
     },
    relationChange(val, index,record) {
        switch(record){
          case '80_d_popup':
         
            let isPresent80D = this.deduction_under_80D_pop_up.some(obj => obj.name === val.name)
            if (isPresent80D) {
              
              this.toast = true
               this.errmsg="Dependents Cannot be same"  
              this.deduction_under_80D_pop_up.splice(index,1)
            } else {
              //console.log("absent")
              this.deduction_under_80D_pop_up[index].relationShip = val.relationship;
               this.deduction_under_80D_pop_up[index].name = val.name;
              }
             
            break;
          case '80_ddb_popup':
           let isPresent80DDB = this.deduction_under_80DDB_pop_up_data.some(obj => obj.name === val.name)
            if (isPresent80DDB) {
              
              this.toast = true
               this.errmsg="Dependencies Cannot be same"  
              this.deduction_under_80DDB_pop_up_data.splice(index,1)
            } else {
              //console.log("absent")
              this.deduction_under_80DDB_pop_up_data[index].relationShip = val.relationship;
               this.deduction_under_80DDB_pop_up_data[index].name = val.name;
              }
          break;
          case '80_dd_popup':
           let isPresent80DD = this.deduction_under_80DD_pop_up.some(obj => obj.name === val.name)
            if (isPresent80DD) {
              
              this.toast = true
               this.errmsg="Dependencies Cannot be same"  
              this.deduction_under_80DD_pop_up.splice(index,1)
            } else {
              //console.log("absent")
              this.deduction_under_80DD_pop_up[index].relationShip = val.relationship;
               this.deduction_under_80DD_pop_up[index].name = val.name;
              }
          break;
        }
      },
    function_for_chapter6A(record, value, index) {
      switch (value) {
        
        case 'deduction_under_80D':
          this.deduction_under_80D_pop_up=[]
       
             if(record.InvestmentComponentType.name == "Medical Insurance Premium Parents"){
              this.deduction_under_80D_table_columns_data.map((item)=>{
                if(item.InvestmentComponentType.name == "Medical Insurance Premium Parents Sr. Citizen"){
                  if(item.actual > 0){
                    this.showPopupUnder80D = false
                  }else{
                    this.showPopupUnder80D = true 
                  }
                  }
                  })
            
             }else if(record.InvestmentComponentType.name == "Medical Insurance Premium Parents Sr. Citizen") {
             this.deduction_under_80D_table_columns_data.map((item)=>{
                  if(item.InvestmentComponentType.name == "Medical Insurance Premium Parents"){
                  if(item.actual > 0){
                    this.showPopupUnder80D = false
                  }else{
                    this.showPopupUnder80D = true 
                  }
                  }})
                  
             }else if( record.InvestmentComponentType.name =="Medical Insurance Premium Self & Family"){
                this.deduction_under_80D_table_columns_data.map((item)=>{
                  if(item.InvestmentComponentType.name == "Medical Insurance Premium Self & Family Sr. Citizen"){
                  if(item.actual > 0){
                    this.showPopupUnder80D = false
                  }else{
                    this.showPopupUnder80D = true 
                  }
                  }})
             }else if( record.InvestmentComponentType.name =="Medical Insurance Premium Self & Family Sr. Citizen"){
                this.deduction_under_80D_table_columns_data.map((item)=>{
                  if(item.InvestmentComponentType.name == "Medical Insurance Premium Self & Family"){
                  if(item.actual > 0){
                    this.showPopupUnder80D = false
                  }else{
                    this.showPopupUnder80D = true 
                  }
                  }})
             }else{
                this.showPopupUnder80D = true
             }
        
       
          this.pop_up_header_80D = (record.InvestmentComponentType.name || slotprops.value.record.name)
          // console.log(this.pop_up_header_80D,"header")
          if (this.pop_up_header_80D == "Medical Insurance Premium Parents") {
            //  console.log("header")
           let options= this.options_for_6a_family_dependant.filter((item) => item.relationship == "Mother" || item.relationship == "Father")
              this.options_for_6a_family_dependant=options
            // console.log(this.options_for_6a_family_dependant)
          }
          else if (this.pop_up_header_80D == "Medical Insurance Premium Self & Family Sr. Citizen") {
            let options= this.options_for_6a_family_dependant.filter((item) => item.age>60)
            this.options_for_6a_family_dependant=options
          }
          else if (this.pop_up_header_80D == "Preventive Health Check Up Upto 5000 Part of Above") {
             let options= this.options_for_6a_family_dependant.filter((item) => item.relationship == "Mother" || item.relationship == "Father"|| item.relationship == "Self")
              this.options_for_6a_family_dependant=options
          } else if (this.pop_up_header_80D == "Medical Insurance Premium Parents Sr. Citizen") {
            let options= this.options_for_6a_family_dependant.filter((item) => item.age>60 && item.relationship == "Mother" || item.relationship == "Father" )
            this.options_for_6a_family_dependant=options
          }
          
          if (record.family_details) {
          this.deduction_under_80D_pop_up = record.family_details  
          } else {
            this.deduction_under_80D_pop_up.push({
              name: "",
              relationShip: "",
              amount: "",
            });
          }
        
            
          break;
        case "deduction_under_80DD":
          this.deduction_under_80DD_pop_up=[]
          this.deduction_under_80DD_table_columns_data.map((item)=>{
              if(item.InvestmentComponentType.name !== record.InvestmentComponentType.name){
              if(item.actual > 0){
                 this.showPopupUnder80DD = false
              }else{
              this.showPopupUnder80DD = true
              }
              }
                  
          }
          )
          
          this.pop_up_80DD_header = (record.InvestmentComponentType.name || slotprops.value.record.name)
              // console.log("header")
           let options= this.options_for_6a_family_dependant.filter((item) => item.relationship != "Self")
              this.options_for_6a_family_dependant=options
          if (record.family_details) {
          this.deduction_under_80DD_pop_up = record.family_details  
          } else {
            this.deduction_under_80DD_pop_up.push({
              name: "",
              relationShip: "",
              amount: "",
            });
          }
        
          break;
        case "deduction_under_80DDB":
            this.deduction_under_80DDB_pop_up_data=[]
                this.deduction_under_80DDB_table_columns_data.map((item)=>{
              if(item.InvestmentComponentType.name !== record.InvestmentComponentType.name){
              if(item.actual > 0){
                 this.showPopupUnder80DDB = false
              }else{
              this.showPopupUnder80DDB = true
              }
              }
                  
          }
          )
           
          this.pop_up_80DDB_header = (record.InvestmentComponentType.name || slotprops.value.record.name)
          if (this.pop_up_80DDB_header == "Medical Treatment Expenses - Specified Diseases Sr Citizen") {
            // console.log("header")
            let options = this.options_for_6a_family_dependant.filter((item) => item.age > 60)
            this.options_for_6a_family_dependant = options
          }
             if (record.family_details) {
          this.deduction_under_80DDB_pop_up_data = record.family_details  
          } else {
            this.deduction_under_80DDB_pop_up_data.push({
              name: "",
              relationShip: "",
              amount: "",
            });
          }
        
          break;

      }
    },
    function_from_chapter6a_popup(header, record) {
    //  console.log("header",header,record) 
      var totalAmount = 0;
       switch(record){
        case "pop_up_80d":
        this.deduction_under_80D_pop_up.map((record) => {
            totalAmount += Number(record.amount);
            this.deduction_under_80D_table_columns_data && this.deduction_under_80D_table_columns_data.map((record,index)=>{
          if(record.InvestmentComponentType && record.InvestmentComponentType.name == header){
          this.deduction_under_80D_table_columns_data[index].actual= totalAmount;
          this.deduction_under_80D_table_columns_data[index].family_details = this.deduction_under_80D_pop_up
         }else if(record.name&&record.name == header){
          this.deduction_under_80D_table_columns_data[index].actual= totalAmount;
          this.deduction_under_80D_table_columns_data[index].family_details = this.deduction_under_80D_pop_up
         }
      })
          });
          this.showPopupUnder80D = false; 
          break;
          case "pop_up_80dd" :
          this.deduction_under_80DD_pop_up.map((record) => {
            totalAmount += Number(record.amount);
            this.deduction_under_80DD_table_columns_data && this.deduction_under_80DD_table_columns_data.map((record,index)=>{
          if(record.InvestmentComponentType && record.InvestmentComponentType.name == header){
          this.deduction_under_80DD_table_columns_data[index].actual= totalAmount;
          this.deduction_under_80DD_table_columns_data[index].family_details = this.deduction_under_80DD_pop_up
         }else if(record.name&&record.name == header){
          this.deduction_under_80DD_table_columns_data[index].actual= totalAmount;
          this.deduction_under_80DD_table_columns_data[index].family_details = this.deduction_under_80DD_pop_up
         }
      })
          });
          this.showPopupUnder80DD = false
          break;
          case "pop_up_80ddb" :
          this.deduction_under_80DDB_pop_up_data.map((record) => {
            totalAmount += Number(record.amount);
            this.deduction_under_80DDB_table_columns_data && this.deduction_under_80DDB_table_columns_data.map((record,index)=>{
          if(record.InvestmentComponentType&&record.InvestmentComponentType.name == header){
          this.deduction_under_80DDB_table_columns_data[index].actual= totalAmount;
          this.deduction_under_80DDB_table_columns_data[index].family_details = this.deduction_under_80DDB_pop_up_data
         }else if(record.name&&record.name == header){
          this.deduction_under_80DDB_table_columns_data[index].actual= totalAmount;
          this.deduction_under_80DDB_table_columns_data[index].family_details = this.deduction_under_80DDB_pop_up_data
         }
      })
          });
          this.showPopupUnder80DDB = false
          break;
       }
      
     
    },
    addMoreRows() {
      if (this.income_loss_from_house_table_columns_data_three.length < 4) {
        this.income_loss_from_house_table_columns_data_three.push({
          joint_holder_name: "",
          relationship: "",
          tax_benefit: "",
        });
      }
    },
    checkSelfJointHolder(val,ind) {
      //console.log(val, ind, this.income_loss_from_house_table_columns_data_three, val, ind, "hello")
      const sumobject = this.income_loss_from_house_table_columns_data_three.reduce((sum, obj) => sum + obj.tax_benefit,0)
      //console.log(sumobject,"hiii")
      if (sumobject > 100) {
        //console.log("true");
        this.income_loss_from_house_table_columns_data_three[ind].tax_benefit = 0
         window.alert("Tax benefit claimed by joint holder cannot exceed more than 100%")
      } else {
        //console.log("false");
        this.toast = false
           this.income_loss_from_house_table_columns_data_three[ind].tax_benefit=val
        }
       
    },
    checkLetOutJointHolder(val,ind) {
      //console.log(val, ind, this.income_loss_from_house_table_columns_data_letout_joint_Property, val, ind, "hello")
      const sumobject = this.income_loss_from_house_table_columns_data_letout_joint_Property.reduce((sum, obj) => sum + obj.tax_benefit,0)
      //console.log(sumobject,"hiii")
      if (sumobject > 100) {
        //console.log("true");
        this.income_loss_from_house_table_columns_data_letout_joint_Property[ind].tax_benefit = 0
       window.alert("Tax benefit claimed by joint holder cannot exceed more than 100%")
      } else {
        //console.log("false");
        this.toast = false
           this.income_loss_from_house_table_columns_data_letout_joint_Property[ind].tax_benefit=val
        }
       
    },
    deleteRow(value, index, relation) {
      //console.log(value, index, "dlete");
      // console.log(this.house_rent_declaration_array.details);
      switch (value) {
        case "family_details":
          this.employeeFamilyDetails[0].details[index].isDelete = true;
          if (
            relation == "Self" ||
            relation == "Mother" ||
            relation == "Father"
          ) {
            if (!this.options_for_relationship.includes(relation)) {
              this.options_for_relationship.unshift(relation);
            }
          }
          this.employeeFamilyDetails[0].details.splice(index,1)
          break;
        case "house_rent_declaration":
        this.house_rent_declaration_array.details.splice(index,1)
          // this.house_rent_declaration_array.details[index].isDelete = true;
          break;
        case "tcs_data":
          this.other_tcs_table_columns_data.splice(index, 1);
          break;
        case "deduction_under_6a_80u":
          this.deduction_under_80U_pop_up_data.splice(index, 1);
          break;
        case "deduction_under_6a_80DD":
          this.deduction_under_80DD_pop_up.splice(index,1);
          break;
          case "deduction_under_6a_80DDB":
          this.deduction_under_80DDB_pop_up_data.splice(index,1);
          break;
        case "income_loss":
          this.income_loss_from_house_table_columns_data_three.splice(index, 1);
          break;
        case "income_loss_letout":
          this.income_loss_from_house_table_columns_data_letout_joint_Property.splice(index, 1);
          break;
        case "deduction_under_6a_80D":   
        this.deduction_under_80D_pop_up.splice(index,1);
        break;
      }
      //console.log(this.house_rent_declaration_array.details, "hra");
    },
    addOneMoreRow(){
        if (this.income_loss_from_house_table_columns_data_three.length < 4) {
                    this.income_loss_from_house_table_columns_data_three.push({
                      joint_holder_name: "",
                      relationship: "",
                      tax_benefit: "",
                    });
                  }
    },
    addMoreRow(value, header) {
      switch (value) {
        case "family_details":
          this.employeeFamilyDetails[0].isSave = false;
          this.allowOtherSections =
            this.employeeFamilyDetails[0].isSave == false ? true : false;
          this.employeeFamilyDetails[0].details.push({
            name: "",
            relationship: "",
            dependencies: "",
            age: "",
            isDelete: false,
            dob: "",
          });
          //console.log(this.employeeFamilyDetails[0], "data");
          break;
          case "adding_Self":
          this.employeeFamilyDetails[0].isSave = false;
          this.allowOtherSections =
            this.employeeFamilyDetails[0].isSave == false ? true : false;
          this.employeeFamilyDetails[0].details.push({
            name: this.employeeName,
            relationship: "Self",
            dependencies: "",
            age: this.now_date,
            isDelete: false,
            dob: this.empProfileDob,
          });

            break;
        case "house_rent_declaration":
          
          const date = new Date(
            this.house_rent_declaration_array.details[
              this.house_rent_declaration_array.details.length - 1
            ]["to"]
          ); 
          let year1 = date.getFullYear()
          let month1 = date.getMonth()
          let day1 = date.getDate()
          let year2 = new Date(this.fiscalYearEnd).getFullYear()  
          let month2 = new Date(this.fiscalYearEnd).getMonth()
          let day2=new Date(this.fiscalYearEnd).getDate()
          // console.log(year1,month1,day1,"next",year2,month2,day2,"boolean",year1 != year2 && month1 != month2 && day1 != day2);
          if (year1 !== year2 || month1 !== month2 || day1 !== day2) {
             this.house_rent_declaration_array.details.push({
            metro: false,
            from: new Date(date.setDate(date.getDate() + 1)).toISOString().split("T")[0],

            to: this.fiscalYearEndPlus.toISOString().split("T")[0],
            isDelete: false,
            value: "",
            ownerDetails: {
              metro: "non_metro",
              panNumber: "",
              state: "",
               },
         status:""   
          });
          } else {
            this.toast = true;
            this.errmsg = "The complete duration for the HRA Decalration has been selected, to add more records please update 'To Date' "
            setTimeout(() => {
              this.toast=false
            }, 3000);
          }
         
          //console.log(this.house_rent_declaration_array, "last");
          break;
        case "tcs_data":
          this.other_tcs_table_columns_data.push({
            section_display_name: "",
            name_of_collector: "",
            tan_of_collector: "",
            planned: 0,
            actual: 0,
            approved: 0,
            file_path: "",
            file_name: "",
            status: "Pending",
            remarks: ""
          });
          break;
        case "income_loss":
          if (this.income_loss_from_house_table_columns_data_three.length < 4) {
            this.income_loss_from_house_table_columns_data_three.push({
              joint_holder_name: "",
              relationship: "",
              tax_benefit: "",
            });
          }
        case "income_loss_letout":
          if(this.income_loss_from_house_table_columns_data_letout_joint_Property.length < 4){
            this.income_loss_from_house_table_columns_data_letout_joint_Property.push({
              joint_holder_name:"",
              relationship:"",
              tax_benefit:"",
            })
          }
        case "deduction_under_6a_80DD":
          this.deduction_under_80DD_pop_up.push({
              name: "",
              relationShip: "",
              amount: "",
            })
        case "deduction_under_6a_80DDB":
          this.deduction_under_80DDB_pop_up_data.push({
            name: "",
            relationShip: "",
            amount: "",
          });
        case "deduction_under_6a_80D":   
        this.deduction_under_80D_pop_up.push({
              name: "",
              relationShip: "",
              amount: "",
            })
      }
    },
    removeTime(val) {
      console.log(val,"time")
      this.house_rent_declaration_array.details.map((item, index) => {
        if (index > 0) {
          item.from = "";
          // item.to=""  
          }   
      })
    },
    hraOnchange(val, index) {
      console.log(val, index, "hraonchnage")
       this.house_rent_declaration_array.details[index].value=val
      if (val == 0) {
      this.house_rent_declaration_array.details[index].ownerDetails.state="No City"
      } 
    },
    sendMetroValue(val, index) {
      //console.log(val, index, "metro");
      if (val != "Other") {
        this.house_rent_declaration_array.details[index].metro = true;
        this.house_rent_declaration_array.details[index].ownerDetails.metro =
          "metro";
        this.house_rent_declaration_array.details[index].ownerDetails.state =
          val;
      } else {
        this.house_rent_declaration_array.details[index].metro = false;
        this.house_rent_declaration_array.details[index].ownerDetails.metro =
          "non_metro";
          this.house_rent_declaration_array.details[index].ownerDetails.state ="";
      }
    
    },

    calculateAge(dob, index) {
      
      var dob = new Date(dob);
      if (dob == null || dob == "") {
        this.errmsg = "Please enter Valid DOB";
        this.toast = true;
      } else {
       
        var month_diff = Date.now() - dob.getTime();

        
        var age_dt = new Date(month_diff);

        
        var year = age_dt.getUTCFullYear();

        
        var age = Math.abs(year - 1970);
        
        this.employeeFamilyDetails[0].details[index].age = age;
        
      }
    },
    checkRelationship(relation) {
      
      if (relation == "Self" || relation == "Mother" || relation == "Father" || relation == "Spouse") {
        
        var index = this.options_for_relationship.indexOf(relation);
        if (index !== -1) {
          
          this.options_for_relationship.splice(index, 1);
        }
      
      }
   
    },
    childValidation() {
      // console.log("child");
      if(this.employeeFamilyDetails[0].no_of_children>9){
        this.toast = true
        this.errmsg = "No of Children - Restricted max to 9"
        this.employeeFamilyDetails[0].no_of_children = 0;
      }
      else if(this.employeeFamilyDetails[0].no_of_school_children>9){
        this.toast = true
        this.errmsg = "No of School Going Children - Restricted max to 9"
        this.employeeFamilyDetails[0].no_of_school_children = 0;
      }
      else if(this.employeeFamilyDetails[0].no_of_hostel_children>9){
        this.toast = true
        this.errmsg = "No of Hostel Staying Children - Restricted max to 9"
        this.employeeFamilyDetails[0].no_of_hostel_children = 0;
      }
      else if (
         this.employeeFamilyDetails[0].no_of_children<this.employeeFamilyDetails[0].no_of_school_children ||this.employeeFamilyDetails[0].no_of_children<this.employeeFamilyDetails[0].no_of_hostel_children 
      ) {
        
        this.employeeFamilyDetails[0].no_of_children = 0;
        this.employeeFamilyDetails[0].no_of_school_children = 0;
        this.employeeFamilyDetails[0].no_of_hostel_children = 0;
        this.toast = true;
        this.errmsg = "Please Enter Valid Children Details";
        
      } else if (this.employeeFamilyDetails[0].no_of_hostel_children> this.employeeFamilyDetails[0].no_of_school_children) {
        this.employeeFamilyDetails[0].no_of_children = 0;
        this.employeeFamilyDetails[0].no_of_school_children = 0;
        this.employeeFamilyDetails[0].no_of_hostel_children = 0;
         this.toast = true;
        this.errmsg = "No. of Hostel going children cannot be greater than school going";
      }
      else {
      this.toast=false  
      }
    },
    isDateInRange(fromDate, toDate) {
      const startDate = new Date(fromDate); 
      const endDate = new Date(toDate);
      const checkDate=new Date()
      startDate.setHours(0, 0, 0, 0);
      endDate.setHours(0, 0, 0, 0);
      checkDate.setHours(0, 0, 0, 0);
      console.log("startDate",startDate,"endDate",endDate,"checkDate",checkDate)
      this.dateCheck = checkDate >= startDate && checkDate <= endDate
      console.log("date",this.dateCheck)
      if (this.dateCheck==false) {
        this.dateSuccess=true  
      }
      // console.log("time check",this.dateCheck,this.dateSuccess)
    },

    // Function to check if a date falls within any date range in the array
    // isDateInRange(arrayOfObjects, targetDate) {
    
    //   for (let i = 0; i < arrayOfObjects.length - 1; i++) {
    //     const fromDate = new Date(arrayOfObjects[i].from);
    //     const toDate = new Date(arrayOfObjects[i].to);

    //     if (targetDate >= fromDate && targetDate <= toDate) {
    //       return true; // Target date is within the range
    //     }
    //   }

    //   return false; // Target date is not within any range
    // },
    // checkResult(date) {
    //   if (this.isDateInRange(this.house_rent_declaration_array.details, date)) {
    //     console.log(`${date.toISOString()} is within a date range.`);
    //   } else {
    //     console.log(`${date.toISOString()} is not within a date range.`);
    //   }
    // },
    prevEmployeeValidation() {
     
     return !this.income_from_previous_employee_table_columns_data[0].some(el => el.actual > 0 )
    },
    prevEmployeeChange(val,index) {
      //console.log("values", val, index, "all", this.income_from_previous_employee_table_columns_data);
      this.income_from_previous_employee_table_columns_data[0][index].actual = val
      this.toast=false
      for (let i = 1; i < this.income_from_previous_employee_table_columns_data[0].length; i++){
        if (this.income_from_previous_employee_table_columns_data[0][i].actual >= this.income_from_previous_employee_table_columns_data[0][0].actual) {
          this.income_from_previous_employee_table_columns_data[0][i].actual = 0
          if (index != 0) {
             this.toast = true; 
            this.errmsg = `${this.previousEmployerNames[this.income_from_previous_employee_table_columns_data[0][index].name]} cannot be greater than Salary Income`  
          }
        
          
        } else if (i == 1 && this.income_from_previous_employee_table_columns_data[0][i].actual > 2500) {
          this.income_from_previous_employee_table_columns_data[0][index].actual = 0
          this.toast = true;
       //console.log("elseif");  
          this.errmsg = `${this.previousEmployerNames[this.income_from_previous_employee_table_columns_data[0][index].name]} cannot exceed Rs.2500`
          break;   
        } 
      }

    },
    uploadValidation(value,type) {
      switch (value) {
        case "section_ten_exemption":
          return this.sec_ten_exemption_table_columns_data && this.sec_ten_exemption_table_columns_data.some(function (el) {
            return (el.actual > 0 && !el.file_location) || ( el.file_location && el.actual<=0);
          });
          break;
          case "other_income":
           
          return this.other_income_table_columns_data && this.other_income_table_columns_data.some(function (el) {
            return (el.actual > 0 && !el.file_location) || ( el.file_location && el.actual<=0);
          });
          break;
         case "income/loss_from_house":
        
            return this.income_loss_from_house_table_columns_data_two.letout && this.income_loss_from_house_table_columns_data_two.letout.some(function(el,index){
              if(index == 0){
             return (el.actual > 0 && !el.file_location) || ( el.file_location && el.actual<=0)
              }
              

          });
          break;
            case "income/loss_self":
     
          // console.log(this.income_loss_from_house_table_columns_data_one);
                
            return this.income_loss_from_house_table_columns_data_one && this.income_loss_from_house_table_columns_data_one.some(function(el){
             
             return el.total_actual>0?!el.bank_details.bank_name ||!el.bank_details.bank_pancard_number ||!el.bank_details.bank_address ||!el.bank_details.home_address||!el.file_location ||!el.bank_details.pre_emi_interest_paid:false
              
          });
          break;
        case "deduction_under_chapter_VI_A_80C":
          return this.deduction_under_80C_table_columns_data && this.deduction_under_80C_table_columns_data.some(function (
            el
          ) {
            return (el.actual > 0 && !el.file_location) || ( el.file_location && el.actual<=0);
          });
          break;
        case "deduction_under_chapter_VI_A_80D":
          return this.deduction_under_80D_table_columns_data && this.deduction_under_80D_table_columns_data.some(function (
            el
          ) {
            return (el.actual > 0 && !el.file_location) || ( el.file_location && el.actual<=0);
          });
          break;
         case "deduction_under_chapter_VI_A_80DD":
         return this.deduction_under_80DD_table_columns_data && this.deduction_under_80DD_table_columns_data.some(function (
            el
          ) {
            return (el.actual > 0 && !el.file_location) || ( el.file_location && el.actual<=0);
          });
          break;
          case "deduction_under_chapter_VI_A_80DDB":
         return this.deduction_under_80DDB_table_columns_data && this.deduction_under_80DDB_table_columns_data.some(function (
            el
          ) {
            return (el.actual > 0 && !el.file_location) || ( el.file_location && el.actual<=0);
          });
          break;
        case "deduction_under_chapter_VI_A_others":
          return this.deduction_under_others_table_columns_data && this.deduction_under_others_table_columns_data.some(function (
            el
          ) {
            return (el.actual > 0 && !el.file_location) || ( el.file_location && el.actual<=0);
          });
          break;
        case "deduction_under_chapter_VI_A_80G":
          return this.deduction_under_80G_table_columns_data && this.deduction_under_80G_table_columns_data.some(function (
            el
          ) {
            return (el.actual > 0 && !el.file_location) || ( el.file_location && el.actual<=0);
          });
          break;
        case "deduction_under_chapter_VI_A_80U":
          return this.deduction_under_80U_table_columns_data && this.deduction_under_80U_table_columns_data.some(function (
            el
          ) {
            return (el.actual > 0 && !el.file_location) || ( el.file_location && el.actual<=0);
          });
          break;
        case "deduction_under_6A":
          console.log("uploadValidation....................................line no 5705",this.deduction_under_NPS_table_columns_data)
          return (
            this.deduction_under_NPS_table_columns_data && this.deduction_under_NPS_table_columns_data.some(function (el){
               return (el.actual > 0 && !el.file_location) || (el.file_location && el.actual <=0);
            }) ||
           this.deduction_under_80U_table_columns_data && this.deduction_under_80U_table_columns_data.some(function (el) {
              return (el.actual > 0 && !el.file_location) || ( el.file_location && el.actual<=0);
            }) ||
           this.deduction_under_80C_table_columns_data && this.deduction_under_80C_table_columns_data.some(function (el) {
              return (el.actual > 0 && !el.file_location) || ( el.file_location && el.actual<=0);
            }) ||
            this.deduction_under_80D_table_columns_data && this.deduction_under_80D_table_columns_data.some(function (el) {
              return (el.actual > 0 && !el.file_location) || ( el.file_location && el.actual<=0);
            })  ||
           this.deduction_under_80G_table_columns_data &&  this.deduction_under_80G_table_columns_data.some(function (el) {
              return (el.actual > 0 && !el.file_location) || ( el.file_location && el.actual<=0);
            })||
           this.deduction_under_80DD_table_columns_data && this.deduction_under_80DD_table_columns_data.some(function (el) {
              return (el.actual > 0 && !el.file_location) || ( el.file_location && el.actual<=0);
            }) ||
           this.deduction_under_80DDB_table_columns_data && this.deduction_under_80DDB_table_columns_data.some(function (el) {
              return (el.actual > 0 && !el.file_location) || ( el.file_location && el.actual<=0);
            }) ||
           this.deduction_under_others_table_columns_data && this.deduction_under_others_table_columns_data.some(function (el) {
              return (el.actual > 0 && !el.file_location) || ( el.file_location && el.actual<=0);
            })
            
          );
        
          break;
        case "family_details":
            return this.employeeFamilyDetails[0].details && this.employeeFamilyDetails[0].details.some(function (el) {
            return !el.dob || !el.name || !el.relationship;
          });
          break;
           case "hra_section":
          this.hraFound = this.house_rent_declaration_array.details.find(item => item.value > 0)
        console.log(this.hraFound,"therfe") 
          return this.house_rent_declaration_array.details && this.house_rent_declaration_array.details.some(function (el) {
            // console.log(el,"hra data")
            return  el.value!=0&&el.value>8333?!el.from || !el.to || !el.value || !el.ownerDetails.state ||!el.ownerDetails.name||!el.ownerDetails.address:!el.from || !el.to|| !el.ownerDetails.state
            // ||!el.ownerDetails.panNumber 
          });

          break;
        case "previous_employee":
          let value = this.income_from_previous_employee_table_columns_data[0] && this.income_from_previous_employee_table_columns_data[0].some((el, ind) => { if (ind == 0) {return el.actual > 0 } })
          let value2 = this.income_from_previous_employee_table_columns_data[0] && this.income_from_previous_employee_table_columns_data[0].some((el, ind) => { if (ind == 0) {return el.actual <= 0} })
          return (value && !this.income_from_previous_employee_table_columns_data[0][0].file_location) ||(this.income_from_previous_employee_table_columns_data[0][0].file_location && value2)
          break;
        case "tcs_data":
          
          let fileError = this.other_tcs_table_columns_data && this.other_tcs_table_columns_data.some(function (el) {

            return (el.actual > 0 && !el.file_path) || (el.file_path && el.actual <= 0)  
          }) 
          let valueError = this.other_tcs_table_columns_data && this.other_tcs_table_columns_data.some(function (el) {
            return (!el.section_display_name || !el.name_of_collector || !el.tan_of_collector)
          })
          return fileError ? 'noFile' : valueError ? 'otherFields' : 'noError' ;
          break;
      }
    },
    async uploadAttachments(value, record, index, belongs) {
      //console.log("belongs", index, record, belongs);
      this.upload_loader = true;
      //console.log(value)
      var config = {
        bucketName:  process.env.VUE_APP_IT_DOCUMENT ? "payliefuat" :"payliefprod" ,
        dirName: `income_tax_proof_submissions/${this.le_id}/${this.it_financial_year}/${this.e_code}/${belongs}/` /* optional - when use: e.g BUCKET_ROOT/dirName/fileName.extesion */,
        region: "ap-south-1",
        accessKeyId: process.env.VUE_APP_AWS_ACCESS_KEY,
        secretAccessKey: process.env.VUE_APP_AWS_SECRET_KEY,
        s3Url: "https://paylief.s3.amazonaws.com/"
      };
      var baseUrl = `https://paylief.s3.${config.region}.amazonaws.com`;
      if (value.length != 0 && value[0].size <21348301 ) {
        this.uploaded_attachment_name = value[0].name;
        let formData = new FormData();
        formData.append("file", value[0]);
        formData.append("fileName",value[0].name.replace(/[\s()]+/g, '_'));
        formData.append("bucketName",config.bucketName);
        formData.append("path",config.dirName);
        try{
          const regex = /\.(png|pdf|jpg|zip)$/i;  // 'i' flag makes it case-insensitive
       let filenamecheck = regex.test(value[0].name);
       console.log("filenamecheck",filenamecheck)
        if(filenamecheck == false){          
          this.upload_loader = false;
          this.toast = true
          this.errmsg="Invalid file format (File format should be PDF, PNG, ZIP, JPG upto 20MB)"           
        }else{         
          let res = await this.uploadFileToS3Bucket(formData)          
          this.fetchUrl = res.payload
          if (this.fetchUrl) {
            switch (belongs) {
              case "section_ten_exemption":
                // console.log(this.sec_ten_exemption_table_columns_data[index])
                this.sec_ten_exemption_table_columns_data[index].file_location =
                  this.fetchUrl;
                this.sec_ten_exemption_table_columns_data[index].file_name =
                  value[0].name;
                  // console.log(this.sec_ten_exemption_table_columns_data[index].file_location)
                break;
              case "income_loss_letout_property":
                this.income_loss_from_house_table_columns_data_two.letout[
                  index
                ].file_location = this.fetchUrl;
                this.income_loss_from_house_table_columns_data_two.letout[
                  index
                ].file_name = value[0].name;
               
                break;
              case "income_loss_self":
               
                this.file_location_income = this.fetchUrl;
                this.income_loss_from_house_table_columns_data_one[
                  index
                ].file_location = this.file_location_income;
                this.income_loss_from_house_table_columns_data_one[
                  index
                ].file_name = value[0].name;
                this.componentKeyUpdate+= 1
                break;
              case "house_rent_declaration":
                this.file_location_hra = this.fetchUrl;
                this.house_rent_declaration_array.file_name = value[0].name;
                this.house_rent_declaration_array.file_location =
                  this.file_location_hra;

                break;
              case "deduction_under_chapter_VI_A_80C":
                this.deduction_under_80C_table_columns_data[
                  index
                ].file_location = this.fetchUrl;
                this.deduction_under_80C_table_columns_data[index].file_name =
                  value[0].name;
                break;
                case "deduction_under_chapter_VI_A_80C_NPS":
                this.deduction_under_NPS_table_columns_data[
                  index
                ].file_location = this.fetchUrl;
                this.deduction_under_NPS_table_columns_data[index].file_name =
                  value[0].name;
                break;
              case "deduction_under_chapter_VI_A_80D":
                this.deduction_under_80D_table_columns_data[
                  index
                ].file_location = this.fetchUrl;
                this.deduction_under_80D_table_columns_data[index].file_name =
                  value[0].name;
                break;
              case "deduction_under_chapter_VI_A_80DD":
              this.deduction_under_80DD_table_columns_data[
                  index
                ].file_location = this.fetchUrl;
                this.deduction_under_80DD_table_columns_data[index].file_name =
                  value[0].name;
                break;
                case "deduction_under_chapter_VI_A_80DDB":
              this.deduction_under_80DDB_table_columns_data[
                  index
                ].file_location = this.fetchUrl;
                this.deduction_under_80DDB_table_columns_data[index].file_name =
                  value[0].name;
                break;
              case "deduction_under_chapter_VI_A_others":
                  // console.log(this.fetchUrl,value);
                this.deduction_under_others_table_columns_data[
                  index
                ].file_location = this.fetchUrl;
                this.deduction_under_others_table_columns_data[index].file_name =
                  value[0].name;
                break;
              case "deduction_under_chapter_VI_A_80G":
                this.deduction_under_80G_table_columns_data[
                  index
                ].file_location = this.fetchUrl;
                this.deduction_under_80G_table_columns_data[index].file_name =
                  value[0].name;
                break;
              case "deduction_under_chapter_VI_A_80U":
                this.deduction_under_80U_table_columns_data[
                  index
                ].file_location = this.fetchUrl;
                this.deduction_under_80U_table_columns_data[index].file_name =
                  value[0].name;
                break;
              case "other_income":
                this.other_income_table_columns_data[index].file_location =
                  this.fetchUrl;
                this.other_income_table_columns_data[index].file_name =
                  value[0].name;
                break;
              case "income_from_previous_employee":
               
                this.file_location_previous = this.fetchUrl
              this.file_name_previous=  value[0].name
                this.income_from_previous_employee_table_columns_data[0][0].file_location = this.fetchUrl;
                this.income_from_previous_employee_table_columns_data[0][0].file_name = value[0].name;
                break;
              case "tcs_attachment":
                this.other_tcs_table_columns_data[index].file_path = this.fetchUrl;
                this.other_tcs_table_columns_data[index].file_name = value[0].name;
                break;
            }
          
          this.upload_loader = false;
          this.toast=false
        }
        }        
        }catch(err){
          this.upload_loader = false;
          this.toast=true
          this.errmsg=err
        }
      } else {
        //console.log("else");
        this.upload_loader = false;
        this.toast = true
        this.errmsg="File Size Cannot Exceed More than 20MB"
      }

      //console.log(value, "value", record, "record");
    },
    closeTabs() {
       this.showPopupFamilyDetaila = false;
      this.showPopupExemptionUnderSectionDeduction = false;
      this.showPopupHouseRentDeclaration = false;
      this.showPopupDeductionUnderCdeu = false;
      this.showPopupIncomeFromPreviousEmployer = false;
      this.showPopupOtherIncome = false;
      this.showPopupExemptionUnderSectionDeduction = false;
      this.showPopupIncomeLossFromHousingProperty = false;
      this.showPopupIncomeLossFromHousingPropertyNewRegime = false;
      this.form12BB_pop_up = false;
      this.incomeTaxProofSubmittedFlag = true
      this.showPopupOtherTaxTcs = false
    },
    checkOwnerPan(pan_number, index) {
    //  console.log(pan_number,index,this.pancardRegex.test(pan_number))
      if (!this.pancardRegex.test(pan_number)) {
        // console.log("hiii")
        this.house_rent_declaration_array.details[index].ownerDetails.panNumber = ""
        
      }
      else {
          // console.log("helloi")
        this.house_rent_declaration_array.details[index].ownerDetails.panNumber=pan_number
      }  
    },
    checkBankPan(pan_number) {
      //  console.log(pan_number,this.bankPanRegex.test(pan_number))
      if (!this.bankPanRegex.test(pan_number)) {
        // console.log("hiii")
      this.income_loss_from_house_table_columns_data_one[0].bank_details.bank_pancard_number = ""
        
      }
      else {
          // console.log("helloi")
        this.income_loss_from_house_table_columns_data_one[0].bank_details.bank_pancard_number=pan_number
      }  
    },
    hraPanValidation(){
     if(this.totalRentExceedsOneLakh){
               const allHavePan = this.house_rent_declaration_array.details
                                   && this.house_rent_declaration_array.details.every(record => {
                                       return record.value > 0
                                                  ? !!record.ownerDetails.panNumber
                                                    : true;
                                           });

                         if (allHavePan) {
                                          this.saveDataForFinalArray('hraSection');
                                         } else {
                                           window.alert("Please Enter PAN Number for all records");
                                         }
               }  
               else{
               this.saveDataForFinalArray('hraSection')
               }
    },
    saveDataForFinalArray(value) {
      //console.log("hiii");
      
      switch (value) {
        case "section_ten_exemption":
          //console.log("hiii");
          
      console.log(this.uploadValidation(value));  
          if (this.uploadValidation(value)) {
              
              window.alert("Please upload attachment to Submitted Amount")
          } else {
            this.backendArrayData.section10.section10Others =
            this.sec_ten_exemption_table_columns_data;
            this.backendArrayData.isDraft = true;
            this.backendArrayData.isSec10Save = true
             this.backendArrayData.isSec10SaveEmp='Pending'
             
            this.it_proof_submission(value);
            
          }
         
          //console.log(this.uploadValidation(), "hello");
          break;
        case "hraSection":
          console.log(this.uploadValidation('hra_section'),this.house_rent_declaration_array,"hra data")
          if (this.uploadValidation('hra_section') || this.hraFound != undefined) {
            if (!this.house_rent_declaration_array.file_location) {
              window.alert("Please upload Proof for submitted HRA")
            } else if (this.uploadValidation('hra_section') || (this.totalRentExceedsOneLakh && !this.house_rent_declaration_array.details[this.house_rent_declaration_array.details.length - 1].ownerDetails.panNumber) || (this.house_rent_declaration_array.details[this.house_rent_declaration_array.details.length - 1].value > 0 && (!this.house_rent_declaration_array.details[this.house_rent_declaration_array.details.length - 1].ownerDetails.metro || !this.house_rent_declaration_array.details[this.house_rent_declaration_array.details.length - 1].ownerDetails.name || !this.house_rent_declaration_array.details[this.house_rent_declaration_array.details.length - 1].ownerDetails.address)) ) {
              window.alert("Please Enter all the Mandatory Fields")
            }
            else {
              this.backendArrayData.section10["HRA"].actual =
                this.house_rent_declaration_array;
              this.backendArrayData.isDraft = true;
              this.backendArrayData.isHraSave = true
              this.backendArrayData.isHraSaveEmp='Pending'
              
              this.it_proof_submission(value);
               
            }
          } else {
            this.backendArrayData.section10["HRA"].actual =
                this.house_rent_declaration_array;
              this.backendArrayData.isDraft = true;
            this.backendArrayData.isHraSave = true
               
              this.backendArrayData.isHraSaveEmp='Pending'
            this.it_proof_submission(value);
              
              }  
          
          // this.backendArrayData.section10["HRA"].actual=this.house_rent_declaration_array
          break;

        case "employee_family_details":
          //console.log(this.uploadValidation('family_details') || this.toast); 
          if(this.uploadValidation('family_details') || this.toast){
            window.alert("Please Enter Missing Fields")
          } else {
             this.allowOtherSections = false;
          this.employeeFamilyDetails.map((record) => {
            record.isSave = true;
          });
          // console.log("here",this.backendArrayData)
          this.backendArrayData.employeeFamily = this.employeeFamilyDetails;
          this.backendArrayData.isDraft = true;
          this.it_proof_submission(value);
           }
         
          //console.log("family", this.backendArrayData);
          break;
        case "income_loss_property":
          //  console.log(this.uploadValidation('income/loss_self') ,"to kmow", this.uploadValidation('income/loss_from_house'))
          // console.log(this.uploadValidation('income/loss_self') || this.uploadValidation('income/loss_from_house'))
          if (this.uploadValidation('income/loss_self') || this.uploadValidation('income/loss_from_house')) {
               window.alert("Please Enter missing Fields and upload attachment")

          } else {
            this.income_loss_from_house_table_columns_data_one[0].joint_property_details =
            this.income_loss_from_house_table_columns_data_three;
          this.income_loss_from_house_table_columns_data_two.joint_property_details =
            this.income_loss_from_house_table_columns_data_letout_joint_Property
          this.backendArrayData.section24.letOutProperty[0].letOut =
            this.income_loss_from_house_table_columns_data_two.letout;
          this.backendArrayData.section24.letOutProperty[0].joint_property_details =
            this.income_loss_from_house_table_columns_data_two.joint_property_details;
          let arr = this.income_loss_from_house_table_columns_data_one;
          let finalObj = {};
          for (let i = 0; i < arr.length; i++) {
            Object.assign(finalObj, arr[i]);
          }
          this.backendArrayData.section24.selfOccupied = finalObj;
            this.backendArrayData.isDraft = true;
            this.backendArrayData.isIncomeLossSave = true  
        this.backendArrayData.isIncomeLossSaveEmp='Pending'  
        
            this.it_proof_submission(value);
           
          }
         
          break;
        case "deduction_under_6A":
        if(!this.regime_type){
          if (this.uploadValidation(value)) {
               window.alert("Please upload attachment to Submitted Amount")
          } else {
            this.deduction_under_80C_table_columns_data.map(data=>{
              if(data["InvestmentComponentType"]["name"] == "80CCD1 - National Pension Scheme"){
                data = this.deduction_under_NPS_table_columns_data[0]
              }else{
                data.actual= 0 
                data.file_location = null
              }
            })
            this.backendArrayData.section6a["80C"] =
            this.deduction_under_80C_table_columns_data;
          this.backendArrayData.section6a["80D"] =
            this.deduction_under_80D_table_columns_data;
          this.backendArrayData.section6a["Others"] =
            this.deduction_under_others_table_columns_data;
          this.backendArrayData.section6a["80G"] =
            this.deduction_under_80G_table_columns_data;
          this.backendArrayData.section6a["80U"] =
            this.deduction_under_80U_table_columns_data;
          this.backendArrayData.section6a["80DD"] =
            this.deduction_under_80DD_table_columns_data;
          this.backendArrayData.section6a["80DDB"] =
            this.deduction_under_80DDB_table_columns_data;
            this.backendArrayData.isDraft = true;
            this.backendArrayData.isDeduction6ASave = true
             this.backendArrayData.isDeduction6ASaveEmp='Pending'
             
            this.it_proof_submission(value);
        
          }
        }else{
          console.log("enterddddddddddddddddddddddddddddddddddddddddddddddd line no 6079 ")
          if (this.uploadValidation(value)) {
               window.alert("Please upload attachment to Submitted Amount")
          } else {
            this.backendArrayData.section6a["80C"] =
            this.deduction_under_80C_table_columns_data;
          this.backendArrayData.section6a["80D"] =
            this.deduction_under_80D_table_columns_data;
          this.backendArrayData.section6a["Others"] =
            this.deduction_under_others_table_columns_data;
          this.backendArrayData.section6a["80G"] =
            this.deduction_under_80G_table_columns_data;
          this.backendArrayData.section6a["80U"] =
            this.deduction_under_80U_table_columns_data;
          this.backendArrayData.section6a["80DD"] =
            this.deduction_under_80DD_table_columns_data;
          this.backendArrayData.section6a["80DDB"] =
            this.deduction_under_80DDB_table_columns_data;
            this.backendArrayData.isDraft = true;
            this.backendArrayData.isDeduction6ASave = true
             this.backendArrayData.isDeduction6ASaveEmp='Pending'
             
            this.it_proof_submission(value);
        
          }
        }
          break;
        case "income_from_previous_employee":
          if (this.uploadValidation('previous_employee')) {
               window.alert("Please upload attachment to Submitted Amount")
          } else {
            var backendPreviousEmployeeArray =
            this.income_from_previous_employee_table_columns_data[0].map(
              (item) => {
                let key = item.name;
                var values = {
                  planned: item.planned,
                  actual: item.actual,
                  approved: item.approved,
                  file_location: this.file_location_previous,
                  file_name:this.file_name_previous
                };
                return {
                  [key]: values,
                };
              }
            );
          this.backendArrayData.previousEmployment =
            backendPreviousEmployeeArray;
          
            this.backendArrayData.isDraft = true;
            this.backendArrayData.isPrevEmpSave = true    
            this.backendArrayData.isPreEmpSaveEmp='Pending'  
        
            this.it_proof_submission(value);
         
          }
         
          
          break;
        case "other_income":
          if (this.uploadValidation('other_income')) {
            window.alert("Please upload attachment to Submitted Amount")
          } else {
            this.backendArrayData.otherIncome =
            this.other_income_table_columns_data;
            this.backendArrayData.isDraft = true;
            this.backendArrayData.isOtherSave = true  
         this.backendArrayData.isOtherSaveEmp='Pending'
         
          
            this.it_proof_submission(value);
          }
          break;
        case "tcs_data":
          let typeOfError = this.uploadValidation(value)
          if ( typeOfError == 'noFile' ) {
             window.alert("Please upload attachment to Submitted Amount")
          }else if(typeOfError == 'otherFields'){
             window.alert("Please Enter Missing Fields")
          }
          else{
            this.backendArrayData.employeeTCS = this.other_tcs_table_columns_data;
            this.backendArrayData.isDraft = true;
            this.it_proof_submission(value);
          }
          break;
        case "regimeChange":
          this.backendArrayData.isDraft = true;
          this.it_proof_submission(value);
          break;
      }
    },
    show_pop_up(records, value, index) {
      //console.log("recor",records)
      switch (value) {
        case "section_ten_exemption":
          this.attachments_pop_up_header = "Section 10 Exemption";
          this.section_ten_attachments_pop_up = true;
          this.fetchUrl = records.file_location;
          this.attachment_pop_up_table_columns_data = [];
          this.attachment_pop_up_table_columns_data.push({
            attachment: records.name || records["InvestmentComponentType.name"],
            index: index,
            fileName: records.file_name,
            viewFile: "View",
            removeFile: "Delete",
          });
          break;
        case "house_rent_declaration":
          //console.log("im here at ");
          this.attachment_pop_up_table_columns_data = [];
          this.attachments_pop_up_header = "House Rent Allowance";
          this.showPopupHouseRentDeclaration = false;
          this.house_rent_attachments_pop_up = true;
          this.fetchUrl = this.house_rent_declaration_array.file_location;
          this.attachment_pop_up_table_columns_data.push({
            attachment: "House Rent Attachment",
            fileName: this.house_rent_declaration_array.file_name,
            viewFile: "View",
            removeFile: "Delete",
          });

          break;
        case "deduction_under_80C":
          this.attachments_pop_up_header = "deduction_under_80C";
          this.showPopupDeductionUnderCdeu = false;
          this.deduction_under_6A_attachments_pop_up = true;
          this.attachment_pop_up_table_columns_data = [];
          this.fetchUrl = records.file_location;
          this.attachment_pop_up_table_columns_data.push({
            attachment: records.name || records["InvestmentComponentType.name"],
            index: index,
            fileName: records.file_name,
            viewFile: "View",
            removeFile: "Delete",
          });
          break;
        case "deduction_under_80D":
          this.attachments_pop_up_header = "deduction_under_80D";
          this.showPopupDeductionUnderCdeu = false;
          this.deduction_under_6A_attachments_pop_up = true;
          this.attachment_pop_up_table_columns_data = [];
          this.fetchUrl = records.file_location;
          this.attachment_pop_up_table_columns_data.push({
            attachment: records.name || records["InvestmentComponentType"]["name"],
            index: index,
            fileName: records.file_name,
            viewFile: "View",
            removeFile: "Delete",
          });
          break;
        case "deduction_under_80DD":
          this.attachments_pop_up_header = "deduction_under_80DD";
          this.showPopupDeductionUnderCdeu = false;
          this.deduction_under_6A_attachments_pop_up = true;
          this.attachment_pop_up_table_columns_data = [];
          this.fetchUrl = records.file_location;
          this.attachment_pop_up_table_columns_data.push({
            attachment: records.name || records["InvestmentComponentType"]["name"],
            index: index,
            fileName: records.file_name,
            viewFile: "View",
            removeFile: "Delete",
          });
          break;
        case "deduction_under_80DDB":
          this.attachments_pop_up_header = "deduction_under_80DDB";
          this.showPopupDeductionUnderCdeu = false;
          this.deduction_under_6A_attachments_pop_up = true;
          this.attachment_pop_up_table_columns_data = [];
          this.fetchUrl = records.file_location;
          this.attachment_pop_up_table_columns_data.push({
            attachment: records.name || records["InvestmentComponentType"]["name"],
            index: index,
            fileName: records.file_name,
            viewFile: "View",
            removeFile: "Delete",
          });
          break;
        case "deduction_under_80E":
          this.attachments_pop_up_header = "deduction_under_80E";
          this.showPopupDeductionUnderCdeu = false;
          this.deduction_under_6A_attachments_pop_up = true;
          this.attachment_pop_up_table_columns_data = [];
          this.fetchUrl = records.file_location;
          this.attachment_pop_up_table_columns_data.push({
            attachment: records.name || records["InvestmentComponentType"]["name"],
            index: index,
            fileName: records.file_name,
            viewFile: "View",
            removeFile: "Delete",
          });
          break;
        case "deduction_under_80G":
          this.attachments_pop_up_header = "deduction_under_80G";
          this.showPopupDeductionUnderCdeu = false;
          this.deduction_under_6A_attachments_pop_up = true;
          this.attachment_pop_up_table_columns_data = [];
          this.fetchUrl = records.file_location;
          this.attachment_pop_up_table_columns_data.push({
            attachment: records.name || records["InvestmentComponentType"]["name"],
            index: index,
            fileName: records.file_name,
            viewFile: "View",
            removeFile: "Delete",
          });
          break;
        case "deduction_under_80T":
          this.attachments_pop_up_header = "deduction_under_80T";
          this.showPopupDeductionUnderCdeu = false;
          this.deduction_under_6A_attachments_pop_up = true;
          this.attachment_pop_up_table_columns_data = [];
          this.fetchUrl = records.file_location;
          this.attachment_pop_up_table_columns_data.push({
            attachment: records.name || records["InvestmentComponentType"]["name"],
            index: index,
            fileName: records.file_name,
            viewFile: "View",
            removeFile: "Delete",
          });
          break;
        case "deduction_under_80U":
          this.attachments_pop_up_header = "deduction_under_80U";
          this.showPopupDeductionUnderCdeu = false;
          this.deduction_under_6A_attachments_pop_up = true;
          this.attachment_pop_up_table_columns_data = [];
          this.fetchUrl = records.file_location;
          this.attachment_pop_up_table_columns_data.push({
            attachment: records.name || records["InvestmentComponentType"]["name"],
            index: index,
            fileName: records.file_name,
            viewFile: "View",
            removeFile: "Delete",
          });
          break;
        case "deduction_under_others":
          this.attachments_pop_up_header = "deduction_under_others";
          this.showPopupDeductionUnderCdeu = false;
          this.deduction_under_6A_attachments_pop_up = true;
          this.attachment_pop_up_table_columns_data = [];
          this.fetchUrl = records.file_location;
          this.attachment_pop_up_table_columns_data.push({
            attachment: records.name || records["InvestmentComponentType"]["name"],
            index: index,
            fileName: records.file_name,
            viewFile: "View",
            removeFile: "Delete",
          
})
          break;
        case "other_income":
          this.attachments_pop_up_header = "Other Income";
          this.showPopupOtherIncome = false;
          this.other_income_attachments_pop_up = true;
          this.attachment_pop_up_table_columns_data = [];
          this.fetchUrl = records.file_location;
          this.attachment_pop_up_table_columns_data.push({
            attachment: records.name,
            index:index,
            fileName: records.file_name,
            viewFile: "View",
            removeFile: "Delete",
          });
          break;

        case "income_from_previous_employee":
          //console.log("hiii previous")
          this.attachments_pop_up_header = "Income From Previous Employer";
          this.showPopupIncomeFromPreviousEmployer = false;
          this.income_loss_from_house_attachments_pop_up = false;
          this.showPopupIncomeLossFromHousingProperty = false;
          this.income_from_previous_employee_pop_up = true;
          this.attachment_pop_up_table_columns_data = [];
          this.fetchUrl = records[0][0].file_location;
          this.attachment_pop_up_table_columns_data.push({
            attachment: records.name || "Income from Previous Employer",
            fileName: records[0][0].file_name,
            viewFile: "View",
            removeFile: "Delete",
          });
          break;
        case "income_loss_self_occuiped":
          this.attachments_pop_up_header = "Income_loss_self_occuiped";
          this.showPopupIncomeFromPreviousEmployer = false;
          this.income_loss_from_house_attachments_pop_up = true;
          this.showPopupIncomeLossFromHousingProperty = false;
          this.attachment_pop_up_table_columns_data = [];
          this.fetchUrl = records.file_location;
          this.attachment_pop_up_table_columns_data.push({
            attachment: records.name || "Total Income",
            fileName: records.file_name,
            viewFile: "View",
            removeFile: "Delete",
          });
          break;
        case "income_loss_letout":
          this.attachments_pop_up_header = "Income_loss_letout";
          this.showPopupIncomeFromPreviousEmployer = false;
          this.income_loss_from_house_attachments_pop_up = true;
          this.showPopupIncomeLossFromHousingProperty = false;
          this.attachment_pop_up_table_columns_data = [];
          this.fetchUrl = records.file_location;
          this.attachment_pop_up_table_columns_data.push({
            attachment: records.name || "Total Income",
            index: index,
            fileName: records.file_name,
            viewFile: "View",
            removeFile: "Delete",
          });
          break;
        case "tcs_attachment":
          this.attachments_pop_up_header = "Other Tax Collected at Source(TCS)";
          this.showPopupOtherTaxTcs = false;
          this.other_tcs_attachment_pop_up = true;
          this.attachment_pop_up_table_columns_data = [];
          this.fetchUrl = records.file_path;
          this.attachment_pop_up_table_columns_data.push({
            attachment: records.section_display_name ,
            index: index,
            fileName: records.file_name,
            viewFile: "View",
            removeFile: "Delete",
          });
          break;
        
      }
    },
    download12BBUrl(data)
    {
      console.log("download12BBUrl",data)
      let url = data
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", 'form12.pdf'); //or any other extension
          document.body.appendChild(link);
          link.click();
    // axios({
    //           url:data,
    //           method:'GET',
    //           responseType: 'blob'
    //   })
    //   .then((res) => {
    //        const url = window.URL.createObjectURL(new Blob([res.data]));
    //             const link = document.createElement("a");
    //             link.href = url;
    //             link.setAttribute("download",'form12.pdf'); //or any other extension
    //             document.body.appendChild(link);
    //             link.click();
    //             return res;
    //   })
    },
    getTitleSec10(name) {
      let titleName = name["InvestmentComponentType.name"] || name.name
      const sectionMap = new Map(this.subSectionInfo);
      const titleInfo = sectionMap.get(`${titleName}`);
      return titleInfo
    },
    getTitlePrevEmployee(name) {
       let titleName = name
      const sectionMap = new Map(this.subSectionInfo);
      const titleInfo = sectionMap.get(`${titleName}`);
      return titleInfo
    },
    // getTitleName(name) {
    //   let titleName = name.name || name["InvestmentComponentType"]["name"] || name["InvestmentComponentType.name"] ||  this.previousEmployerNames[name.name]
    //   const sectionMap = new Map(this.subSectionInfo);
    //   const titleInfo = sectionMap.get(`${titleName}`);
    //   return titleInfo
    // },

      async preSignedUrlFunction() {
        try {
          let res = await this.getPreSignedUrl({
            url: this.fetchUrl
          });
          if (res.data.payload && res.data.payload.iv && res.data.payload.encryptedPacket) {
            const decryptedLink = await this.decrypt(res.data.payload);
            return decryptedLink;
          } else {
            console.log('Invalid payload structure');
            return null;
          } 
        } catch (e) {
          console.log('Error in preSignedUrlFunction:', e);
          return null; 
        }
      },
  
    async downloadUrl() {
      try {
        const downloadLink = await this.preSignedUrlFunction();
        if (downloadLink) {
          let url = JSON.parse(downloadLink);
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", this.attachment_pop_up_table_columns_data[0].fileName); //or any other extension
          document.body.appendChild(link);
          link.click();
        } else {
          console.log('Failed to retrieve the download link.');
        }
      } catch (e) {
        console.error('Error during download:', e);
      }
    },
    async decrypt(payload) {
      const key = process.env.VUE_APP_PAYSLIP_SECRET;
      const decipher = createDecipheriv('aes-256-cbc', key, Buffer.from(payload.iv, 'hex'));
      const decrypted = Buffer.concat([
        decipher.update(payload.encryptedPacket, 'base64'),
        decipher.final()
      ]);

      return decrypted.toString();
    },
   
    async deleteUrl(record,index,header) {
      try{
        // let res = await this.deleteFileInS3bucket(this.fetchUrl)
        if(true){
        switch(header){
      case 'Section 10 Exemption':
          this.section_ten_attachments_pop_up = false
      this.showPopupExemptionUnderSectionDeduction = true;  
        this.sec_ten_exemption_table_columns_data[record.index].file_location = "";
        this.sec_ten_exemption_table_columns_data[record.index].actual=0;
        this.showSuccessMsg = true;
        this.pop_up_message = "Attachment Deleted Successfully"; 
        break;
      case 'deduction_under_80C':
          this.deduction_under_6A_attachments_pop_up = false
       this.showPopupDeductionUnderCdeu = true  
        this.deduction_under_80C_table_columns_data[record.index].file_location="";
        this.deduction_under_80C_table_columns_data[record.index].actual=0;
        this.showSuccessMsg = true;
        this.pop_up_message = "Attachment Deleted Successfully"; 
        break;
       case 'deduction_under_80D':
          this.deduction_under_6A_attachments_pop_up = false
       this.showPopupDeductionUnderCdeu = true  
        this.deduction_under_80D_table_columns_data[record.index].file_location="";
        this.deduction_under_80D_table_columns_data[record.index].actual=0;
        this.showSuccessMsg = true;
        this.pop_up_message = "Attachment Deleted Successfully"; 
        break;
       case 'deduction_under_80DD':
          this.deduction_under_6A_attachments_pop_up = false
       this.showPopupDeductionUnderCdeu = true  
        this.deduction_under_80DD_table_columns_data[record.index].file_location="";
        this.deduction_under_80DD_table_columns_data[record.index].actual=0;
        this.showSuccessMsg = true;
        this.pop_up_message = "Attachment Deleted Successfully"; 
         break;
       case 'deduction_under_80DDB':
          this.deduction_under_6A_attachments_pop_up = false
       this.showPopupDeductionUnderCdeu = true  
        this.deduction_under_80DDB_table_columns_data[record.index].file_location="";
        this.deduction_under_80DDB_table_columns_data[record.index].actual=0;
        this.showSuccessMsg = true;
        this.pop_up_message = "Attachment Deleted Successfully"
        break; 
        case 'deduction_under_others':
          this.deduction_under_6A_attachments_pop_up = false
       this.showPopupDeductionUnderCdeu = true  
        this.deduction_under_others_table_columns_data[record.index].file_location="";
        this.deduction_under_others_table_columns_data[record.index].actual=0;
        this.showSuccessMsg = true;
        this.pop_up_message = "Attachment Deleted Successfully"
        break; 
        case 'deduction_under_80G':
          this.deduction_under_6A_attachments_pop_up = false
       this.showPopupDeductionUnderCdeu = true  
        this.deduction_under_80G_table_columns_data[record.index].file_location="";
        this.deduction_under_80G_table_columns_data[record.index].actual=0;
        this.showSuccessMsg = true;
        this.pop_up_message = "Attachment Deleted Successfully"
        break; 
        case 'deduction_under_80U':
          this.deduction_under_6A_attachments_pop_up = false
       this.showPopupDeductionUnderCdeu = true  
        this.deduction_under_80U_table_columns_data[record.index].file_location="";
        this.deduction_under_80U_table_columns_data[record.index].actual=0;
        this.showSuccessMsg = true;
        this.pop_up_message = "Attachment Deleted Successfully"
        break;
        case 'House Rent Allowance':
          this.showPopupHouseRentDeclaration = true
        this.file_location_hra=""  
        this.house_rent_declaration_array.file_location = "";
        this.file_location_hra="";
        this.showSuccessMsg = true;
        this.pop_up_message = "Attachment Deleted Successfully"
        break;
        case 'Income_loss_self_occuiped':
          this.showPopupIncomeLossFromHousingProperty=true
          //console.log(this.income_loss_from_house_table_columns_data_one)
          this.income_loss_from_house_table_columns_data_one.map((item) => {
          item.total_actual=0  
          })
        this.income_loss_from_house_table_columns_data_one[0].file_location = "";
        this.showSuccessMsg = true;
        this.pop_up_message = "Attachment Deleted Successfully"
        break;
        case 'Income_loss_letout':
          //console.log(this.income_loss_from_house_table_columns_data_two);
          this.showPopupIncomeLossFromHousingProperty=true
          
          this.income_loss_from_house_table_columns_data_two.letout.map((item) => {
          item.actual=0  
          })
          this.income_loss_from_house_table_columns_data_two.letout[record.index].file_location = "";
        
        this.showSuccessMsg = true;
        this.pop_up_message = "Attachment Deleted Successfully"
        break;
        case 'Other Income':
        this.other_income_table_columns_data[record.index].file_location = "";
        this.other_income_table_columns_data[record.index].actual =0;
        this.showSuccessMsg = true;
          this.pop_up_message = "Attachment Deleted Successfully"
       this.showPopupOtherIncome = true;  
          break;
        case 'Other Tax Collected at Source(TCS)':
        this.other_tcs_table_columns_data[record.index].file_path = "";
        this.other_tcs_table_columns_data[record.index].actual = 0;
        this.showSuccessMsg = true;
        this.pop_up_message = "Attachment Deleted Successfully"
        this.showPopupOtherTaxTcs = true;
        break;
        case 'Income From Previous Employer':
         //console.log(this.income_from_previous_employee_table_columns_data)
        this.income_from_previous_employee_table_columns_data[0][0].file_location = "";
          this.file_location_previous = ""
        this.file_name_previous=""    
        this.income_from_previous_employee_table_columns_data[0].map(record=>{
          record.actual =0;
        })
        this.showSuccessMsg = true;
          this.pop_up_message = "Attachment Deleted Successfully"
         this.showPopupIncomeFromPreviousEmployer = true;  
        break;  

       }
      }
      }catch(err){
        this.toast= true
        this.errmsg=err
      }
    },
    async decryptOne(payload) {
      try {
        const key = process.env.VUE_APP_PAYSLIP_SECRET;
        const decipher = crypto.createDecipheriv('aes-256-cbc', key, payload.iv);
        const decrypted = Buffer.concat([decipher.update(payload.encryptedPacket, 'base64'), decipher.final()]);
        return decrypted.toString();
      } catch (error) {

      }
    },
    async encryptData(payload) {
      try {
        const iv = crypto.randomBytes(8).toString('hex')
        const key = process.env.VUE_APP_PAYSLIP_SECRET;
        const cipher = crypto.createCipheriv('aes-256-cbc', key, iv);
        let encryptedText = Buffer.concat([
          cipher.update(JSON.stringify(payload)),
          cipher.final()
        ]);
        return {
          iv: iv.toString(),
          encryptedPacket: encryptedText.toString('base64')
        }
      } catch (err) {
        throw err;
      }
    },
     async upload12BBmanual(data){
      try{   
             let formData = new FormData();
            formData.append("form12B", data[0]);
              let record={
                "legalEntityId":this.employeeDetailsPayload[0].legal_entity_id,
                "empCode":this.employeeDetailsPayload[0].code,
                 "payload":formData
              }
              let res = await this.form12BBupdateURL(record);
              if(res){
                this.showSuccessMsg = true;
                this.finalSubmitFlag=false
                this.pop_up_message = "Form 12BB uploaded successfully";
                this.finalSubmitButton = false 
              }
      }catch(err){
        this.toast = true;
        this.errmsg = err;
      }
     },
     async downloadForm12BB() {
      var hraDetailsFor12BB=[]
      let HRAbackendArray=this.backendArrayData.section10.HRA.actual.details.length?
      this.backendArrayData.section10.HRA.actual:"";
      HRAbackendArray&&HRAbackendArray.details. map(record=>{
          hraDetailsFor12BB.push(
            {
              "rentPaidToTheLandlord":record.value?record.value:"",
              "nameOfLandlord":record.ownerDetails.name?record.ownerDetails.name:"",
              "addressOfTheLandlord":record.ownerDetails.address?record.ownerDetails.address:"",
              "PANofTheLandlord":record.ownerDetails.panNumber?record.ownerDetails.panNumber:"",
              "proofStatus": "Proof Submitted"
            }
          )
      })
      this.BBPayload ={
        "empId":this.empId,
        "ipAddress":"",
        "isDigitallySiged":false,
        "empCode":this.employeeDetailsPayload[0].code,
        "empName":this.employeeName ,
        "gender":this.employeeDetailsPayload[0].gender,
        "empEmail":this.employeeDetailsPayload[0].email_id,
        "empMobile":this.employeeDetailsPayload[0].mobile_number,
        "empPAN":this.employeeDetailsPayload[0].pan_number,
        "legalEntityId":this.employeeDetailsPayload[0].legal_entity_id,
        "legalEntityImgUrl":this.employeeDetailsPayload[0].legalEntityDetails.logoURL,
        "legalEntityAddress":this.employeeDetailsPayload[0].legalEntityDetails.registeredAddress,
        "clientCode":this.employeeDetailsPayload[0].legalEntityDetails.clientCode,
        "clientName": this.employeeDetailsPayload[0].legalEntityDetails.legalName,
        "financialYear":`${new Date(this.fiscalYearStart).getFullYear()}-${new Date(this.fiscalYearEnd).getFullYear()}`,
        "houseRentAllowance":hraDetailsFor12BB,
        "deductionOfInterestOnBorrowing": [{
        "interestPayableOrPaidToTheLender":this.backendArrayData.section24.sefOccupied.total_actual,
        "nameOfTheLender":this.backendArrayData.section24.sefOccupied.bank_details.bank_name,
        "addressOfTheLender":this.backendArrayData.section24.sefOccupied.bank_details.bank_address,
        "PANofLender":this.backendArrayData.section24.sefOccupied.bank_details.bank_pancard_number,                                                                                                                                                                                                                                                    
        "financialInstitutions":this.backendArrayData.section24.sefOccupied.bank_details.bank_name,
        "employer":"",
        "otherLenderDetails": "",
        "proofStatus":this.backendArrayData.section24.sefOccupied.file_location?"Proof Submitted":""
       }],
       "leaveTravelConcessionsOrAssitance" : this.ltaValue,
        "section10": this.backendArrayData.section10.section10Others,
        "incomeLossFromHouseingProperty": this.backendArrayData.section24,
        "otherIncome": this.backendArrayData.otherIncome,
        "previousEmployement": this.backendArrayData.previousEmployment,
        "familyDetails": this.backendArrayData.employeeFamily,
       "chapterVIASections": [{
       "chapterVIASection80C":this.backendArrayData.section6a['80C'],
       "chapterVIAOtherSections": [{
         "80D":this.backendArrayData.section6a['80D'],
         "80G":this.backendArrayData.section6a['80G'],
         "Others":this.backendArrayData.section6a['Others'],
         "80U":this.backendArrayData.section6a['80U'],
         "80DD":this.backendArrayData.section6a['80DD'],
         "80DDB": this.backendArrayData.section6a['80DDB']
       }]
     }],
     "employeeTCS": this.backendArrayData.employeeTCS
   }
   let data = await this.encryptData(this.BBPayload); 
     let res = await this.form12BBURL(data);
     let apiResponse = JSON.parse(await this.decryptOne(res));
      console.log("apiResponse",apiResponse)
      this.BB_12_url=apiResponse.data.pdfPreSignedUrl
    }, 
    async openForm12BB() {
      this.checkBoxFlag=true
      this.form12BB_pop_up = true;
      var hraDetailsFor12BB=[]
      let HRAbackendArray=this.backendArrayData.section10.HRA.actual.details.length?
      this.backendArrayData.section10.HRA.actual:"";
      HRAbackendArray&&HRAbackendArray.details. map(record=>{
          hraDetailsFor12BB.push(
            {
              "rentPaidToTheLandlord":record.value?record.value:"",
              "nameOfLandlord":record.ownerDetails.name?record.ownerDetails.name:"",
              "addressOfTheLandlord":record.ownerDetails.address?record.ownerDetails.address:"",
              "PANofTheLandlord":record.ownerDetails.panNumber?record.ownerDetails.panNumber:"",
              "proofStatus": "Proof Submitted"
            }
          )
      })
      this.BBPayload ={
        "empId":this.empId,
        "ipAddress":"",
        "isDigitallySiged":false,
        "empCode":this.employeeDetailsPayload[0].code,
        "empName":this.employeeName ,
        "gender":this.employeeDetailsPayload[0].gender,
        "empEmail":this.employeeDetailsPayload[0].email_id,
        "empMobile":this.employeeDetailsPayload[0].mobile_number,
        "empPAN":this.employeeDetailsPayload[0].pan_number,
        "legalEntityId":this.employeeDetailsPayload[0].legal_entity_id,
        "legalEntityImgUrl":this.employeeDetailsPayload[0].legalEntityDetails.logoURL,
        "legalEntityAddress":this.employeeDetailsPayload[0].legalEntityDetails.registeredAddress,
        "clientCode":this.employeeDetailsPayload[0].legalEntityDetails.clientCode,
        "clientName": this.employeeDetailsPayload[0].legalEntityDetails.legalName,
        "financialYear":`${new Date(this.fiscalYearStart).getFullYear()}-${new Date(this.fiscalYearEnd).getFullYear()}`,
        "houseRentAllowance":hraDetailsFor12BB,
        "deductionOfInterestOnBorrowing": [{
        "interestPayableOrPaidToTheLender":this.backendArrayData.section24.sefOccupied.total_actual,
        "nameOfTheLender":this.backendArrayData.section24.sefOccupied.bank_details.bank_name,
        "addressOfTheLender":this.backendArrayData.section24.sefOccupied.bank_details.bank_address,
        "PANofLender":this.backendArrayData.section24.sefOccupied.bank_details.bank_pancard_number,                                                                                                                                                                                                                                                    
        "financialInstitutions":this.backendArrayData.section24.sefOccupied.bank_details.bank_name,
        "employer":"",
        "otherLenderDetails": "",
        "proofStatus":this.backendArrayData.section24.sefOccupied.file_location?"Proof Submitted":""
       }],
       "leaveTravelConcessionsOrAssitance" : this.ltaValue,
        "section10": this.backendArrayData.section10.section10Others,
        "incomeLossFromHouseingProperty": this.backendArrayData.section24,
        "otherIncome": this.backendArrayData.otherIncome,
        "previousEmployement": this.backendArrayData.previousEmployment,
        "familyDetails": this.backendArrayData.employeeFamily,
       "chapterVIASections": [{
       "chapterVIASection80C":this.backendArrayData.section6a['80C'],
       "chapterVIAOtherSections": [{
         "80D":this.backendArrayData.section6a['80D'],
         "80G":this.backendArrayData.section6a['80G'],
         "Others":this.backendArrayData.section6a['Others'],
         "80U":this.backendArrayData.section6a['80U'],
         "80DD":this.backendArrayData.section6a['80DD'],
         "80DDB": this.backendArrayData.section6a['80DDB']
       }]
     }],
     "employeeTCS": this.backendArrayData.employeeTCS
   }
   let data = await this.encryptData(this.BBPayload); 
     let res = await this.form12BBURL(data);
     console.log("ressssssssss",res)
     let apiResponse = JSON.parse(await this.decryptOne(res));
      console.log("apiResponse",apiResponse)
      this.BB_12_url=apiResponse.data.pdfPreSignedUrl
    },  
    async digitalySign()
    {
      try{
      this.BBPayload.isDigitallySiged=true
      this.BBPayload.ipAddress = this.promiseIP
      let data = await this.encryptData(this.BBPayload); 
     let res = await this.form12BBURL(data);
      if(res){
        this.showSuccessMsg = true;
        this.finalSubmitFlag=false
        this.finalSubmitButton = false
        this.pop_up_message = "Form 12BB has been signed digitally";
        var apiResponse = JSON.parse(await this.decryptOne(res));
      }
      //  console.log(apiResponse)
      }catch(err){
        this.toast = true;
        this.errmsg = err;
      }
    },

    async it_proof_submission(header) {
      try {
        this.upload_loader=true
         if((this.backendArrayData.employeeTCS.length ==1) &&(this.backendArrayData.employeeTCS[0].actual ==0)){
              this.backendArrayData.employeeTCS = []
            }
        if(header == "final_submit"){
          this.showDeleteConfirmation = false
          this.backendArrayData.isDraft = false;
          this.backendArrayData.itProofSubmitted = true;
        }
        this.backendArrayData.employeeId = this.empId;
        this.backendArrayData.itPlanId = this.it_plan_id;
        this.backendArrayData.financialYear = "2025";
        this.backendArrayData.login_email_id = this.emailId;
        this.backendArrayData.regimeType = this.uploadMethod
        console.log(this.backendArrayData)
        let res = await this.postAllITProofData(this.backendArrayData);
        if (res) {
          this.toast=false
          switch (header) {
             case "regimeChange":
             this.upload_loader=false
             this.getItSubmissionData()
             break;
            case "section_ten_exemption":
            this.upload_loader=false
              this.showSuccessMsg = true;
                 
          this.pop_up_message = "Section 10 proofs successfully saved as draft";
          this.getItSubmissionData();
          this.closeTabs()
              break;
              case "hraSection":
            this.upload_loader=false
              this.showSuccessMsg = true;
              
              console.log("im here") 
          this.pop_up_message = "House Rent Declaration proofs successfully saved as draft";
          this.getItSubmissionData();
          this.closeTabs()
              break;
            case "employee_family_details":
                this.upload_loader=false
          this.showSuccessMsg = true;
          this.pop_up_message = "Family Details successfully saved as draft";
          this.getItSubmissionData();
          this.closeTabs()
              break;
               case "income_loss_property":
                this.upload_loader=false
              this.showSuccessMsg = true;
       this.backendArrayData.isIncomeLossSave="Pending"      
          this.pop_up_message = "Income/Loss From Housing Proofs successfully saved as draft";
          this.getItSubmissionData();
          this.closeTabs()
              break;
          case "deduction_under_6A":
                this.upload_loader=false
              this.showSuccessMsg = true;
              this.backendArrayData.isDeduction6ASave="Pending"    
          this.pop_up_message = "Deduction Under Chapter VI A Proofs successfully saved as draft";
          this.getItSubmissionData();
          this.closeTabs()
              break;
          case "income_from_previous_employee":
                this.upload_loader=false
              this.showSuccessMsg = true;
            this.backendArrayData.isPrevEmpSave="Pending"      
          this.pop_up_message = "Income From Previous Employer Proofs successfully saved as draft";
          this.getItSubmissionData();
          this.closeTabs()
              break;
          case "other_income":
                this.upload_loader=false
              this.showSuccessMsg = true;
           this.backendArrayData.isOtherSave="Pending"    
          this.pop_up_message = "Other Income Proofs successfully saved as draft";
          this.getItSubmissionData();
          this.closeTabs()
              break;
          case "tcs_data":
                this.upload_loader=false
              this.showSuccessMsg = true;
          this.pop_up_message = "TCS Proofs successfully saved as draft";
          this.getItSubmissionData();
          this.closeTabs()
              break;
          case "final_submit" :
          this.upload_loader=false
              this.showSuccessMsg = true;
          
          this.pop_up_message = "IT Proofs is successfully submitted for validation";
          this.getItSubmissionData();
          this.closeTabs()
          }
          
          
        
        }
        //console.log(res);
      } catch (err) {
        this.upload_loader=false
        this.toast = true;
        this.errmsg = err;
      }
    },
    async getHraDAta(data) {
      if (data["HRA"].approved.details && data["HRA"].approved.details.length > 0) {
        return await data["HRA"].approved;
      } 
      else if (!Array.isArray(data["HRA"].actual)&&data["HRA"].actual.details.length > 0) {
        return await data["HRA"].actual;
      } else if (data["HRA"].planned.details.length > 0) {
        return await data["HRA"].planned;
      } else {
        return data["HRA"].planned;
      }
    },

    // isInCurrentFinancialYear(doj) {
    //   // Get the current date
    //   const currentDate = new Date();

    //   // Get the current year
    //   const currentYear = currentDate.getFullYear();

    //   // Define the start and end of the current financial year
    //   const financialYearStart = new Date(currentYear, 3, 1); // April 1st of the current year (Month is 0-indexed)
    //   const financialYearEnd = new Date(currentYear + 1, 2, 31); // March 31st of the next year

    //   // Parse the DOJ (Date of Joining) string into a Date object
    //   const dojDate = new Date(doj); // assuming DOJ is in the format 'YYYY-MM-DD'

    //   // Check if DOJ is within the current financial year range
    //   return dojDate >= financialYearStart && dojDate <= financialYearEnd;
    // },

    async getCurrentFiscalYear() {
      // console.log("isInCurrentFinancialYear(this.employeeDetailsPayload[0].date_of_joining)",this.employeeDetailsPayload)
      // if (this.isInCurrentFinancialYear(this.employeeDetailsPayload[0].date_of_joining)) {
      const today = new Date();
      const currentYear = new Date().getFullYear();
      if(currentYear == this.yearOfJoining && this.monthOfJoining  > 3 ){
        var fiscalStartMonth = this.monthOfJoining ;
      }
      else{
        var fiscalStartMonth = 4 ;
      }

      if (today.getMonth() + 1 < fiscalStartMonth) {
        // If the current month is before the fiscal year start month
        this.fiscalYearStart = new Date(
          today.getFullYear() - 1,
          fiscalStartMonth - 1,
          new Date().getFullYear()==this.yearOfJoining?this.joiningDate :1    
        );
        this.fiscalYearEnd = new Date(
          today.getFullYear(),
          fiscalStartMonth - 2,
          31
        );
      } else {
        // If the current month is on or after the fiscal year start month
        this.fiscalYearStart = new Date(
          today.getFullYear(),
          fiscalStartMonth - 1,
          new Date().getFullYear()==this.yearOfJoining?this.joiningDate :1
        );
        if(currentYear == this.yearOfJoining ){
             this.fiscalYearEnd = new Date(
              today.getFullYear() + 1,
              2,    
              31
            );
        }else{
          this.fiscalYearEnd = new Date(
          today.getFullYear() + 1,
          fiscalStartMonth - 2,    
          31
        );
        }
        // console.log("fiscalYearEnd",this.fiscalYearEnd)
        
      }
      this.fiscalYearEndPlus = new Date(this.fiscalYearEnd)
       this.fiscalYearEndPlus.setDate(this.fiscalYearEnd.getDate()+1)
      this.fiscalYearStart.toISOString().split("T")[0];
      this.fiscalYearEnd.toISOString().split("T")[0];

       //console.log("start", this.fiscalYearStart, "end", this.fiscalYearEndPlus);
  },

    async getItSubmissionData() {
      try {
        let res = await this.act_get_plan(this.empId);
        console.log("Checking Data",res.data.payload);
        const planList = res.data.payload.filter(
          (ele) => ele.is_plan_active == true
        );
        this.it_plan_id = planList[0].id;
        let obj = {
          employee_id: this.empId,
        };
        let response = await this.act_getProfileData(obj);
        this.employeeDetailsPayload =response.data.payload
        this.DateOfJoining = this.employeeDetailsPayload[0].date_of_joining.slice(0,10)
        this.yearOfJoining = this.DateOfJoining.slice(0,4)
        this.monthOfJoining = this.DateOfJoining.slice(5,7)
        this.joiningDate = this.DateOfJoining.slice(8,10)
        await this.getCurrentFiscalYear();
        var getProfileDataPayload = response.data.payload;
        let cientCodeName=getProfileDataPayload[0].legalEntityDetails.clientCode
        this.e_code = response.data.payload[0].code;
        this.it_financial_year = response.data.payload[0].payrollDetails.year;
        this.employeeName = response.data.payload[0].first_name+" "+(response.data.payload[0].last_name?response.data.payload[0].last_name:"");
        this.empProfileDob = response.data.payload[0].dob.slice(0,10);
        let aged = this.empProfileDob.slice(0,4);
        let now = new Date().getFullYear();
        this.now_date = now - aged;       
        const itsheetPayload = {
          employeeId: this.empId,
          le_id: this.le_id,
          financialYear:2025,
          itPlanId: this.it_plan_id,
          regimeType:this.uploadMethod
        };
        let result = await this.getAllItProofSubmissionData(itsheetPayload);
        this.backendArrayData = result
        this.enableSection10ForNewRegime = result.enablesection10fornewregime
        this.currentFinancialyear = result.DOJFlag
       this.subStartDate = result.submissionStartDate
        console.log("this.subStartDate:",this.subStartDate);      
        this.clientCodeBoolen = result.enableSection10?true:false;
        this.enableRegimeChange = result.enableRegimeChange?true:false
        this.other_tcs_table_columns_data =    result.employeeTCS 
        this.enableTCS = result.enableTCS?true:false
        // result.itProofSubmitted = false
         this.regime_type = result.regimeType == "newregime"?false:true
        this.uploadMethod = result.regimeType
        this.incomeTaxProofSubmittedFlag = result.itProofSubmitted ? false : true;
        this.finalizedSubmitFlag = result.itProofSubmitted;      
        if (!result.releaseITProof) {
          console.log("hiii", result.releaseITProof) 
          this.releaseForEmployees = true  
          this.releaseSuccess=true   
        } else if(result.releaseITProof==null) {
          console.log("hello", result.releaseITProof)
          this.releaseForEmployees = true 
          this.releaseSuccess=true   
        } else {
          // console.log("worl", result.releaseITProof)
          this.releaseForEmployees = false
          this.releaseSuccess=false 
        }
        console.log(this.releaseForEmployees, "releae")
        if (result.employeeMaster) {
        var first_Object_key_access = Object.keys(result.employeeMaster)[0];
        (this.net_taxable_income =
          result.employeeMaster[first_Object_key_access].taxableIncome),
          (this.total_tax =
            result.employeeMaster[first_Object_key_access].totalTax),
          (this.tax_to_be_paid =
            result.employeeMaster[first_Object_key_access].totalTaxProjected),
            (this.backendArrayData = result);
       } 
        
        this.employeeFamilyDetails = result.employeeFamily;

        this.options_for_6a_family_dependant =
          this.employeeFamilyDetails[0].details;
        //console.log(this.employeeFamilyDetails);
        this.employeeFamilyDetails[0].details &&
          this.employeeFamilyDetails[0].details.forEach((person) => {
            //console.log("entry", person);
            this.nameToRelationship[person.name] = person.relationship;
          });
        this.employeeFamilyDetails[0].details.length &&
          this.employeeFamilyDetails[0].details.map((item) => {
            //console.log("hiii");
            if (
              item.relationship == "Self" ||
              item.relationship == "Father" ||
              item.relationship == "Mother"
            ) {
              //console.log("here at index", item.relationship);
              let index = this.options_for_relationship.indexOf(
                item.relationship
              );
              if (index != -1) {
                this.options_for_relationship.splice(index, 1);
              }
              //console.log(index, "index");
            }
          });
        //console.log(this.options_for_relationship, "familt data");
        if (this.employeeFamilyDetails[0].details.length == 0) {
          this.addMoreRow("adding_Self");
        }
        if(result.employeeTCS&&result.employeeTCS.length == 0){
        this.addMoreRow('tcs_data')
        }
        this.subSectionInfo=result.subSectionInfo
        this.sec_ten_exemption_table_columns_data =
          result.section10.section10Others;
          let ltaIndex =  this.sec_ten_exemption_table_columns_data.filter(item => item["InvestmentComponentType.mapToItSubSection"] == "3fcb4b86-a49d-403f-aad4-53ef3d10189c")
          // console.log(ltaIndex,"lta")  
          if (ltaIndex) {
            this.ltaValue = ltaIndex.reduce((acc, obj) => { return acc + obj.actual }, 0)
      //  console.log(this.ltaValue,"sum")       
            }
          this.sec_ten_exemption_table_columns_data.map(record=>{
              if(record.status == "not_approved"){
                  record.status = "Pending"
              }
              else if(record.status == 'audit_approved' ||record.status == 'approved' ||record.status == 'Approved' ){
                 record.status = "Approved"
              }
              // else if(record.status == "rejected"){
              //   record.status= "Rejected"
              // }
              // else if(record.status == "partially_approved"){
              //   record.status ="partially_approved"
              // }
          })
          this.deduction_under_80C_table_columns_data = result.section6a["80C"];

        result.section6a["80C"].map((rec) => {
          if (rec && rec["name"] && rec["name"] === "80CCD1 - National Pension Scheme") {
            console.log("else if", rec["name"]);

            if (this.deduction_under_NPS_table_columns_data.length > 0) {
              console.log("element is present");
              let isPresent = this.deduction_under_NPS_table_columns_data.some(
                (data) => data["name"] === rec["name"]
              );
              if (!isPresent) {
                this.deduction_under_NPS_table_columns_data.push(rec);
              }
            } else {
              console.log("element is Empty");
              this.deduction_under_NPS_table_columns_data.push(rec);
            }
          } else if (
            rec &&
            rec["InvestmentComponentType"] &&
            rec["InvestmentComponentType"]["name"] === "80CCD1 - National Pension Scheme"
          ) {

            if (this.deduction_under_NPS_table_columns_data.length > 0) {
              console.log("element is present");
              let isPresent = this.deduction_under_NPS_table_columns_data.some(
                (data) =>
                  data["InvestmentComponentType"] &&
                  data["InvestmentComponentType"]["name"] ===
                    rec["InvestmentComponentType"]["name"]
              );
              if (!isPresent) {
                this.deduction_under_NPS_table_columns_data.push(rec);
              }
            } else {
              console.log("element is Empty");
              this.deduction_under_NPS_table_columns_data.push(rec);
            }
          }
        });

        // this.deduction_under_80C_table_columns_data = result.section6a["80C"];
        // console.log("qwertyuio",this.deduction_under_80C_table_columns_data)
        // result.section6a["80C"].map(rec=>{
        //   if(rec["name"] == "80CCD1 - National Pension Scheme"){
        //     console.log("else if",rec["name"])
        //     if(this.deduction_under_NPS_table_columns_data.length > 0){
        //       console.log("elememt is presnt")
        //       this.deduction_under_NPS_table_columns_data.map(data=>{
        //         if(data["name"] != rec["name"]){
        //           this.deduction_under_NPS_table_columns_data.push(rec)
        //         }
        //     })
        //     }else{
        //       console.log("elememt is Empty")
        //       this.deduction_under_NPS_table_columns_data.push(rec)
        //     }
            
            
        //    }
        //    else if(rec["InvestmentComponentType"]["name"] == "80CCD1 - National Pension Scheme"){
        //     console.log("qqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqwwwww",rec["InvestmentComponentType"]["name"])
        //     if(this.deduction_under_NPS_table_columns_data.length > 0){
        //       console.log("elememt is presnt")
        //       this.deduction_under_NPS_table_columns_data.map(data=>{
        //         if(data["InvestmentComponentType"]["name"] != rec["InvestmentComponentType"]["name"]){
        //           this.deduction_under_NPS_table_columns_data.push(rec)
        //         }
        //     })
        //     }else{
        //       console.log("elememt is Empty")
        //       this.deduction_under_NPS_table_columns_data.push(rec)
        //     }
            
            
        //    }
        
        // })
        console.log("this.deduction_under_NPS_table_columns_data",this.deduction_under_NPS_table_columns_data)
        this.deduction_under_80C_table_columns_data.map(record=>{
              if(record.status == "not_approved"){
                  record.status = "Pending"
              }  
              else if(record.status == 'audit_approved' ||record.status == 'approved' ||record.status == 'Approved' ){
                 record.status = "Approved"
              }
              // else if(record.status == "rejected"){
              //   record.remarks= ""
              // }
              // else if(record.status == "partially_approved"){
              //   record.status ="partially_approved"
              // }
          })
          // this.arr =[]
          // this.deduction_under_80C_table_columns_data.map(remove=>{
          //   if(remove.InvestmentComponentType.name== 'LIC Deduction Through Salary' ||remove.InvestmentComponentType.name== 'NPS Employer Contribution' || remove.InvestmentComponentType.name== 'NPS Employer Contribution - Previous Employer' || remove.InvestmentComponentType.name== 'Principle Repayment on Housing Loan through Salary' ||remove.InvestmentComponentType.name== 'Voluntary Provident Fund (VPF)'|| remove.InvestmentComponentType.name== 'Voluntary Provident Fund (VPF) - Previous Employer'||remove.InvestmentComponentType.name== 'Additional NPS Employee Contribution' || remove.InvestmentComponentType.name == 'Provident Fund (PF)'){
          //     let demoArray = []
          //     demoArray.push(remove)
          //   }
          //   else 
          //   this.arr.push(remove)
          // })
          // console.log("The final array", this.arr);
          
        this.deduction_under_80D_table_columns_data = result.section6a["80D"];
        this.deduction_under_80D_table_columns_data.map(record=>{
              if(record.status == "not_approved"){
                  record.status = "Pending"
              }
              else if(record.status == 'audit_approved' ||record.status == 'approved' ||record.status == 'Approved' ){
                 record.status = "Approved"
              }
              // else if(record.status == "rejected"){
              //   record.status= "Rejected"
              // }
              // else if(record.status == "partially_approved"){
              //   record.status ="partially_approved"
              // }
          })
        this.deduction_under_others_table_columns_data = result.section6a["Others"];
        this.deduction_under_others_table_columns_data.map(record=>{
              if(record.status == "not_approved"){
                  record.status = "Pending"
              }
             else if(record.status == 'audit_approved' ||record.status == 'approved' ||record.status == 'Approved' ){
                 record.status = "Approved"
              }
              // else if(record.status == "rejected"){
              //   record.status= "Rejected"
              // }
              // else if(record.status == "partially_approved"){
              //   record.status ="partially_approved"
              // }
          })
        this.deduction_under_80G_table_columns_data = result.section6a["80G"]; // 
        this.deduction_under_80G_table_columns_data&& this.deduction_under_80G_table_columns_data.map(record=>{
              if(record.status == "not_approved"){
                  record.status = "Pending"
              }
             else if(record.status == 'audit_approved' ||record.status == 'approved' ||record.status == 'Approved' ){
                 record.status = "Approved"
              }
              // else if(record.status == "rejected"){
              //   record.status= "Rejected"
              // }
              // else if(record.status == "partially_approved"){
              //   record.status ="partially_approved"
              // }
          })
        this.deduction_under_80U_table_columns_data = result.section6a["80U"];
        this.deduction_under_80U_table_columns_data.map(record=>{
              if(record.status == "not_approved"){
                  record.status = "Pending"
              }
              else if(record.status == 'audit_approved' ||record.status == 'approved' ||record.status == 'Approved' ){
                 record.status = "Approved"
              }
              // else if(record.status == "rejected"){
              //   record.status= "Rejected"
              // }
              // else if(record.status == "partially_approved"){
              //   record.status ="partially_approved"
              // }
          })
        let copydeduction_under_80DD_table_columns_data = result.section6a["80DD"];
             this.deduction_under_80DD_table_columns_data = copydeduction_under_80DD_table_columns_data && copydeduction_under_80DD_table_columns_data.filter(record => {
               return (record.InvestmentComponentType && record.InvestmentComponentType.name !== 'Medical Treatment Expenses') || record.name !== 'Medical Treatment Expenses';
             });            
        this.deduction_under_80DD_table_columns_data&& this.deduction_under_80DD_table_columns_data.map(record=>{
              if(record.status == "not_approved"){
                  record.status = "Pending"
              }
             else if(record.status == 'audit_approved' ||record.status == 'approved' ||record.status == 'Approved' ){
                 record.status = "Approved"
              }

              // else if(record.status == "rejected"){
              //   record.status= "Rejected"
              // }
              // else if(record.status == "partially_approved"){
              //   record.status ="partially_approved"
              // }
          })
        this.deduction_under_80DDB_table_columns_data = result.section6a["80DDB"];
        this.deduction_under_80DDB_table_columns_data.map(record=>{
              if(record.status == "not_approved"){
                  record.status = "Pending"
              }
              else if(record.status == 'audit_approved' ||record.status == 'approved' ||record.status == 'Approved' ){
                 record.status = "Approved"
              }
              // else if(record.status == "rejected"){
              //   record.status= "Rejected"
              // }
              // else if(record.status == "partially_approved"){
              //   record.status ="partially_approved"
              // }
          })
        this.deduction_under_80U_table_columns_data.map((record, index) => {
          record.familyDetails = {
            name: "",
            relationship: "",
            percentage: "",
            amount: "",
            isDelete: false,
          };
        });
        //console.log(this.deduction_under_80U_table_columns_data);
        this.other_income_table_columns_data = result.otherIncome;
        this.other_income_table_columns_data.map(record=>{
              if(record.status == "not_approved"){
                  record.status = "Pending"
              }
             else if(record.status == 'audit_approved' ||record.status == 'approved' ||record.status == 'Approved' ){
                 record.status = "Approved"
              }
              // else if(record.status == "rejected"){
              //   record.status= "Rejected"
              // }
              // else if(record.status == "partially_approved"){
              //   record.status ="partially_approved"
              // }
          })
        // result.previousEmployment.pop();
        this.isPrevEmployerEnabled = true;
        var previous_Employee_data =
          result.previousEmployment &&
          result.previousEmployment.map((item) => {
            let key = Object.keys(item)[0];
            let nestedObject = item[key];
            return {
              name: key,
              planned: nestedObject.planned,
              actual: nestedObject.actual,
              approved: nestedObject.approved,
              status: nestedObject.status,
              file_location: nestedObject.file_location,
              file_name:nestedObject.file_name,
            };
          });
        let prevEmpData = [];
        prevEmpData.push(previous_Employee_data);
        this.income_from_previous_employee_table_columns_data = prevEmpData;
        if (!this.income_from_previous_employee_table_columns_data.file_location) {
          this.income_from_previous_employee_table_columns_data.file_location=""
        }
         if (!this.income_from_previous_employee_table_columns_data.remarks) {
          this.income_from_previous_employee_table_columns_data.remarks=""
        }
    
        result.section24.letOutProperty[0].letOut &&
          result.section24.letOutProperty[0].letOut.forEach((item) => {
            // Check if the object's name is in the specified list and "isDisabled" is not already present
            if (
              this.namesToAddIsDisabled.includes(item.name) &&
              !item.hasOwnProperty("isDisabled")
            ) {
              // Add the "isDisabled" key with an empty string value
              item.isDisabled = true;
             
            }
          });
        this.isDateInRange(result.submissionStartDate,result.submissionEndDate)
        this.income_loss_from_house_table_columns_data_two.letout =
          result.section24.letOutProperty[0].letOut.map((item) => {
            if ("file_location" in item) {
            } else {
              item.file_location = "";
            }
            return item;
          });
        this.income_loss_from_house_table_columns_data_two.joint_property_details =
        result.section24.letOutProperty[0].joint_property_details && result.section24.letOutProperty[0].joint_property_details
        this.income_loss_from_house_table_columns_data_one = [
          result.section24.sefOccupied,
        ];
        if (
          !this.income_loss_from_house_table_columns_data_one[0].bank_details
        ) {
          this.income_loss_from_house_table_columns_data_one[0].bank_details = {
            bank_name: "",
            bank_address: "",
            bank_pancard_number: "",
            loan_sanction_date: "",
            home_occupance_date: "",
            home_address: "",
            pre_emi_interest_paid: "",
          };
        }
        if (
          this.income_loss_from_house_table_columns_data_one[0]
            .joint_property_details
        ) {
          this.income_loss_from_house_table_columns_data_three =
            this.income_loss_from_house_table_columns_data_one[0].joint_property_details;
        }
        if (
          !this.income_loss_from_house_table_columns_data_one[0].file_location
        ) {
          this.income_loss_from_house_table_columns_data_one[0].file_location =
            "";
        }
        if(
          this.income_loss_from_house_table_columns_data_two.joint_property_details
        ){
          this.income_loss_from_house_table_columns_data_letout_joint_Property =
          this.income_loss_from_house_table_columns_data_two.joint_property_details;
        }
        // this.income_loss_from_house_table_columns_data_one[0].joint_holder_name = "Total"
        let hraData = await this.getHraDAta(result.section10);
        // console.log(hraData, "self occupied");
        this.house_rent_declaration_array = JSON.parse(JSON.stringify(hraData));
      
        this.house_rent_declaration_array &&
          this.house_rent_declaration_array.details.length &&
          this.house_rent_declaration_array.details.map((item) => {
            if (item.isDelete) {
            } else {
              item.isDelete = false;
            }
           if(item.status == "not_approved" || item.status==""){
                  item.status = "Pending"
              }
             else if(item.status == 'audit_approved' ||item.status == 'approved' ||item.status == 'Approved' ){
                 item.status = "Approved"
              }
            return item;
          });
        if (!this.house_rent_declaration_array.file_location) {
          this.house_rent_declaration_array.file_location = "";
        }
        if (this.house_rent_declaration_array.details.length == 0) {
          addMoreRow("house_rent_declaration");
        }
        // this.house_rent_table_columns_data=hraData

       this.downloadForm12BB()
       
       
      } catch (err) {
        console.log("error", err);
      }
    },

     goBackFunction(headerValue) {
       this.toast = false
       this.errmsg = false 
       this.dateSuccess=false  
   
      //console.log(headerValue);
      switch (headerValue) {
        case "Deduction Under 6A":
          this.showPopupDeductionUnderCdeu = true;
          break;
        case "Other Income":
          this.showPopupOtherIncome = true;
          break;
        case "Other Tax Collected at Source(TCS)":
          this.showPopupOtherTaxTcs = true;
          break;
        case "Income From Previous Employer":
          this.showPopupIncomeFromPreviousEmployer = true;
          break;
        case "House Rent Allowance":
          this.showPopupHouseRentDeclaration=true
          break;
        case "Income/Loss from Housing Property":

          this.showPopupIncomeLossFromHousingProperty = true
          break;  
        case "deduction_under_80D":
          this.showPopupDeductionUnderCdeu = true;
          break;
          case "deduction_under_80C":
          this.showPopupDeductionUnderCdeu = true;
          break;
          case "deduction_under_80DD":
          this.showPopupDeductionUnderCdeu = true;
          break;
           case "deduction_under_80DD":
          this.showPopupDeductionUnderCdeu = true;
          break;
          case "deduction_under_80DDB":
          this.showPopupDeductionUnderCdeu = true;
          break;
          case "deduction_under_80E":
          this.showPopupDeductionUnderCdeu = true;
          break;
          case "deduction_under_80G":
          this.showPopupDeductionUnderCdeu = true;
          break;
          case "deduction_under_80T":
          this.showPopupDeductionUnderCdeu = true;
          break;
          case "deduction_under_80U":
          this.showPopupDeductionUnderCdeu = true;
          break;
           case "deduction_under_others":
          this.showPopupDeductionUnderCdeu = true;
          break;
        case "Income_loss_self_occuiped":
          this.showPopupIncomeLossFromHousingProperty = true;
          break;
        case "Income_loss_letout":
          this.showPopupIncomeLossFromHousingProperty = true;
          break;
      }
     
      (this.section_ten_attachments_pop_up = false),
        (this.house_rent_attachments_pop_up = false),
        (this.deduction_under_6A_attachments_pop_up = false),
        (this.income_loss_from_house_attachments_pop_up = false),
        (this.income_from_previous_employee_pop_up = false),
        (this.other_income_attachments_pop_up = false);
        (this.other_tcs_attachment_pop_up = false);
    },
    async fetchRecord() {
      this.it_plan_id = this.$route.query.it_plan_id;
      this.employeeId = this.$route.query.employee_id;
      let payload = {
        empId: this.employeeId,
        empLeId: this.le_id,
      };
      let employeeDetail = await this.act_fetchEmpById(payload);
      let planDetails = await this.act_fetch_plan_name(this.it_plan_id);
      this.PlanName = planDetails.data.payload.plan_name;
      this.first_name = employeeDetail.data.payload.data.first_name;
      this.last_name = employeeDetail.data.payload.data.last_name;
      this.ctc = employeeDetail.data.payload.data.EmployeeSalarySetting[0].ctc;
      this.code = employeeDetail.data.payload.data.code;
      //console.log("Employee Details", employeeDetail.data.payload.data);
      this.instance.employee_id = this.employeeId;
      let bodyParams = {};
      let data = await this.getOrgLeList({
        data: {
          ...bodyParams,
        },
      });
      this.role = data.data.user.userRole;
      if (this.role == "EMPLOYEE") {
        this.instance.financial_year = 2020;
      } else {
        this.instance.financial_year = this.payrollYear;
      }
      this.instance.it_plan_id = this.it_plan_id;
      this.instance.le_id = this.le_id;
      let res = await this.act_set_it_data(this.instance);

      if (res.status) {
        // //console.log(res);
        this.data2.exemption10 = res.data.payload.Exemption10;
        this.data2.exemption17 = res.data.payload.Exemption17;
        this.data2.deductionsUnderSection16 =
          res.data.payload.deductionsUnderSection16;
        this.data2.deductionsUnderChapterVIA =
          res.data.payload.deductionsUnderChapterVIA;
        //console.log("deductionsUnderChapterVIA---------->",this.data2.deductionsUnderChapterVIA)
        this.data2.section24 = res.data.payload.section24;
        this.data2.previousEmploymentDetails =
          res.data.payload.previousEmploymentDetails;
        this.totalAmount_previousEmpDetails =
          this.data2.previousEmploymentDetails.nps.amount +
          this.data2.previousEmploymentDetails.pf.amount +
          this.data2.previousEmploymentDetails.pt.amount +
          this.data2.previousEmploymentDetails.salary_income.amount +
          this.data2.previousEmploymentDetails.tds.amount +
          this.data2.previousEmploymentDetails.vpf.amount;
        this.data2.otherIncome = res.data.payload.otherIncome;
        this.totalAmount_otherIncome = this.data2.otherIncome.reduce(
          (total, i) => {
            total = total + i.planned;
            return total;
          },
          0
        );
        this.salaryPerk = res.data.payload.Salary;
        this.tds_breakup_and_taxable_income =
          res.data.payload.tds_breakup_and_taxable_income;
        this.itSheet = res.data.payload.itSheet;

        this.totalIncomeTax = this.itSheet[0].taxableIncome;
        this.annualTax = this.itSheet[0].totalTax;
        //console.log("TDS data show", this.tds_breakup_and_taxable_income);
        //console.log("IT sheet data ",this.itSheet);
      }
    },

    backpreviouspage() {
      this.$router.push({
        path: `/dashboard/${this.$route.params.entity_index}/payroll/incometax/incometaxdeclarationdashboard`,
        query: { id: this.employeeId },
      });
    },
    section10update(Exemption10) {
      this.showPopupExemptionUnderSectionDeduction = false;
      // //console.log("updated data ",Exemption10);
      this.data2.exemption10 = Exemption10;
    },
    section17update(Exemption17) {
      this.showPopupExemptionUnderSectionSeventeen = false;
      ////console.log("updated data Exemption17",Exemption17);
      this.data2.exemption17 = Exemption17;
    },
    previousDataUpdate(previousEmpData) {
      this.showPopupIncomeFromPreviousEmployer = false;
      ////console.log("updated data previousEmpData",previousEmpData);
      this.data2.previousEmploymentDetails = previousEmpData;
    },

    chapterVIAupdate(chapterData) {
      this.showPopupDeductionUnderCdeu = false;
      //console.log("updated data chapter VI A",chapterData);
      this.data2.deductionsUnderChapterVIA = chapterData;
    },

    otherIncomeUpdate(otherIncomeList) {
      this.showPopupOtherIncome = false;
      //console.log("updated data Other Income",otherIncomeList);
      this.data2.otherIncome = otherIncomeList;
    },
    Section24Update(Section24Update) {
      this.showPopupIncomeLossFromHousingProperty = false;
      //console.log("updated data Other Income",Section24Update);
      this.data2.section24 = Section24Update;
      this.data2.section24.self_occupied.total_planned = this.data2.section24
        .self_occupied.total_planned
        ? this.data2.section24.self_occupied.total_planned * -1
        : 0;
    },
    saveplan() {
      this.showConfirmationMsg = true;
    },

    async saveTaxRegime() {
      this.data2.plan_id = this.instance.it_plan_id;
      this.data2.employee_id = this.instance.employee_id;
      this.data2.financial_year = this.instance.financial_year;
      this.data2.le_id = this.instance.le_id;
      this.showConfirmationMsg = false;
      let res = await this.act_save_it_plan(this.data2);
      if (res.status) {
        //console.log(res);
        this.$router.push({
          path: `/dashboard/${this.$route.params.entity_index}/payroll/incometax/incometaxdeclarationdashboard`,
          query: { id: this.data2.employee_id },
        });
      } else {
        console.log("make mistake try again...........");
      }
    },

    /* function to hide the confimation pop-up */
    cancelEvent() {
      this.showConfirmationMsg = false;
    },

    //cancel() {
    //this.$router.push({
    //path: `/dashboard/${this.$route.params.entity_index}/payroll/incometax`
    //});
    // this.$router.push({
    //   path: `/dashboard/${this.$route.params.entity_index}/payroll/utilities/updateFixedNonCtcComponents`
    // });
    //},

    nothing() {
      //alert("Helloooo");
    },

    popupMessage() {
      this.exemptionSection = "Add House on Rent";
      //location.reload();
    },

    changeHeaderTitle() {
      this.exemptionSection = "Exemption Under Section 10";
      this.showPopupExemptionUnderSectionDeduction = false;
    },

    goBack() {
      // this.$router.push({
      //   path: `/dashboard/${this.$route.params.entity_index}/overview/dashboard`
      // });\
      this.dateSuccess = false;
      this.showSuccessMsg = false;
      this.releaseSuccess = false;
      this.section_ten_attachments_pop_up = false;
      this.house_rent_attachments_pop_up = false
       this.deduction_under_6A_attachments_pop_up =false
       this.income_from_previous_employee_pop_up = false
       this.income_loss_from_house_attachments_pop_up = false
       this.other_income_attachments_pop_up = false
       this.other_tcs_attachment_pop_up = false
    },

    calculate(index) {
      //console.log("fuction called")
      let item = this.income_loss_from_house_table_columns_data_two.letout;
      // if(item[2].actual>item[1].actual){
      //     this.totalRent = true;
      //   }else{
      //     this.totalRent = false;
      //   }
       if (this.income_loss_from_house_table_columns_data_two.letout[1].actual > 0) {
                //console.log("there");
                this.income_loss_from_house_table_columns_data_two.letout[2].isDisabled=false
              } else {
                this.income_loss_from_house_table_columns_data_two.letout[2].isDisabled=true
       }
      if (this.income_loss_from_house_table_columns_data_two.letout[1].actual&& this.income_loss_from_house_table_columns_data_two.letout[1].actual <= this.income_loss_from_house_table_columns_data_two.letout[2].actual) {
        this.income_loss_from_house_table_columns_data_two.letout[2].actual = 0
            window.alert('Muncipal Tax paid cannot be more than or equal to Rent Recieved')
      }     
      //console.log("fuction called",item)
      item[3].actual = item[1].actual - item[2].actual;
      item[4].actual = item[3].actual * 0.3;
      item[5].actual = item[0].actual;
      item[6].actual = item[3].actual - item[4].actual - item[5].actual;
    },

    async saveEssIT() {
      this.data2.plan_id = this.instance.it_plan_id;
      this.data2.employee_id = this.instance.employee_id;
      //this.data2.financial_year=this.instance.financial_year;
      this.data2.le_id = this.instance.le_id;
      this.instance.financial_year = 2020;
      this.data2.regime_type = "oldregime";
      let res = await this.act_save_it_plan(this.data2);
      if (res.status) {
        this.showSuccessMsg = true;
        //   this.$router.push({
        //   path: `/dashboard/${this.$route.params.entity_index}/payroll/incometax/incometaxdeclarationdashboard`,
        //   query: { id: this.data2.employee_id }
        // });
      } else {
        //console.log("make mistake try again...........");
      }
    },

    assignFamilyDetails(value,index){
      console.log(value, index, 'value inside select.....',this.income_loss_from_house_table_columns_data_letout_joint_Property,this.income_loss_from_house_table_columns_data_letout_joint_Property[index])
         this.income_loss_from_house_table_columns_data_letout_joint_Property[index].joint_holder_name = value.name;
         this.income_loss_from_house_table_columns_data_letout_joint_Property[index].relationship = value.relationship ;
         console.log(this.income_loss_from_house_table_columns_data_letout_joint_Property[index].joint_holder_name, 'joint_holder_name',
         this.income_loss_from_house_table_columns_data_letout_joint_Property[ index].relationship  
         )
    }
  },
};
</script>

<style lang="scss" scoped>
@import "@/scss/components/margins.scss"; //margins
@import "@/scss/_variables.scss";

.delete-btn {
  padding: 2px 20px;
  margin-top: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 500;
  background-color: #db2929;
  height: 40px;
  color: #fff;
  border-radius: 5px;
}
.btn-popup-cancel {
  display: block;
  border-radius: 4px;
  min-width: 150px;
  padding: 0px 10px;
  height: 35px;
  background-color: #ffffff;
  border: #5D409F solid 2px;
  color: #5D409F;
}
.section-container {
  margin-top: 20px;
  display: flex;
  gap: 20px;
  justify-content: space-between;
  flex-wrap: wrap;
}
.data_three {
  display: flex;
  width: 23%;
  flex-direction: column;
  gap: 10px;
  margin-top: 20px;
}

.table-div {
  min-height: 350px;
  // max-height: 500px;
  margin-bottom: 175px;
  overflow: auto;
}

.mask {
  width: 258.5px;
  height: 144px;
  border-radius: 8px;
  border: solid 1px #e9e9e9;
  background-color: #ffffff;
  padding: 20px 24px;
  margin: 20px 20px 20px 0px;
}

.center {
  margin: 500px;
}

.resize {
  margin-left: 100px;
}

.bold-text {
  width: 345px;
  height: 24px;
  font-family: Montserrat;
  font-size: 20px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #444444;
  margin-top: 40px;
}

.add-new {
  width: 68px;
  height: 18px;
  font-family: Montserrat;
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #37c6c0;
}

.click-on-Add-New-t {
  width: 403px;
  height: 19px;
  font-family: Montserrat;
  font-size: 16px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #444444;
  // margin-left: -30px;
  margin-top: 10px;
}

.oval {
  // background-color: #ffa000;
  width: 75px;
  height: 75px;
  border-radius: 50px;
}

.add-btn-small {
  margin-top: 30px;
  height: auto;
  padding: 10px;
  display: flex;
  justify-content: flex-end;
  align-items: center;

  .text {
    color: #858585;
    font-size: 14px;
  }
}

.employee-info {
  height: 150px;
  border-radius: 4px;
  box-shadow: 0 1px 6px 0 rgba(0, 0, 0, 0.25);
  background-color: #ffffff;
  padding: 20px 15px 20px 25px;
  position: relative;

  &:nth-child(n) {
    margin-right: 20px;
  }

  .btn-primary-small {
    background-color: white;
    color: $color-primary;
    border-radius: 4px;
    border: 1px solid $color-primary;
    height: 25px;
    padding: 0px 20px;
    font-size: $font-size-small;
    width: auto;
  }

  .header-text {
    font-size: 24px;
    font-weight: bold;
    color: $color-secondary;
  }

  .sub-text {
    font-size: 20px;
    color: $color-primary;
    margin-top: 20px;
  }

  .btn-upload {
    position: absolute;
    bottom: 20px;
    right: 15px;
  }
}

.noData {
  text-align: center;
  padding: 10% 0 10% 0;

  span {
    color: #858585;
    font-size: 18px;
  }
}

.action-container {
  margin-left: auto;
  display: flex;
  justify-content: flex-end;
}

.noData {
  text-align: center;
  padding: 10% 0 10% 0;
}

.noData span {
  font-size: 18px;
  color: #858585;
}

.lineheight {
  height: 1px;
}

.img-user {
  margin-right: 10px;
  position: absolute;
}

.month {
  position: relative;
  margin-left: 40%;
}

.employee-fullname {
  text-transform: capitalize;
  font-family: Montserrat;
  font-size: 16px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #444444;
}

.employee-code {
  font-size: 12px;
  font-weight: normal;
  color: #979797;
}

.salary-perks {
  margin-top: 30px;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #444444;
}

.salary-ctc {
  margin-top: 5px;
  font-size: 16px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #444444;
}

.close-card {
  position: absolute;
  cursor: pointer;
  color: #5d409f;
  right: 10px;
  top: 4px;
}

.document-new-block {
  margin-left: auto;
  margin-right: auto;
  margin-top: 18%;
  width: 400px;
  text-align: center;
}

.add-new-icon-document {
  display: inline-flex;
  cursor: pointer;
  margin-top: 15px;
}

.add-new {
  height: 18px;
  margin: 3px 0 3px 6px;
  font-size: 14px;
  font-weight: bold;
  color: #37c6c0;
}

#example {
  margin-top: 20px;
}

#example .col-4 {
  border: 1px solid #c9c9c9;
}

#example .col-4:not(:last-child) {
  border-right-width: 0;
}

#example .row:not(:last-child) .col-4 {
  border-bottom-width: 0;
}

#example .col-5 {
  border: 1px solid #c9c9c9;
}

#example .col-5:not(:last-child) {
  border-left-width: 0;
  border-right-width: 0;
}

// #example .row:not(:last-child) .col-5 {
//   border-bottom-width: 0;
// }

.first {
  height: 210px;
  padding: 32px;
  border-radius: 10px 0px 0px 10px;
  border: solid 1px #dddddd;
}

.middle {
  max-width: 37%;
  height: 210px;
  padding: 32px;
  // border-radius: 10px 0px 0px 10px;
  // border: solid 1px #dddddd;
}

.last {
  max-width: 37%;
  flex: 0 0 37%;
  height: 210px;
  padding: 32px;
  border-radius: 0px 10px 10px 0px;
  border: solid 1px #dddddd;
}

.view-salary-breakup {
  margin: 22px 0px 0px 0px;
  font-family: Montserrat;
  font-size: 14px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #34c0be;
  cursor: pointer;
}

.regime-title {
  font-size: 16px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #444444;
}

.badget-custom {
  width: 160px;
  height: 30px;
  padding: 5px 0px;
  border-radius: 14.5px;
  color: #5d409f;
  background-color: #ded4f3;
  text-align: center;
  font-weight: 600;
  line-height: 20px;
  display: inline-block;
  margin-right: 7px;
}

.icon-i {
  // margin: 0px 12px;
  transform: translate(0px, 7px);
}

.total-taxable-income {
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #444444;
}

.taxable-amount {
  font-size: 16px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #444444;
  // margin-right: 20px;
  text-align: right;
}

.custom-width-block-19 {
  width: 14%;
}

.custom-width-block-13 {
  width: 13%;
}

.icon-move-right {
  float: right;
  margin-right: 7px;
}

.custom-col {
  margin-right: 0px;
}

.deduction-title {
  font-size: 16px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #444444;
}

.line {
  width: 1px;
  display: inline-block;
  height: 19px;
  margin: 0px 13px 0px 10px;
  opacity: 0.16;
  border: solid 1px #30b6bc;
}

.block-deductions {
  width: 404px;
  // height: 145px;
  padding: 24px 16px 24px 16px;
  border-radius: 8px;
  border: solid 1px #efefef;
  background-color: #ffffff;
  cursor: pointer;
}

.block-deductions-title {
  margin-bottom: 8px;
}

.block-deductions-sub-title {
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #444444;
}

.deduction-img {
  text-align: right;
  transform: translate(0px, 0px);
}

.amount-deduction {
  text-align: right;
  display: block;
}

.progress-bar-blue {
  margin-top: 10px;
  width: 340px;
  border-radius: 10px;
  height: 10px;
  background-color: #dadada;
}

.progress-target {
  background-color: #34c0be;
  border-radius: 10px;
  height: 10px;
  width: 94px;
}

.progress-target-full {
  background-color: #34c0be;
  border-radius: 10px;
  height: 10px;
  width: 340px;
}

/* Modal Content */

.modal-content {
  background-color: white;
  margin: 150px auto 0px auto;
  z-index: 20;
  width: 30%;
  // height: 191px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  border-radius: 12px;
  opacity: 0;
  padding: 30px 30px 30px 30px;
  -webkit-animation-name: showPopup;
  -webkit-animation-duration: 0.3s;
  -webkit-animation-delay: 0s;
  -webkit-animation-iteration-count: 1;
  // -webkit-animation-timing-function: ease-in-out;
  -webkit-animation-fill-mode: forwards;

  .success-icon {
    // margin-bottom: 40px;
  }

  .success-text {
    font-size: $font-size-l1;
    font-weight: 600;
    // margin-bottom: auto;
    margin-left: 12px;
    color: #6e6e6e;
  }

  .message-text {
    font-size: $font-size-l1;
    margin-bottom: 20px;
    line-height: 25px;
    animation-delay: 0.7s;
    animation-name: fadeInRight;
    -webkit-animation-name: fadeInRight;
  }

  .btn-confirm-delete {
    display: flex;
    align-items: center;

    *:nth-child(n) {
      margin-right: 20px;
    }
  }

  .warning {
    margin-bottom: 16px;
    text-align: center;
    height: 24px;
    width: 24px;
  }

  .btn-popup {
    display: block;
    border-radius: 4px;
    min-width: 150px;
    padding: 0px 10px;
    height: 35px;
    background-color: $color-primary;
    color: $color-white;
  }

  .btn-popup-secondary {
    display: block;
    border-radius: 4px;
    min-width: 150px;
    padding: 0px 10px;
    height: 35px;
    background-color: #ffffff;
    border: #34c0be solid 2px;
    color: #34c0be;
  }

  .close-btn {
    position: relative;
    transform: scale(2);
    left: 230px;
    bottom: 20px;
    cursor: pointer;
  }
}

.success-img {
  position: relative;
  height: 24px;
  width: 24px;

  &.animated {
    animation-name: pulse;
    animation-iteration-count: infinite;
    animation-duration: 3s;
    -webkit-animation-name: pulse;
    -webkit-animation-iteration-count: infinite;
    -webkit-animation-duration: 3s;
  }
}

.warn-img {
  position: relative;
  height: 24px;
  width: 24px;
}

.warning {
  display: flex;
  align-items: center;
  position: relative;
  white-space: nowrap;

  &.animated {
    animation-name: shake;
    animation-iteration-count: infinite;
    animation-duration: 3s;
    -webkit-animation-name: shake;
    -webkit-animation-iteration-count: infinite;
    -webkit-animation-duration: 3s;
  }
}

.warning-text {
  font-size: $font-size-l1;
  font-weight: 600;
  margin-left: 12px;
  color: #6e6e6e;
}

.circle {
  position: relative;
  animation-name: showc;
  animation-duration: 2s;
  opacity: 0;
  left: 10px;
  height: 80px;
  width: 80px;
  -webkit-animation-name: showc;
  -webkit-animation-duration: 0.3s;
  -webkit-animation-delay: 0.4s;
  -webkit-animation-iteration-count: 1;
  -webkit-animation-timing-function: ease-in-out;
  -webkit-animation-fill-mode: forwards;
}

.tick {
  position: absolute;
  bottom: 21px;
  left: 17px;
  width: 45px;
  height: 45px;
  opacity: 0;
  -webkit-animation-name: showt;
  -webkit-animation-duration: 0.3s;
  -webkit-animation-delay: 0.7s;
  -webkit-animation-iteration-count: 1;
  -webkit-animation-timing-function: ease-in-out;
  -webkit-animation-fill-mode: forwards;
}

@keyframes showPopup {
  0% {
    opacity: 1;
    transform: scale(0.2);
  }

  80% {
    transform: scale(1.1);
    opacity: 1;
  }

  100% {
    transform: scale(1);
    opacity: 1;
  }
}

@keyframes showc {
  0% {
    opacity: 1;
    transform: scale(0.2);
  }

  80% {
    transform: scale(1.1);
    opacity: 1;
  }

  100% {
    transform: scale(1);
    opacity: 1;
  }
}

@keyframes showt {
  0% {
    opacity: 1;
    transform: scale(0.2);
  }

  80% {
    transform: scale(1.1);
    opacity: 1;
  }

  100% {
    transform: scale(1);
    opacity: 1;
  }
}

.img-msg-container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 16px;
  animation-delay: 0.4s;
  animation-name: fadeInRight;
  -webkit-animation-name: fadeInRight;
}

@keyframes fadeInRight {
  0% {
    padding-left: 25px;
    opacity: 0;
  }

  100% {
    padding-left: 0px;
    opacity: 1;
  }
}

@-webkit-keyframes fadeInRight {
  0% {
    padding-left: 25px;
    opacity: 0;
  }

  100% {
    padding-left: 0px;
    opacity: 1;
  }
}

.popup-btns {
  margin-left: auto;

  &.animated {
    animation-name: fadeIn;
    animation-delay: 1s;
    animation-duration: 0.5s;
    -webkit-animation-name: fadeInRight;
    -webkit-animation-delay: 1s;
    -webkit-animation-duration: 0.5s;
  }
}

.animated {
  animation-duration: 0.3s;
  -webkit-animation-duration: 0.3s;
}

@keyframes pulse {
  0% {
    transform: scale3d(1, 1, 1);
  }

  5% {
    transform: scale3d(1.2, 1.2, 1.2);
  }

  10% {
    transform: scale3d(1, 1, 1);
  }

  100% {
    transform: scale3d(1, 1, 1);
  }
}

@-webkit-keyframes pulse {
  0% {
    transform: scale3d(1, 1, 1);
  }

  5% {
    transform: scale3d(1.2, 1.2, 1.2);
  }

  10% {
    transform: scale3d(1, 1, 1);
  }

  100% {
    transform: scale3d(1, 1, 1);
  }
}

@keyframes shake {
  1%,
  9% {
    transform: translate3d(-1px, 0, 0);
  }

  2%,
  8% {
    transform: translate3d(2px, 0, 0);
  }

  3%,
  5%,
  7% {
    transform: translate3d(-4px, 0, 0);
  }

  4%,
  6% {
    transform: translate3d(4px, 0, 0);
  }

  10% {
    transform: translate3d(0, 0, 0);
  }

  100% {
    transform: translate3d(0, 0, 0);
  }
}

@-webkit-keyframes shake {
  1%,
  9% {
    transform: translate3d(-1px, 0, 0);
  }

  2%,
  8% {
    transform: translate3d(2px, 0, 0);
  }

  3%,
  5%,
  7% {
    transform: translate3d(-4px, 0, 0);
  }

  4%,
  6% {
    transform: translate3d(4px, 0, 0);
  }

  10% {
    transform: translate3d(0, 0, 0);
  }

  100% {
    transform: translate3d(0, 0, 0);
  }
}

.top-bar {
  height: 64px;
  // width: 100%;
  width: 453px;
  transform: translate(-30px, -30px);
  border-radius: 12px 12px 0px 0px;
  display: flex;
  box-shadow: 0 1px 18px 0 rgba(0, 0, 0, 0.12);
  background-color: #ffffff;
  padding: 24px 0 24px 32px;
}

.hraButton {
  display: flex;
  justify-content: center;
}

.heading_new {
  font-size: 22px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #5d409f;
}

.badget-custom-popup-title {
  transform: translate(140px, -24px);
  width: 160px;
  height: 30px;
  padding: 5px 0px;
  border-radius: 14.5px;
  color: #5d409f;
  background-color: #ded4f3;
  text-align: center;
  font-weight: 600;
  line-height: 20px;
  display: inline-block;
  margin-right: 7px;
}

// ESS UI part CSS
.income-tax-summary-box {
  background-color: #ebebeb;
  border: 1px solid #ebebeb;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0px 1px 2px #f0f0f0;
}

.income-tax-text {
  font-size: 1.3rem;
  font-weight: bold;
  margin-bottom: 15px;
  color: #5a5a5a;
  margin-left: 8px;
  font-family: "Montserrat";
}

.col-10-new {
  -ms-flex: 0 0 83.33334%;
  -webkit-box-flex: 0;
  flex: 0 0 83.33334%;
  max-width: 83.33334%;
}

.back-btn-color-text {
  color: #40c6bf;
  font-weight: 600;
  text-align: center;
  margin: 12px 0px 0px;
  cursor: pointer;
}

.custom-col-3 {
  background: white;
  padding: 16px;
  margin: 5px;
  flex: 0 0 22%; // 24% change to 22%
  max-width: 22%; // 24% change to 22%
  border-radius: 8px;
}

.sm-text-it-summary {
  color: #8d8d8d;
  font-size: 1rem;
  font-weight: 500;
  font-family: "Montserrat";
}

.sm-sub-text-it-summary {
  font-weight: 600;
  margin-top: 8px;
  color: #5a5a5a;
  font-family: "Montserrat";
}

.sm-sub-text-right {
  font-family: "Montserrat";
  font-size: 0.8rem;
}

// .add-btn-sm {
//   margin-top: 5px;
// }

.change-btn-color-text {
  border: #34c0bd solid 1px;
  background: #34c0bd;
  color: #ffffff;
  border-radius: 4px;
  font-weight: bold;
  min-width: 180px;
  min-height: 30px;
  text-align: center;
  padding: 10px;
  margin-top: 6px;
  cursor: pointer;
}

.change-status-btn-color-text {
  border: #c07c34 solid 1px;
  background: #fe7632ab;
  color: #ffffff;
  border-radius: 4px;
  font-weight: bold;
  min-width: 180px;
  min-height: 20px;
  text-align: center;
  padding: 6px;
  margin-top: 6px;
  cursor: pointer;
}

.col-bg-gray {
  background: #ebebeb;
  padding: 15px;
  border-radius: 8px;
}

.img-block {
  margin-top: 6px;
  height:90px;
  overflow-wrap: break-word;
  word-wrap: break-word;
  overflow: hidden;
  white-space: normal;
  margin: 0;
  padding: 0;
}

.heading-text {
  font-size: 1.125rem;
  font-weight: bold;
  color: #40c6bf;
  margin-bottom: 9px;
  font-family: "Montserrat";
}

.sub-heading-details-sm {
  color: #8d8d8d;
  line-height: 1.5rem;
  font-weight: 500;
  font-size: 1.1rem;
  font-family: "Montserrat";
}

.total-amount-text {
  font-weight: bold;
  font-size: 1rem;
  margin-top: 14px;
  color: #5a5a5a;
  font-family: "Montserrat";
}

.arrow-icon-it {
  position: relative;
  top: calc(50% - 10px);
}

.arrow-left-align {
  text-align: end;
  cursor: pointer;
}

.cursor-point {
  cursor: pointer;
  width: 48.5%;
  gap: 20px;
}

.export-button {
  background-color: rgba(14, 165, 235, 0.5);
  color: black;
  width: 12rem;
  height: 2rem;
  display: flex;
  position: relative;
  gap: 10px;

  img {
    height: 1rem;
    width: 1rem;
  }
}

// .export-button > input {
//   visibility: hidden;
//   width: 0;
// }
.input-label {
  cursor: pointer;
  display: flex;
  flex-direction: row;
  width: -webkit-fill-available !important;
  justify-content: center;
  font-size: 12px;
  color: #000000;
  margin: 0px;
}

.input-label1 {
  cursor: pointer;
  display: flex;
  flex-direction: row;
  width: -webkit-fill-available !important;

  font-size: 12px;
  color: #000000;
  margin: 0px;
}

input[type="file"] {
  position: absolute;

  z-index: -1;
  top: 15px;
  left: 20px;
  font-size: 1px;
  color: #b8b8b8;
}

.model {
  position: fixed;
  left: 0px;
  top: 0px;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 30;
  display: flex;
  flex-direction: column;
  gap: 20px;
  justify-content: center;
  align-items: center;

  span {
    color: #f3f3f3;
    font-size: xx-large;
  }
}

.loader {
  border: 16px solid #f3f3f3;
  border-radius: 50%;
  border-top: 16px solid #3b2867;
  width: 120px;
  height: 120px;
  -webkit-animation: spin 2s linear infinite;
  /* Safari */
  animation: spin 2s linear infinite;
}

/* Safari */
@-webkit-keyframes spin {
  0% {
    -webkit-transform: rotate(0deg);
  }

  100% {
    -webkit-transform: rotate(360deg);
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

span {
  font-weight: 500;
}

.hover-on-text {
  font-weight: bold;
  text-decoration: underline;
  cursor: pointer;
  color: #34c0bd;
}
.BBmain {
  display: flex;
  flex-direction: column;
  height:100%;
  width: 100%;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size:large;
  border-bottom: solid 1px grey;

}

.BBbottom {
  height:100%;
  width: 100%;
  border-top: solid 1px grey;
}
.BBcenter{
  border-top: solid 1px grey;
  width:100%;
  background-color: #f5f3f3;
  text-align:center;
}
.uploadMethoRadio {
  display: flex;
  margin-top:2%;
  margin-bottom: 2%;
  gap:5px;
}
.borderRed{
  border:solid 1px red;
}
.borderLess{
  width:14rem
}
.upload {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: linear-gradient(
      to right,
      rgb(147, 146, 146) 10px,
      rgba(255, 255, 255, 0) 0%
    ),
    linear-gradient(rgb(147, 145, 145) 10px, rgba(255, 255, 255, 0) 0%),
    linear-gradient(
      to right,
      rgb(146, 143, 143) 10px,
      rgba(255, 255, 255, 0) 0%
    ),
    linear-gradient(rgb(146, 146, 146) 10px, rgba(255, 255, 255, 0) 0%);
  background-position: top, right, bottom, left;
  background-repeat: repeat-x, repeat-y;
  background-size: 20px 1px, 1px 20px;
  height: 70%;
  width: 100%;
  p {
    font-size: large;
  }
}
.upload-button {
  display: flex;
  align-items: center;
  label {
    cursor: pointer;
    border: 3px solid #5d409f;
    border-radius: 4px;
    padding: 10px 45px;
    font-size: 15px;
    font-weight: 600;
    color: #5d409f;
    margin-top:-10px ;
  }
  #upload-photo {
    opacity: 0;
    position: absolute;
    z-index: -1
  }
  img {
    height: 19px;
    width: 19px;
    margin-right: 8px;
  }
}
</style>
